class ConfiguratorController {
    static DEBOUNCE_DELAY = 300;
    constructor() {
        const maintenanceMessage = document.querySelector('.configurator-maintenance-message');
        if (maintenanceMessage) {
            window.closeLoader();
            this.log('Both configurators are disabled, not initialising', 'warn');
            return;
        }
        this.debug_mode = false;
        this.currentStep = 1;
        this.onboardingWizard_open = true;
        this.navigating = false;
        this.options = false;
        this.materialBill = {};
        this.totalBomCost = 0;
        this.inProgressOptions = {
            'spindle': [],
            'glass': [],
            'post': [],
            'rail': [],
            'misc': [],
            'step': [],
            'string': [],
        }
        this.dimensions = {
        }
        this.treadBounds = [0,0];
        this.pendingDeleteUid = null;
        this.debounces = {};
        this.turns = [];
        this.currentTurnIndex = -1;
        this.pendingDeleteTurnIndex = null;
        this.riseInputMode = 'angle'; // 'angle' | 'total' | 'step'
        this.LoadDefaultOptions();
        this.SetUIElements()
        this.initialiseBillOfMaterials();
        this.HookEventListeners()
        this.HookModalEventListeners()
        let params = new URLSearchParams(document.location.search);
        let configurator_pre_load = params.get("configurator-pre-load");
        let configurator_load_save = params.get("configurator-load-save");
        if (configurator_pre_load) {
            if (configurator_pre_load === 'balustrade' || configurator_pre_load === 'staircase') {
                this.PreLoadConfigurator(
                    configurator_pre_load.toUpperCase(),
                    configurator_load_save
                );
            }
        }
        if (window.closeLoader) {
            window.closeLoader();
        }
        setTimeout(() => {
            this.log('Ensuring BOM is up to date after initialisation', 'info');
            if (this.StairController && this.StairController.businessLogic) {
                this.forceBillOfMaterialsUpdate();
            }
        }, 1000);
    }

    // ? ================== Debugging and logging methods's ==================
    // ?
    log(message, level = 'log') {
        if (!this.debug_mode) return;
        switch (level) {
            case 'warn':
                console.warn(message);
                break;
            case 'error':
                console.error(message);
                break;
            case 'info':
                console.info(message);
                break;
            case 'temp':
                // ! Log method use for easy find and remove after development cycles. Used for no permanent implementations.
                console.warn(message);
                break;
            case 'overlog':
                // ! Excessive logging capability. Log it All! But not all the time.
                const types = Array.prototype.slice.call(arguments, 2);
                // REVIEW: Future addition was to plan and add flags for the Over-logger to identify and narrow down specific types for overlogging.
                console.warn(message);
                break;
            default:
                console.log(message);
                break;
        }
    }

    enableDebugMode() {
        this.debug_mode = true;
        this.log('Debug mode enabled', 'info');
    }

    disableDebugMode() {
        this.debug_mode = false;
    }

    // ! ================== Initialization Method's ==================





    // ! ================== Event Listeners and callback's ==================

    HookEventListeners() {
        this.masterTypeOptions.forEach(option => {
            option.addEventListener('click', (event) => {
                this.HandleMasterControlClick(option, event);
            });
        });

        this.skipOnboardingButtons.forEach(option => {
            option.addEventListener('click', () => {
                this.CloseOnboarding()
            });
        });
        document.body.addEventListener('click', this.HandleGlobalClickEvent, false);
        if (this.onboardingWizard) {
            this.onboardingWizard.addEventListener('change', (e) => {
                if (e.target.matches('input[name="rise-input-mode-onboarding"]')) {
                    this.handleOnboardingRiseInputModeChange(e.target.value);
                }
            });
        }
        this.addBalustradeTypeToggleListeners();
        this.addTurnsEventListeners();
    }

    HandleGlobalClickEvent(event) {
        const component = event.target.closest('.stair-configurator-component-option')
        if (component) {
            window.ConfiguratorController.ProcessStepOptionSelect(component);
            const activeComponent = window.ConfiguratorController.onboardingWizard.querySelector('.stair-configurator-step__active .stair-configurator-component-option.selected');
            if (activeComponent) {
                activeComponent.classList.remove('selected');
            }
            component.classList.add('selected');
            window.ConfiguratorController.NavigateToNextStep();
        }
    }

    HandleMasterControlClick(option, event) {
        this.setConfiguratorType(option.getAttribute('data-configurator-type'));
        this.StairController = new StairCaseController(
            this.type,
            null,
            true
        );
        this.StairController.registerCallback('onCalculateBillOfMaterials', (data) => {
            this.updateBillOfMaterials(data);
        });
        this.StairController.registerCallback('treadBoundsUpdated', (minTreads, maxTreads) => {
            this.updateTreadCountValidation(minTreads, maxTreads);
        });
        if (this.type === 'STAIRCASE') {
            this.StairController.registerCallback('onStaircasePostToggle', () => {
                this.log('Staircase post toggled, triggering auto-save', 'info');
                this.debouncedAutoSave();
            });
        }
        this.ShowControls();
        this.PopulateComponentData();
        if (this.type === 'STAIRCASE') {
            this.StairController.setInput('angle', 42);
            this.StairController.setInput('length', 900);
            this.StairController.setInput('floor_height', 2000);
            this.StairController.setInput('riser_count', 13);
            document.getElementById('sc-show-background').style.display = 'none';
            this.addStaircaseControlListeners();
            this.options = {
                step: this.defaultOptions.step || this.assets.step[0],
                post: this.defaultOptions.post || []
            };
            this.inProgressOptions = {
                step: this.defaultOptions.step || this.assets.step[0],
                post: this.defaultOptions.post || []
            };
            // Ensure default post for staircase
            this.ensureDefaultPost();
            // Ensure default string material for staircase
            this.ensureDefaultString();
            // Ensure default riser for staircase
            this.ensureDefaultRiser();
            // Populate component data for staircase onboarding
            this.PopulateComponentData();
            if (this.options) {
                this.StairController.setSelectedOptions(this.options);
            }
            setTimeout(() => this.syncStaircaseControls(), 100);
            setTimeout(() => this.initializeStepComponentDisplay(), 200);
            setTimeout(() => this.initializeTreadCountBounds(), 300);
        } else if (this.type === 'BALUSTRADE') {
            this.StairController.setInput('glass_gap', 20);
            this.ensureDefaultOptions();
            if (this.options) {
                this.StairController.setSelectedOptions(this.options);
            }
        }
        this.NavigateToStep(2);
    }

    addBalustradeTypeToggleListeners() {
        const toggleInputs = document.querySelectorAll('input[name="balustrade-type"]');
        toggleInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                this.handleBalustradeTypeChange(e.target.value);
            });
        });
        
        // Add event listener for second spindle toggle
        const secondSpindleToggleInputs = document.querySelectorAll('input[name="second-spindle-toggle"]');
        secondSpindleToggleInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                this.handleSecondSpindleToggleChange(e.target.value);
            });
        });
        
        this.initializeGlassGap();
        this.ensureDefaultOptions();
    }

    addTurnsEventListeners() {
        // Add turn form submission listener
        const turnForm = document.getElementById('turn-form');
        if (turnForm) {
            turnForm.addEventListener('submit', (e) => {
                e.preventDefault();
                this.handleTurnFormSubmission();
            });
        }

        // Add modal click outside listeners
        const turnModal = document.getElementById('turn-form-modal');
        if (turnModal) {
            turnModal.addEventListener('click', (e) => {
                if (e.target === turnModal) {
                    this.closeTurnModal();
                }
            });
        }

        const removeTurnModal = document.getElementById('remove-turn-modal');
        if (removeTurnModal) {
            removeTurnModal.addEventListener('click', (e) => {
                if (e.target === removeTurnModal) {
                    this.closeRemoveTurnModal();
                }
            });
        }
    }
    addStaircaseControlListeners() {
        this.removeStaircaseControlListeners();
        const floorHeightInput = document.getElementById('sc-floor-height');
        const stairRiseInput = document.getElementById('sc-stair-rise');
        const stairWidthInput = document.getElementById('sc-stair-width');
        const treadCountInput = document.getElementById('sc-stair-tread-count');
        if (floorHeightInput) {
            floorHeightInput.addEventListener('change', (e) => {
                this.handleStaircaseControlChange('floor_height', e.target.value);
            });
        }
        if (stairRiseInput) {
            stairRiseInput.addEventListener('change', (e) => {
                this.handleStaircaseControlChange('rise_angle', e.target.value);
            });
        }
        if (stairWidthInput) {
            stairWidthInput.addEventListener('change', (e) => {
                this.handleStaircaseControlChange('stair_width', e.target.value);
            });
        }
        if (treadCountInput) {
            treadCountInput.addEventListener('change', (e) => {
                this.handleStaircaseControlChange('riser_count', e.target.value);
            });
        }

        // Rise input mode toggle (Angle / Total R&G / Step R&G)
        const riseInputModeInputs = document.querySelectorAll('input[name="rise-input-mode"]');
        riseInputModeInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                this.handleRiseInputModeChange(e.target.value);
            });
        });

        // Total rise & going
        const totalRiseInput = document.getElementById('sc-total-rise');
        const totalGoingInput = document.getElementById('sc-total-going');
        if (totalRiseInput) {
            totalRiseInput.addEventListener('change', (e) => {
                this.handleTotalRiseChange(e.target.value);
            });
        }
        if (totalGoingInput) {
            totalGoingInput.addEventListener('change', (e) => {
                this.handleTotalGoingChange(e.target.value);
            });
        }

        // Step rise & going
        const stepRiseInput = document.getElementById('sc-step-rise');
        const stepGoingInput = document.getElementById('sc-step-going');
        if (stepRiseInput) {
            stepRiseInput.addEventListener('change', (e) => {
                this.handleStepRiseChange(e.target.value);
            });
        }
        if (stepGoingInput) {
            stepGoingInput.addEventListener('change', (e) => {
                this.handleStepGoingChange(e.target.value);
            });
        }

        // Add feature step toggle listener
        const featureStepToggleInputs = document.querySelectorAll('input[name="feature-step-toggle"]');
        featureStepToggleInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                this.handleFeatureStepToggleChange(e.target.value);
            });
        });

        this.addRestartButtonListener();
    }
    removeStaircaseControlListeners() {
        const floorHeightInput = document.getElementById('sc-floor-height');
        const stairRiseInput = document.getElementById('sc-stair-rise');
        const stairWidthInput = document.getElementById('sc-stair-width');
        const treadCountInput = document.getElementById('sc-stair-tread-count');
        if (floorHeightInput) {
            const newFloorHeightInput = floorHeightInput.cloneNode(true);
            floorHeightInput.parentNode.replaceChild(newFloorHeightInput, floorHeightInput);
        }
        if (stairRiseInput) {
            const newStairRiseInput = stairRiseInput.cloneNode(true);
            stairRiseInput.parentNode.replaceChild(newStairRiseInput, stairRiseInput);
        }
        if (stairWidthInput) {
            const newStairWidthInput = stairWidthInput.cloneNode(true);
            stairWidthInput.parentNode.replaceChild(newStairWidthInput, stairWidthInput);
        }
        if (treadCountInput) {
            const newTreadCountInput = treadCountInput.cloneNode(true);
            treadCountInput.parentNode.replaceChild(newTreadCountInput, treadCountInput);
        }

        // Remove rise input mode toggle and rise/going input listeners (clone entire group)
        const riseAngleControlGroup = document.getElementById('rise-angle-control-group');
        if (riseAngleControlGroup) {
            const newGroup = riseAngleControlGroup.cloneNode(true);
            riseAngleControlGroup.parentNode.replaceChild(newGroup, riseAngleControlGroup);
        }
        
        // Remove feature step toggle listeners
        const featureStepToggleInputs = document.querySelectorAll('input[name="feature-step-toggle"]');
        featureStepToggleInputs.forEach(input => {
            const newInput = input.cloneNode(true);
            input.parentNode.replaceChild(newInput, input);
        });
        
        this.removeRestartButtonListener();
    }
    addBalustradeControlListeners() {
        if (!this.masterAngle || !this.masterLength || !this.masterAppetureHeight) {
            this.log('One or more balustrade control elements are not initialized. Re-initializing...', 'warn');
            this.initializeControlElements();
        }
        this.removeBalustradeControlListeners();
        if (this.masterAngle) {
            this.masterAngle.addEventListener('change', () => {
                this.validateAndUpdateBalustradeControl('master_angle', parseInt(this.masterAngle.value));
                this.clearCurrentConfiguration();
                this.debouncedAutoSave();
            });
        } else {
            this.log('Master angle control not available for listener attachment', 'error');
        }
        if (this.masterLength) {
            this.masterLength.addEventListener('change', () => {
                this.validateAndUpdateBalustradeControl('master_length', parseInt(this.masterLength.value));
                this.clearCurrentConfiguration();
                this.debouncedAutoSave();
            });
        } else {
            this.log('Master length control not available for listener attachment', 'error');
        }
        if (this.masterAppetureHeight) {
            this.masterAppetureHeight.addEventListener('change', () => {
                this.validateAndUpdateBalustradeControl('master_aperture_height', parseInt(this.masterAppetureHeight.value));
                this.clearCurrentConfiguration();
                this.debouncedAutoSave();
            });
        } else {
            this.log('Master aperture height control not available for listener attachment', 'error');
        }
        const glassGapInput = document.getElementById('glass-gap');
        if (glassGapInput) {
            glassGapInput.addEventListener('change', (e) => {
                this.handleGlassGapChange(e.target.value);
                this.clearCurrentConfiguration();
                this.debouncedAutoSave();
            });
        } else {
            this.log('Glass gap input not found', 'warn');
        }
        this.addRestartButtonListener();
    }
    removeBalustradeControlListeners() {
        if (this.masterAngle) {
            const newMasterAngle = this.masterAngle.cloneNode(true);
            this.masterAngle.parentNode.replaceChild(newMasterAngle, this.masterAngle);
            this.masterAngle = newMasterAngle;
        }
        if (this.masterLength) {
            const newMasterLength = this.masterLength.cloneNode(true);
            this.masterLength.parentNode.replaceChild(newMasterLength, this.masterLength);
            this.masterLength = newMasterLength;
        }
        if (this.masterAppetureHeight) {
            const newMasterAppetureHeight = this.masterAppetureHeight.cloneNode(true);
            this.masterAppetureHeight.parentNode.replaceChild(newMasterAppetureHeight, this.masterAppetureHeight);
            this.masterAppetureHeight = newMasterAppetureHeight;
        }
        const glassGapInput = document.getElementById('glass-gap');
        if (glassGapInput) {
            const newGlassGapInput = glassGapInput.cloneNode(true);
            glassGapInput.parentNode.replaceChild(newGlassGapInput, glassGapInput);
        }
        this.removeRestartButtonListener();
    }

    addRestartButtonListener() {
        const restartButton = document.getElementById('sc-restart-icon');
        if (restartButton) {
            this.removeRestartButtonListener();
            restartButton.addEventListener('click', (e) => {
                this.log('Restart button clicked!', 'info');
                e.preventDefault();
                e.stopPropagation();
                this.showRestartModal();
            });
            restartButton.style.cursor = 'pointer';
            restartButton.title = 'Click to restart (debug: button should be clickable)';
        } else {
            this.log('Restart button not found - element may not exist yet', 'warn');
        }
    }

    removeRestartButtonListener() {
        const restartButton = document.getElementById('sc-restart-icon');
        if (restartButton) {
            const newRestartButton = restartButton.cloneNode(true);
            restartButton.parentNode.replaceChild(newRestartButton, restartButton);
        }
    }

    listenForBalustradeChange() {
        this.masterAngle.addEventListener('change', () => {
            this.log('Master Angle changed:', this.masterAngle.value);
            this.validateAndUpdateBalustradeControl('master_angle', parseInt(this.masterAngle.value));
        });
        this.masterLength.addEventListener('change', () => {
            this.log('Master Length changed:', this.masterLength.value);
            this.validateAndUpdateBalustradeControl('master_length', parseInt(this.masterLength.value));
        });
        this.masterAppetureHeight.addEventListener('change', () => {
            this.validateAndUpdateBalustradeControl('master_aperture_height', parseInt(this.masterAppetureHeight.value));
        });

        // Listen for balustrade type changes to ensure BOM updates
        const balustradeTypeInputs = document.querySelectorAll('input[name="balustrade-type"]');
        balustradeTypeInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                if (e.target.checked) {
                    this.log(`Balustrade type changed to: ${e.target.value}`, 'info');
                    // BOM update will be handled by handleBalustradeTypeChange
                }
            });
        });
    }

    HookModalEventListeners() {
        const saveInput = document.getElementById('save-config-name');
        if (saveInput) {
            saveInput.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    this.confirmSaveConfiguration();
                }
            });
        }
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                const saveModal = document.getElementById('save-config-modal');
                const deleteModal = document.getElementById('delete-config-modal');
                const errorModal = document.getElementById('error-modal');
                if (saveModal && saveModal.classList.contains('show')) {
                    this.closeSaveModal();
                } else if (deleteModal && deleteModal.classList.contains('show')) {
                    this.closeDeleteModal();
                } else if (errorModal && errorModal.classList.contains('show')) {
                    this.closeErrorModal();
                }
            }
        });
        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('configurator-modal')) {
                const saveModal = document.getElementById('save-config-modal');
                const deleteModal = document.getElementById('delete-config-modal');
                const errorModal = document.getElementById('error-modal');
                const componentModal = document.getElementById('component-selection-modal');
                if (e.target === saveModal) {
                    this.closeSaveModal();
                } else if (e.target === deleteModal) {
                    this.closeDeleteModal();
                } else if (e.target === errorModal) {
                    this.closeErrorModal();
                } else if (e.target === componentModal) {
                    this.closeComponentModal();
                }
            }
        });
    }

    // ? ================== Onboarding/Step Method's ==================

    initializeStepComponentDisplay() {
        if (!this.StairController || this.type !== 'STAIRCASE') {
            return;
        }
        if (this.options && this.options.step && this.options.step[0]) {
            this.updateComponentDisplay('step', this.options.step[0]);
        }
    }

    ProcessStepOptionSelect(target) {
        const componentType = target.getAttribute('data-component-type');
        const componentHandle = target.getAttribute('data-component-handle');
        switch (componentType) {
            case 'post':
                this.inProgressOptions['post'] = [componentHandle];
                break;
            case 'spindle':
                if (this.wouldComponentLeaveNoCompatibleRails('spindle', componentHandle)) {
                    this.showNoCompatibleRailsWarning(this.getComponentGrooveSize('spindle', componentHandle));
                    return;
                }
                this.inProgressOptions['spindle'] = [componentHandle];
                this.validateRailCompatibility('spindle');
                if (this.onboardingWizard_open) {
                    this.refreshOnboardingComponentOptions();
                }
                break;
            case 'spindle-2':
                // Validate groove size compatibility with first spindle
                const validation = this.validateSecondSpindleGrooveSize(componentHandle);
                if (!validation.isValid) {
                    this.showMainConfiguratorNotification(validation.message, 'error');
                    return;
                }
                // Ensure spindle array exists and has at least one element
                if (!this.inProgressOptions['spindle'] || this.inProgressOptions['spindle'].length === 0) {
                    this.showMainConfiguratorNotification('Please select a first spindle before selecting a second spindle', 'error');
                    return;
                }
                // Set second spindle at index 1
                if (this.inProgressOptions['spindle'].length === 1) {
                    this.inProgressOptions['spindle'].push(componentHandle);
                } else {
                    this.inProgressOptions['spindle'][1] = componentHandle;
                }
                break;
            case 'glass':
                if (this.wouldComponentLeaveNoCompatibleRails('glass', componentHandle)) {
                    this.showNoCompatibleRailsWarning(this.getComponentGrooveSize('glass', componentHandle));
                    return;
                }
                this.inProgressOptions['glass'] = [componentHandle];
                this.validateRailCompatibility('glass');
                if (this.onboardingWizard_open) {
                    this.refreshOnboardingComponentOptions();
                }
                break;
            case 'rail':
                this.inProgressOptions['rail'].push(componentHandle);
                break;
            case 'step':
                this.inProgressOptions['step'] = [componentHandle];
                break;
            case 'handrail':
                this.inProgressOptions['rail'][0] = componentHandle;
                break;
            case 'baserail':
                this.inProgressOptions['rail'][1] = componentHandle;
                break;
            case 'misc':
                this.inProgressOptions['misc'].push(componentHandle);
                break;
            case 'glass-clamp':
                if (this.inProgressOptions['misc']) {
                    this.inProgressOptions['misc'] = this.inProgressOptions['misc'].filter(item => {
                        const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                        return !miscComponent || miscComponent.sub_type !== 'glass-clamp';
                    });
                    this.inProgressOptions['misc'].push(componentHandle);
                } else {
                    this.inProgressOptions['misc'] = [componentHandle];
                }
                break;
            case 'feature-step':
                if (this.inProgressOptions['misc']) {
                    this.inProgressOptions['misc'] = this.inProgressOptions['misc'].filter(item => {
                        const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                        return !miscComponent || miscComponent.sub_type !== 'feature-step';
                    });
                    this.inProgressOptions['misc'].push(componentHandle);
                } else {
                    this.inProgressOptions['misc'] = [componentHandle];
                }
                break;
            case 'string':
                this.inProgressOptions['string'] = [componentHandle];
                // Also add to misc array for StairController compatibility
                if (this.inProgressOptions['misc']) {
                    this.inProgressOptions['misc'] = this.inProgressOptions['misc'].filter(item => {
                        const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                        return !miscComponent || miscComponent.sub_type !== 'string';
                    });
                    this.inProgressOptions['misc'].push(componentHandle);
                } else {
                    this.inProgressOptions['misc'] = [componentHandle];
                }
                break;
            default:
                break;
        }
        if (!this.onboardingWizard_open) {
            this.options = this.inProgressOptions;
            this.updateComponentDisplays();
            this.clearCurrentConfiguration();
        }
    }

    NavigateToNextStep() {
        this.NavigateToStep(this.currentStep + 1)
    }

    NavigateToStep(step) {
        if (this.navigating) {
            return;
        }
        let type_bracket = `.stair-configurator-step-group__${(this.type.toLowerCase())}`;
        this.navigating = true;
        this.currentStep = step;
        const currentActiveStep = this.onboardingWizard.querySelector('.stair-configurator-step__active');
        const currentActiveStepContent = currentActiveStep.querySelector('.stair-configurator-step-contents');
        const newStep = this.onboardingWizard.querySelector(`${type_bracket} .stair-configurator-step__${step}`);
        currentActiveStep.classList.remove('stair-configurator-step__active');
        if (!newStep) {
            this.onboardingWizard_open = false;
            this.options = this.inProgressOptions;
            switch (this.type) {
                case 'BALUSTRADE':
                    this.FinaliseBalustradeLoad()
                    break;
                case 'STAIRCASE':
                    this.FinaliseStaircaseLoad()
                    break;
            }
            this.CloseOnboarding();
            this.navigating = false;
            return;
        } else {
            const newStepContent = newStep.querySelector('.stair-configurator-step-contents');
            newStep.classList.add('stair-configurator-step__active');
            if (step > 2) {
                currentActiveStep.scrollIntoView({'behavior': 'smooth', 'block':'center'})
            }
            gsap.to(currentActiveStepContent, {
                opacity: 0,
                duration: .5,
                onComplete: () => {
                    currentActiveStepContent.style.opacity = 0;
                    currentActiveStep.style.display = 'none';
                    newStepContent.style.opacity = 0;
                    newStep.style.display = 'block';
                }
            });
            gsap.to(newStepContent, {
                opacity: 1,
                delay: .5,
                duration: .5,
                onComplete: () => {
                    newStepContent.style.opacity = 1;
                    this.navigating = false;
                    this.handleOnboardingStepActions(step);
                }
            });
        }
    }

    CloseOnboarding() {
        window.openLoader()
        gsap.to(this.onboardingWizard, {
            opacity: 0,
            duration: 1.5,
            onComplete: () => {
                this.onboardingWizard.style.opacity = 0;
                this.onboardingWizard.style.display = 'none';
                this.onboardingWizard_open = false;
                this.ShowConfigurator();
                window.closeLoader()
            }
        });
    }

    refreshOnboardingRailDisplays() {
        if (!this.inProgressOptions.rail) return;
        if (this.inProgressOptions.rail[0]) {
            const handrailDisplay = document.querySelector('#stair-controller-step__handrail-type-input-options');
            if (handrailDisplay) {
                const options = handrailDisplay.querySelectorAll('.stair-configurator-component-option');
                options.forEach(option => {
                    option.classList.remove('selected');
                    if (option.getAttribute('data-component-handle') === this.inProgressOptions.rail[0]) {
                        option.classList.add('selected');
                    }
                });
            }
        }
        if (this.inProgressOptions.rail[1]) {
            const baserailDisplay = document.querySelector('#stair-controller-step__baserail-type-input-options');
            if (baserailDisplay) {
                const options = baserailDisplay.querySelectorAll('.stair-configurator-component-option');
                options.forEach(option => {
                    option.classList.remove('selected');
                    if (option.getAttribute('data-component-handle') === this.inProgressOptions.rail[1]) {
                        option.classList.add('selected');
                    }
                });
            }
        }
    }

    refreshOnboardingPostDisplay() {
        if (!this.inProgressOptions.post || this.inProgressOptions.post.length === 0) return;
        const postDisplay = document.querySelector('#stair-controller-step__post-type-input-options');
        if (postDisplay) {
            const options = postDisplay.querySelectorAll('.stair-configurator-component-option');
            options.forEach(option => {
                option.classList.remove('selected');
                if (option.getAttribute('data-component-handle') === this.inProgressOptions.post[0]) {
                    option.classList.add('selected');
                }
            });
        }
    }

    refreshOnboardingComponentOptions() {
        if (!this.onboardingWizard_open) return;
        this.PopulateComponentData();
        this.refreshOnboardingRailDisplays();
        this.refreshOnboardingPostDisplay();
        this.addGrooveSizeIndicatorToOnboarding();
    }

    handleOnboardingStepActions(step) {
        if (!this.onboardingWizard_open) return;
        switch (step) {
            case 5:
                // Refresh component options for balustrade post selection (step 5)
                if (this.type === 'BALUSTRADE') {
                    setTimeout(() => {
                        this.refreshOnboardingComponentOptions();
                    }, 100);
                }
                break;
            case 6:
                // Refresh component options for staircase post selection (step 6)
                if (this.type === 'STAIRCASE') {
                    // Use a small delay to ensure the step is fully visible before populating
                    setTimeout(() => {
                        this.refreshOnboardingComponentOptions();
                    }, 100);
                }
                break;
            case 7:
                // Refresh component options for staircase step selection (step 7)
                if (this.type === 'STAIRCASE') {
                    setTimeout(() => {
                        this.refreshOnboardingComponentOptions();
                    }, 100);
                }
                break;
            case 8:
                // Refresh component options for staircase string selection (step 8)
                if (this.type === 'STAIRCASE') {
                    setTimeout(() => {
                        this.refreshOnboardingComponentOptions();
                    }, 100);
                }
                break;
        }
    }

    addGrooveSizeIndicatorToOnboarding() {
        if (!this.onboardingWizard_open) return;
        const currentGrooveSize = this.getCurrentGrooveSize();
        if (!currentGrooveSize) return;
        const handrailStepHeader = document.querySelector('.stair-configurator-step__7 .stair-configurator-step__header-title');
        if (handrailStepHeader && !handrailStepHeader.querySelector('.groove-size-indicator')) {
            const indicator = document.createElement('span');
            indicator.className = 'groove-size-indicator compatible';
            indicator.textContent = `${currentGrooveSize}mm groove`;
            handrailStepHeader.appendChild(indicator);
        }
        const baserailStepHeader = document.querySelector('.stair-configurator-step__8 .stair-configurator-step__header-title');
        if (baserailStepHeader && !baserailStepHeader.querySelector('.groove-size-indicator')) {
            const indicator = document.createElement('span');
            indicator.className = 'groove-size-indicator compatible';
            indicator.textContent = `${currentGrooveSize}mm groove`;
            baserailStepHeader.appendChild(indicator);
        }
    }

    HandleStepInputChange(inputKey, callback = false) {
        if (inputKey === 'staircase_total_rise_going' && this.onboardingInputRiseAngle) {
            const totalRiseEl = document.getElementById('stair-controller-step__total-rise-input');
            const totalGoingEl = document.getElementById('stair-controller-step__total-going-input');
            if (totalRiseEl && totalGoingEl) {
                const angle = this.angleFromRiseAndGoing(parseFloat(totalRiseEl.value), parseFloat(totalGoingEl.value));
                if (angle != null) this.onboardingInputRiseAngle.value = this.roundAngleForDisplay(angle);
            }
        } else if (inputKey === 'staircase_step_rise_going' && this.onboardingInputRiseAngle) {
            const stepRiseEl = document.getElementById('stair-controller-step__step-rise-input');
            const stepGoingEl = document.getElementById('stair-controller-step__step-going-input');
            if (stepRiseEl && stepGoingEl) {
                const angle = this.angleFromRiseAndGoing(parseFloat(stepRiseEl.value), parseFloat(stepGoingEl.value));
                if (angle != null) this.onboardingInputRiseAngle.value = this.roundAngleForDisplay(angle);
            }
        }
        const config = window.PD_SC_CONTROLS[inputKey];
        const debounceKey = config.properties.debounceKey;
        clearTimeout(this.debounces[debounceKey]);
        const activeContinueButton = document.querySelector('.stair-configurator-step__active .stair-configurator-step__continue-button');
        activeContinueButton.disabled = true;
        this.debounces[debounceKey] = setTimeout(() => {
            this.ClearActiveMessages();
            const inputElement = this[config.properties.inputElement];
            const isRiseAngleStep = (inputKey === 'staircase_rise_angle' || inputKey === 'staircase_total_rise_going' || inputKey === 'staircase_step_rise_going');
            const stepValue = isRiseAngleStep ? parseFloat(inputElement.value) : parseInt(inputElement.value, 10);
            const validation = this.validateInput(inputKey, stepValue, true);
            if (!validation.isValid) {
                this.displayValidationMessages(validation.messages, true);
                return;
            }
            const onboardingWarnings = [...validation.messages];
            if (inputKey === 'staircase_step_rise_going') {
                const stepRiseEl = document.getElementById('stair-controller-step__step-rise-input');
                const stepGoingEl = document.getElementById('stair-controller-step__step-going-input');
                const stepRise = stepRiseEl ? parseFloat(stepRiseEl.value) : NaN;
                const stepGoing = stepGoingEl ? parseFloat(stepGoingEl.value) : NaN;
                onboardingWarnings.push(...this.getStepRiseGoingWarningMessages(stepRise, stepGoing));
            }
            if (onboardingWarnings.length > 0) {
                this.displayValidationMessages(onboardingWarnings, true);
            }
            if (callback) {
                callback();
            } else {
                if (config.callback) {
                    config.callback(inputElement.value, inputKey);
                }
            }
            this.debouncedAutoSave();
            activeContinueButton.disabled = false;
        }, ConfiguratorController.DEBOUNCE_DELAY);
    }

    HandleStepInputComplete(inputKey) {
        const config = window.PD_SC_CONTROLS[inputKey];
        let inputElement = this[config.properties.inputElement];
        // When completing rise/angle step, support total/step mode: compute angle from visible onboarding inputs and persist manual mode
        if (inputKey === 'staircase_rise_angle' && inputElement) {
            const onboardingMode = document.querySelector('input[name="rise-input-mode-onboarding"]:checked')?.value;
            this.dimensions.rise_input_mode = onboardingMode || 'angle';
            if (onboardingMode === 'total') {
                const totalRiseEl = document.getElementById('stair-controller-step__total-rise-input');
                const totalGoingEl = document.getElementById('stair-controller-step__total-going-input');
                if (totalRiseEl && totalGoingEl) {
                    const totalRise = parseFloat(totalRiseEl.value);
                    const totalGoing = parseFloat(totalGoingEl.value);
                    this.dimensions.total_rise = totalRise;
                    this.dimensions.total_going = totalGoing;
                    const angle = this.angleFromRiseAndGoing(totalRise, totalGoing);
                    if (angle != null && this.onboardingInputRiseAngle) {
                        this.onboardingInputRiseAngle.value = this.roundAngleForDisplay(angle);
                        inputElement = this.onboardingInputRiseAngle;
                    }
                }
            } else if (onboardingMode === 'step') {
                const stepRiseEl = document.getElementById('stair-controller-step__step-rise-input');
                const stepGoingEl = document.getElementById('stair-controller-step__step-going-input');
                if (stepRiseEl && stepGoingEl) {
                    const stepRise = parseFloat(stepRiseEl.value);
                    const stepGoing = parseFloat(stepGoingEl.value);
                    this.dimensions.step_rise = stepRise;
                    this.dimensions.step_going = stepGoing;
                    const angle = this.angleFromRiseAndGoing(stepRise, stepGoing);
                    if (angle != null && this.onboardingInputRiseAngle) {
                        this.onboardingInputRiseAngle.value = this.roundAngleForDisplay(angle);
                        inputElement = this.onboardingInputRiseAngle;
                    }
                }
            } else {
                delete this.dimensions.total_rise;
                delete this.dimensions.total_going;
                delete this.dimensions.step_rise;
                delete this.dimensions.step_going;
            }
        }
        const isRiseAngleInput = (inputKey === 'staircase_rise_angle' || inputKey === 'staircase_total_rise_going' || inputKey === 'staircase_step_rise_going');
        const numValue = isRiseAngleInput ? parseFloat(inputElement.value) : parseInt(inputElement.value, 10);
        const validation = this.validateInput(inputKey, numValue, true);
        const onboardingWarnings = [...validation.messages];
        if (validation.isValid && inputKey === 'staircase_step_rise_going') {
            const stepRiseEl = document.getElementById('stair-controller-step__step-rise-input');
            const stepGoingEl = document.getElementById('stair-controller-step__step-going-input');
            const stepRise = stepRiseEl ? parseFloat(stepRiseEl.value) : NaN;
            const stepGoing = stepGoingEl ? parseFloat(stepGoingEl.value) : NaN;
            onboardingWarnings.push(...this.getStepRiseGoingWarningMessages(stepRise, stepGoing));
        }
        if (validation.isValid) {
            if (onboardingWarnings.length > 0) {
                this.displayValidationMessages(onboardingWarnings, true);
            }
            this.dimensions[config.properties.dimensionKey] = inputElement.value;
            if (config.properties.preLoad) {
                if (this.type == 'STAIRCASE') {
                    this.PreLoadStaircase()
                }
            }
            this.debouncedAutoSave();
            this.NavigateToNextStep();
        } else {
            this.displayValidationMessages(onboardingWarnings, true);
        }
    }

    // ? ================== Primary UI And Core Method's ==================

    SetUIElements() {
        this.onboardingWizard = document.querySelector('.stair-configurator-onboarding-steps');
        this.rootStep = this.onboardingWizard.querySelector('#stair-configurator-root-step');
        this.masterTypeOptions =  this.rootStep.querySelectorAll('.configurator-master-type:not(.disabled)');
        this.skipOnboardingButtons =  this.onboardingWizard.querySelectorAll('.stair-configurator-step__skip-btn');
        this.onboardingInputWidth = this.onboardingWizard.querySelector('#stair-controller-step__aperture-width-input');
        this.onboardingInputHeight = this.onboardingWizard.querySelector('#stair-controller-step__aperture-height-input');
        this.onboardingInputAngle = this.onboardingWizard.querySelector('#stair-controller-step__aperture-angle-input');
        this.onboardingInputFloorHeight = this.onboardingWizard.querySelector('#stair-controller-step__floor-height-input');
        this.onboardingInputStaircaseWidth = this.onboardingWizard.querySelector('#stair-controller-step__staircase-width-input');
        this.onboardingInputRiseAngle = this.onboardingWizard.querySelector('#stair-controller-step__rise-angle-input');
        this.onboardingInputTreadCount = this.onboardingWizard.querySelector('#stair-controller-step__tread-count-input');
        this.masterAngle = document.getElementById('sc-angle');
        this.masterLength = document.getElementById('sc-length');
        this.masterAppetureHeight = document.getElementById('sc-aperture');
        this.savedConfigsSection = document.getElementById('saved-configurations-section');
        this.billOfMaterialsSection = document.querySelector('.bill-of-materials-section');

        // ? Hide sections before load cover removed as they sit outside the main view wrapper as dual purpose sections.
        if (this.savedConfigsSection) {
            this.savedConfigsSection.style.display = 'none';
        }
        if (this.billOfMaterialsSection) {
            this.billOfMaterialsSection.style.display = 'none';
        }
    }

    startNewConfiguration() {
        this.clearCurrentConfigurationAndTurns();
        this.clearHiddenConfiguration();
        this.log('Started new configuration', 'info');
        this.showMainConfiguratorNotification('Started new configuration', 'info');
    }

    PopulateComponentData() {
        const populationItems = [
            {
                target: 'stair-controller-step__post-type-input-options',
                type: 'post',
                field: 'option-post',
                description_constructor: function(component) {
                    return ``
                }
            },
            {
                target: 'stair-controller-step__spindle-type-input-options',
                type: 'spindle',
                field: 'option-spindle',
                description_constructor: false,
            },
            {
                target: 'stair-controller-step__handrail-type-input-options',
                type: 'rail',
                field: 'option-handrail',
                description_constructor: false,
                sub_type: 'handrail'
            },
            {
                target: 'stair-controller-step__baserail-type-input-options',
                type: 'rail',
                field: 'option-baserail',
                description_constructor: false,
                sub_type: 'baserail'
            },
            {
                target: 'stair-controller-step__step-type-input-options',
                type: 'step',
                field: 'option-step',
                description_constructor: false,
            },
            {
                target: 'stair-controller-step__string-type-input-options',
                type: 'string',
                field: 'option-string',
                description_constructor: false,
            }
        ];
        
        // Populate options for all items
        // For posts, step, and string, use context-aware querying to avoid ID conflicts between balustrade and staircase
        // For other components, populate all matching elements
        for (const item of populationItems) {
            if (item.type === 'post' || item.type === 'step' || item.type === 'string') {
                // For posts, step, and string, try to find in the correct step group first to avoid ID conflicts
                let contextElement = null;
                if (this.onboardingWizard && this.type) {
                    const stepGroup = this.onboardingWizard.querySelector(`.stair-configurator-step-group__${this.type.toLowerCase()}`);
                    if (stepGroup) {
                        const elementInGroup = stepGroup.querySelector(`#${item.target}`);
                        if (elementInGroup) {
                            contextElement = stepGroup;
                        }
                    }
                }
                // If not found in step group, try active step
                if (!contextElement) {
                    const activeStep = this.onboardingWizard ? this.onboardingWizard.querySelector('.stair-configurator-step__active') : null;
                    if (activeStep) {
                        const elementInStep = activeStep.querySelector(`#${item.target}`);
                        if (elementInStep) {
                            contextElement = activeStep;
                        }
                    }
                }
                // Use context-aware querying for posts, step, and string
                this.PopulateComponentOptions(item.target, item.type, item.field, item.description_constructor ?? null, item.sub_type, contextElement);
            } else {
                // For other components, populate all matching elements (no context restriction)
                // This ensures all steps get populated regardless of which step group they're in
                this.PopulateComponentOptions(item.target, item.type, item.field, item.description_constructor ?? null, item.sub_type, null);
            }
        }
        this.addGrooveSizeIndicatorToOnboarding();
        this.debouncedAutoSave();
    }

    selectComponentOption(handle, componentType) {
        // Handle special "no-cap" selection for post-caps
        if (componentType === 'post-cap' && handle === 'no-cap') {
            this.updateComponentDisplay(componentType, handle);
            this.updateComponentSelection(componentType, handle);
            this.closeComponentModal();
            this.SetSelectedAssets(true);
            return;
        }

        // Validate second spindle groove size compatibility
        if (componentType === 'spindle-2') {
            const validation = this.validateSecondSpindleGrooveSize(handle);
            if (!validation.isValid) {
                this.showMainConfiguratorNotification(validation.message, 'error');
                this.closeComponentModal();
                return;
            }
        }

        this.updateComponentDisplay(componentType, handle);
        this.updateComponentSelection(componentType, handle);
        if (componentType === 'glass') {
            this.updateGlassClampVisibility();
        }
        if (componentType === 'post' && this.type === 'BALUSTRADE') {
            this.updatePostCapVisibility();
        }
        if (componentType === 'feature-step') {
            this.updateFeatureStepVisibility();
        }
        this.closeComponentModal();
        this.SetSelectedAssets(true);
    }

    HandleMasterControlChange(inputKey, inputElement) {
        const config = window.PD_SC_CONTROLS[inputKey];
        clearTimeout(this.debounces[`${inputKey}MasterControlDebounce`]);
        this.debounces[`${inputKey}MasterControlDebounce`] = setTimeout(() => {
            const validation = this.validateInput(inputKey, parseInt(inputElement.value), false);
            if (!validation.isValid) {
                this.displayValidationMessages(validation.messages, false);
                return;
            }
            if (validation.messages.length > 0) {
                this.displayValidationMessages(validation.messages, false);
            }
            this.StairController.setInput(
                config.properties.controllerParam,
                parseInt(inputElement.value),
                config.properties.triggerRender
            );
            if (config.properties.additionalAction) {
                const additionalValue = eval(config.properties.additionalAction.calculation.replace('value', inputElement.value));
                this.StairController.setInput(
                    config.properties.additionalAction.param,
                    additionalValue,
                    config.properties.additionalAction.triggerRender
                );
            }
            this.debouncedAutoSave();
        }, ConfiguratorController.DEBOUNCE_DELAY);
    }

    updateTreadCountBoundsDisplay(inputElement, minTreads, maxTreads) {
        const existingBounds = inputElement.parentNode.querySelector('.tread-count-bounds-info');
        if (existingBounds) {
            existingBounds.remove();
        }
        if (minTreads > 0 && maxTreads > 0) {
            const boundsInfo = document.createElement('div');
            boundsInfo.className = 'tread-count-bounds-info';
            boundsInfo.style.cssText = `
                font-size: 12px;
                color: #666;
                margin-top: 4px;
                font-style: italic;
            `;
            boundsInfo.textContent = `Valid range: ${minTreads} - ${maxTreads} treads`;
            inputElement.parentNode.insertBefore(boundsInfo, inputElement.nextSibling);
        }
    }

    // ? ~~~ Control's ~~~

    initializeControlElements() {
        if (this.type === 'BALUSTRADE') {
            this.masterAngle = document.getElementById('sc-angle');
            this.masterLength = document.getElementById('sc-length');
            this.masterAppetureHeight = document.getElementById('sc-aperture');
            if (!this.masterAngle) {
                this.log('Master angle control not found', 'warn');
            }
            if (!this.masterLength) {
                this.log('Master length control not found', 'warn');
            }
            if (!this.masterAppetureHeight) {
                this.log('Master aperture height control not found', 'warn');
            }
        }
    }

    syncControlValuesAfterOnboarding() {
        if (!this.StairController) {
            this.log('No StairController available for syncing', 'warn');
            return;
        }
        if (this.type === 'BALUSTRADE') {
            this.syncBalustradeControlValuesAfterOnboarding();
        } else if (this.type === 'STAIRCASE') {
            this.syncStaircaseControlValuesAfterOnboarding();
        }
    }

    syncBalustradeControlValuesAfterOnboarding() {
        const currentAngle = this.StairController.businessLogic?.stairCaseParameters?.inputs?.angle;
        const currentLength = this.StairController.businessLogic?.stairCaseParameters?.inputs?.length;
        const currentApertureHeight = this.StairController.businessLogic?.stairCaseParameters?.inputs?.aperture_height;
        const currentGlassGap = this.StairController.businessLogic?.stairCaseParameters?.inputs?.glass_gap;
        if (this.masterAngle && currentAngle !== undefined) {
            this.masterAngle.value = currentAngle;
        }
        if (this.masterLength && currentLength !== undefined) {
            this.masterLength.value = currentLength;
        }
        if (this.masterAppetureHeight && currentApertureHeight !== undefined) {
            this.masterAppetureHeight.value = currentApertureHeight;
        }
        const glassGapInput = document.getElementById('glass-gap');
        if (glassGapInput && currentGlassGap !== undefined) {
            glassGapInput.value = currentGlassGap;
        }
        if (!this.options) {
            this.options = {};
        }
        this.options.angle = currentAngle;
        this.options.length = currentLength;
        this.options.aperture_height = currentApertureHeight;
        this.options.glass_gap = currentGlassGap;
    }

    syncStaircaseControlValuesAfterOnboarding() {
        const currentFloorHeight = this.StairController.businessLogic?.stairCaseParameters?.inputs?.floor_height;
        const currentRiseAngle = this.StairController.businessLogic?.stairCaseParameters?.inputs?.angle;
        const currentStairWidth = this.StairController.businessLogic?.stairCaseParameters?.inputs?.width;
        const currentTreadCount = this.StairController.businessLogic?.stairCaseParameters?.inputs?.riser_count;
        const floorHeightInput = document.getElementById('sc-floor-height');
        const stairRiseInput = document.getElementById('sc-stair-rise');
        const stairWidthInput = document.getElementById('sc-stair-width');
        const treadCountInput = document.getElementById('sc-stair-tread-count');
        if (floorHeightInput && currentFloorHeight !== undefined) {
            floorHeightInput.value = currentFloorHeight;
        }
        if (stairRiseInput && currentRiseAngle !== undefined) {
            stairRiseInput.value = this.roundAngleForDisplay(parseFloat(currentRiseAngle));
        }
        if (stairWidthInput && currentStairWidth !== undefined) {
            stairWidthInput.value = this.getDisplayStairWidth(currentStairWidth);
        }
        if (treadCountInput && currentTreadCount !== undefined) {
            treadCountInput.value = currentTreadCount;
        }
        if (!this.options) {
            this.options = {};
        }
        this.options.floor_height = currentFloorHeight;
        this.options.angle = currentRiseAngle;
        this.options.width = currentStairWidth;
        this.options.riser_count = currentTreadCount;
    }

    handleStaircaseControlChange(controlType, value) {
        const applied = this.validateAndUpdateStaircaseControl(controlType, value);
        if (applied) {
            this.refreshMainStaircaseValidationWarnings();
        }

        // Always clear current configuration for any staircase control change
        // This ensures configurator-load-save is cleared from URL
        this.clearCurrentConfiguration();

        this.debouncedAutoSave();

        // When floor_height or riser_count changes, keep rise/going panels in sync
        if (controlType === 'floor_height' || controlType === 'riser_count') {
            setTimeout(() => {
                const panelTotal = document.getElementById('rise-mode-total');
                const panelStep = document.getElementById('rise-mode-step');
                if (panelTotal && panelTotal.style.display !== 'none') {
                    const { totalRise, totalGoing } = this.computeTotalRiseAndGoing();
                    const totalRiseEl = document.getElementById('sc-total-rise');
                    const totalGoingEl = document.getElementById('sc-total-going');
                    if (totalRiseEl) totalRiseEl.value = totalRise;
                    if (totalGoingEl) totalGoingEl.value = totalGoing;
                }
                if (panelStep && panelStep.style.display !== 'none') {
                    const { stepRise, stepGoing } = this.computeStepRiseAndGoing();
                    const stepRiseEl = document.getElementById('sc-step-rise');
                    const stepGoingEl = document.getElementById('sc-step-going');
                    if (stepRiseEl) stepRiseEl.value = stepRise;
                    if (stepGoingEl) stepGoingEl.value = stepGoing;
                }
            }, 0);
        }

        // Update turns display when staircase controls change
        if (controlType === 'riser_count') {
            setTimeout(() => {
                this.updateTurnsDisplay();
            }, 200);
        }
    }

    syncStaircaseControls() {
        if (!this.StairController || this.type !== 'STAIRCASE') {
            return;
        }
        const floorHeightInput = document.getElementById('sc-floor-height');
        const stairRiseInput = document.getElementById('sc-stair-rise');
        const stairWidthInput = document.getElementById('sc-stair-width');
        const treadCountInput = document.getElementById('sc-stair-tread-count');
        if (floorHeightInput && this.StairController.businessLogic?.stairCaseParameters?.inputs?.floor_height) {
            floorHeightInput.value = this.StairController.businessLogic.stairCaseParameters.inputs.floor_height;
        }
        if (stairRiseInput && this.StairController.businessLogic?.stairCaseParameters?.inputs?.angle) {
            stairRiseInput.value = this.roundAngleForDisplay(parseFloat(this.StairController.businessLogic.stairCaseParameters.inputs.angle));
        }
        if (stairWidthInput && this.StairController.businessLogic?.stairCaseParameters?.inputs?.width) {
            stairWidthInput.value = this.getDisplayStairWidth(this.StairController.businessLogic.stairCaseParameters.inputs.width);
        }
        if (treadCountInput && this.StairController.businessLogic?.stairCaseParameters?.inputs?.riser_count) {
            treadCountInput.value = this.StairController.businessLogic.stairCaseParameters.inputs.riser_count;
        }
        // Keep rise/going panels in sync when controller state changes
        const panelTotal = document.getElementById('rise-mode-total');
        const panelStep = document.getElementById('rise-mode-step');
        if (panelTotal && panelTotal.style.display !== 'none') {
            const { totalRise, totalGoing } = this.computeTotalRiseAndGoing();
            const totalRiseEl = document.getElementById('sc-total-rise');
            const totalGoingEl = document.getElementById('sc-total-going');
            if (totalRiseEl) totalRiseEl.value = totalRise;
            if (totalGoingEl) totalGoingEl.value = totalGoing;
        }
        if (panelStep && panelStep.style.display !== 'none') {
            const { stepRise, stepGoing } = this.computeStepRiseAndGoing();
            const stepRiseEl = document.getElementById('sc-step-rise');
            const stepGoingEl = document.getElementById('sc-step-going');
            if (stepRiseEl) stepRiseEl.value = stepRise;
            if (stepGoingEl) stepGoingEl.value = stepGoing;
        }
    }

    ensureDefaultOptions() {
        if (!this.options) {
            this.options = { ...this.defaultOptions };
        }
        const currentType = this.getCurrentBalustradeType();
        if (currentType === 'spindle') {
            if (!this.options.spindle || this.options.spindle.length === 0) {
                const availableSpindles = Object.keys(window.PD_SC_BUILDER_ASSETS['spindle'] || {});
                if (availableSpindles.length > 0) {
                    this.options.spindle = [availableSpindles[0]];
                }
            }
        } else if (currentType === 'glass') {
            if (!this.options.glass || this.options.glass.length === 0) {
                const availableGlass = Object.keys(window.PD_SC_BUILDER_ASSETS['glass'] || {});
                if (availableGlass.length > 0) {
                    this.options.glass = [availableGlass[0]];
                }
            }
        }
        if (!this.options.post || this.options.post.length === 0) {
            const availablePosts = Object.keys(window.PD_SC_BUILDER_ASSETS['post'] || {});
            if (availablePosts.length > 0) {
                this.options.post = [availablePosts[0]];
            }
        }
        if (!this.options.rail || this.options.rail.length === 0) {
            const availableRails = Object.keys(window.PD_SC_BUILDER_ASSETS['rail'] || {});
            if (availableRails.length > 0) {
                this.options.rail = [availableRails[0], availableRails[0]];
            }
        }
        if (this.options.glass && this.options.glass.length > 0) {
            const glassComponent = window.PD_SC_BUILDER_ASSETS['glass']?.[this.options.glass[0]];
            if (glassComponent && glassComponent.dimensions2d && glassComponent.dimensions2d.embedded !== true) {
                this.ensureDefaultGlassClamp();
            }
        }
        // Ensure default string material
        this.ensureDefaultString();
        // Ensure default riser
        this.ensureDefaultRiser();
    }

    handleBalustradeTypeChange(type) {
        // Clear current configuration when changing balustrade type
        this.clearCurrentConfiguration();

        const spindleControls = document.getElementById('spindle-controls');
        const glassControls = document.getElementById('glass-controls');
        const glassGapControl = document.getElementById('glass-gap-control');
        const glassClampControl = document.getElementById('glass-clamp-control');

        this.log(`Switching balustrade type to: ${type}`, 'info');

        if (type === 'spindle') {
            spindleControls.classList.remove('hidden');
            glassControls.classList.add('hidden');
            glassGapControl.classList.add('hidden');
            glassClampControl.classList.add('hidden');
            // Show second spindle toggle control when spindle type is selected
            const spindle2ToggleControl = document.getElementById('spindle-2-toggle-control');
            if (spindle2ToggleControl) {
                spindle2ToggleControl.classList.remove('hidden');
            }
            // Show second spindle controls if toggle is enabled
            const secondSpindleToggle = document.querySelector('input[name="second-spindle-toggle"]:checked');
            if (secondSpindleToggle && secondSpindleToggle.value === 'yes') {
                const spindle2Controls = document.getElementById('spindle-2-controls');
                if (spindle2Controls) {
                    spindle2Controls.classList.remove('hidden');
                }
            }
            this.clearGlassSelection();
            this.clearGlassClampSelection();
            if (this.StairController) {
                let spindleOptions = this.options?.spindle || [];
                if (spindleOptions.length === 0) {
                    const availableSpindles = Object.keys(window.PD_SC_BUILDER_ASSETS['spindle'] || {});
                    if (availableSpindles.length > 0) {
                        spindleOptions = [availableSpindles[0]];
                        this.options = this.options || this.defaultOptions;
                        this.options.spindle = spindleOptions;
                        this.updateComponentDisplay('spindle', availableSpindles[0]);
                    }
                }
                this.ensureDefaultOptions();
                const optionsToSet = {
                    "spindle": spindleOptions,
                    "post": this.options?.post || [],
                    "rail": this.options?.rail || [],
                    "step": this.options?.step || [],
                    "misc": this.options?.misc || []
                };
                this.StairController.setSelectedOptions(optionsToSet);
                this.StairController.setInput('glass_gap', 20);
            }
        } else if (type === 'glass') {
            spindleControls.classList.add('hidden');
            glassControls.classList.remove('hidden');
            glassGapControl.classList.remove('hidden');
            // Hide second spindle toggle and controls when glass type is selected
            const spindle2ToggleControl = document.getElementById('spindle-2-toggle-control');
            if (spindle2ToggleControl) {
                spindle2ToggleControl.classList.add('hidden');
            }
            const spindle2Controls = document.getElementById('spindle-2-controls');
            if (spindle2Controls) {
                spindle2Controls.classList.add('hidden');
            }
            // Clear second spindle selection when switching to glass
            this.clearSecondSpindleSelection();
            // Reset second spindle toggle to "no"
            const secondSpindleToggleNo = document.querySelector('input[name="second-spindle-toggle"][value="no"]');
            if (secondSpindleToggleNo) {
                secondSpindleToggleNo.checked = true;
            }
            this.clearSpindleSelection();
            this.updateGlassClampVisibility();
            if (this.options?.glass_gap !== undefined) {
                const glassGapInput = document.getElementById('glass-gap');
                if (glassGapInput) {
                    glassGapInput.value = this.options.glass_gap;
                }
            }
            if (this.StairController) {
                let glassOptions = this.options?.glass || [];
                if (glassOptions.length === 0) {
                    const availableGlass = Object.keys(window.PD_SC_BUILDER_ASSETS['glass'] || {});
                    if (availableGlass.length > 0) {
                        glassOptions = [availableGlass[0]];
                        this.options = this.options || this.defaultOptions;
                        this.options.glass = glassOptions;
                        this.updateComponentDisplay('glass', availableGlass[0]);
                        this.updateGlassClampVisibility();
                    }
                }
                this.ensureDefaultOptions();
                const optionsToSet = {
                    "glass": glassOptions,
                    "post": this.options?.post || [],
                    "rail": this.options?.rail || [],
                    "step": this.options?.step || [],
                    "misc": this.options?.misc || []
                };
                this.StairController.setSelectedOptions(optionsToSet);
                if (this.options?.glass_gap !== undefined) {
                    this.StairController.setInput('glass_gap', this.options.glass_gap);
                    this.log(`Set glass gap on StairController to: ${this.options.glass_gap}`, 'debug');
                } else {
                    this.StairController.setInput('glass_gap', 20);
                    this.options = this.options || {};
                    this.options.glass_gap = 20;
                    this.log('Set default glass gap on StairController to: 20', 'debug');
                }
            }
        }

        this.validateRailCompatibility(type);

        if (this.onboardingWizard_open) {
            this.refreshOnboardingComponentOptions();
        }

        // Ensure BOM is updated after balustrade type change
        if (this.StairController) {
            this.log('Regenerating configuration after balustrade type change', 'info');
            this.StairController.generate();
            this.log('Configuration regenerated after balustrade type change', 'debug');

            // Clear current BOM and request update with proper timing
            this.clearBillOfMaterials();

            // Use a longer delay to ensure all components are properly set
            setTimeout(() => {
                this.log('Requesting BOM update after balustrade type change', 'info');
                this.requestBillOfMaterialsUpdate();
            }, 300);
        }

        this.debouncedAutoSave();
    }

    handleSecondSpindleToggleChange(value) {
        const spindle2Controls = document.getElementById('spindle-2-controls');
        if (!spindle2Controls) {
            this.log('Second spindle controls element not found', 'warn');
            return;
        }

        if (value === 'yes') {
            spindle2Controls.classList.remove('hidden');
            // If a second spindle is already selected, update its display
            const currentSecondSpindle = this.getCurrentComponentSelection('spindle-2');
            if (currentSecondSpindle) {
                this.updateComponentDisplay('spindle-2', currentSecondSpindle);
            }
        } else {
            spindle2Controls.classList.add('hidden');
            // Clear second spindle selection when toggle is disabled
            this.clearSecondSpindleSelection();
        }
        this.debouncedAutoSave();
    }

    clearSecondSpindleSelection() {
        const spindle2Display = document.getElementById('component-spindle-2-display');
        if (spindle2Display) {
            spindle2Display.innerHTML = '<div class="component-display-placeholder">Select Second Spindle</div>';
        }
        if (this.options && this.options.spindle && this.options.spindle.length > 1) {
            this.options.spindle = [this.options.spindle[0]]; // Keep only first spindle
            // Update StairController with cleared second spindle
            if (this.StairController && this.type === 'BALUSTRADE') {
                this.SetSelectedAssets(true);
            }
        }
        if (this.inProgressOptions && this.inProgressOptions.spindle && this.inProgressOptions.spindle.length > 1) {
            this.inProgressOptions.spindle = [this.inProgressOptions.spindle[0]]; // Keep only first spindle
        }
    }

    PopulateComponentOptions(target, type, select_field, description_constructor = null, sub_type = false, contextElement = null) {
        const template = document.getElementById('configurator-component-option-template');
        if (!template) {
            this.log('Component option template not found', 'warn');
            return;
        }
        // If contextElement is provided, search within it; otherwise use getElementById
        let componentOptions;
        if (contextElement) {
            componentOptions = contextElement.querySelector(`#${target}`);
            if (!componentOptions) {
                // Fallback: try querySelector with just the ID (in case it's a class or other selector)
                componentOptions = contextElement.querySelector(`.${target}`);
            }
        } else {
            componentOptions = document.getElementById(target);
        }
        if (!componentOptions) {
            this.log(`Target element '${target}' not found for component type '${type}'. Element may not exist yet or may be in a hidden step.`, 'warn');
            return;
        }
        componentOptions.innerHTML = '';
        let availableComponents = this.getAvailableComponentsForType(type, sub_type);
        this.log(`[PopulateComponentOptions] Type: ${type}, Sub-type: ${sub_type}, Available components: ${availableComponents.length}, Target: ${target}`);
        for (const component_handle of availableComponents) {
            try {
                // Handle string type which is stored in misc assets
                let component;
                if (type === 'string') {
                    component = window.PD_SC_BUILDER_ASSETS['misc']?.[component_handle];
                } else {
                    component = window.PD_SC_BUILDER_ASSETS[type]?.[component_handle];
                }
                if (!component) {
                    this.log(`Component not found: ${component_handle} for type: ${type}`, 'warn');
                    continue;
                }
                const clone = template.content.cloneNode(true);
                const productImage = clone.querySelector('.stair-configurator-component-image');
                const title = clone.querySelector('.component_option__title');
                const description = clone.querySelector('.component_option__description');
                const textureRibbon = clone.querySelector('.component_option__texture-ribbon.primary_texture');
                const secondaryTextureRibbon = clone.querySelector('.component_option__texture-ribbon.secondary_texture');
                const primaryTexture = window.PD_SC_BUILDER_TEXTURES[component.primary_texture];
                clone.querySelector('.stair-configurator-component-option').setAttribute('data-component-handle', component_handle);
                clone.querySelector('.stair-configurator-component-option').setAttribute('data-component-type', type);
                if (component.product_data && component.product_data.featured_image) {
                    productImage.style.backgroundImage = `url(${component.product_data.featured_image})`;
                }
                title.textContent = component.name;
                if (typeof description_constructor === 'function') {
                    description.textContent = description_constructor(component);
                } else {
                    description.style.display = 'none';
                }
                if (primaryTexture.source_type === 'color') {
                    textureRibbon.style.backgroundColor = primaryTexture.source;
                } else {
                    textureRibbon.style.backgroundImage = `url('${primaryTexture.source}')`;
                }
                if (component.primary_texture !== component.secondary_texture) {
                    const secondaryTexture = window.PD_SC_BUILDER_TEXTURES[component.secondary_texture];
                    if (secondaryTexture.source_type === 'color') {
                        secondaryTextureRibbon.style.backgroundColor = secondaryTexture.source;
                    } else {
                        secondaryTextureRibbon.style.backgroundImage = `url('${secondaryTexture}')`;
                    }
                } else {
                    secondaryTextureRibbon.style.display = 'none';
                    textureRibbon.classList.add('full_texture');
                }
                componentOptions.appendChild(clone);
                const selectField = document.getElementById(select_field);
                if (selectField) {
                    let option = document.createElement('option');
                    option.textContent = component.name;
                    option.value = component_handle;
                    selectField.appendChild(option);
                }
            } catch (error) {
                this.log(`There has been an error displaying ${component_handle} as an option.`, error);
            }
        }
    }

    SetSelectedAssets(generate = false) {
        // Clear current configuration when setting selected assets
        this.clearCurrentConfiguration();

        let misc_items = [];
        if (this.type === 'STAIRCASE') {
            // Get string material from component selection - use options.string first, then fallback to getCurrentComponentSelection
            if (this.options?.string && this.options.string.length > 0) {
                misc_items.push(this.options.string[0]);
            } else {
                const stringSelection = this.getCurrentComponentSelection('string');
                if (stringSelection) {
                    misc_items.push(stringSelection);
                    // Also update options.string to keep it in sync
                    if (!this.options) {
                        this.options = {};
                    }
                    if (!this.options.string) {
                        this.options.string = [];
                    }
                    this.options.string[0] = stringSelection;
                }
            }
            // Get riser from component selection - use options.riser first, then fallback to getCurrentComponentSelection
            if (this.options?.riser && this.options.riser.length > 0) {
                misc_items.push(this.options.riser[0]);
            } else {
                const riserSelection = this.getCurrentComponentSelection('riser');
                if (riserSelection) {
                    misc_items.push(riserSelection);
                    // Also update options.riser to keep it in sync
                    if (!this.options) {
                        this.options = {};
                    }
                    if (!this.options.riser) {
                        this.options.riser = [];
                    }
                    this.options.riser[0] = riserSelection;
                }
            }
            // Get feature step from component selection if toggle is enabled
            const featureStepToggle = document.querySelector('input[name="feature-step-toggle"]:checked');
            if (featureStepToggle && featureStepToggle.value === 'yes') {
                const featureStepSelection = this.getCurrentComponentSelection('feature-step');
                if (featureStepSelection) {
                    misc_items.push(featureStepSelection);
                }
            }
        } else if (this.type === 'BALUSTRADE') {
            // Get all misc items for balustrade configurator
            if (this.options?.misc) {
                misc_items = [...this.options.misc];
            }
        }
        const optionsToSet = {
            "post": this.options?.post || [],
            "rail": this.options?.rail || [],
            "step": this.options?.step || [],
            "misc": misc_items
        };

        // Ensure string material is in misc items for StairController compatibility (only for staircase)
        if (this.type === 'STAIRCASE' && this.options?.string && this.options.string.length > 0) {
            if (!optionsToSet.misc) {
                optionsToSet.misc = [];
            }
            // Ensure we don't duplicate string material
            const hasString = optionsToSet.misc.some(item => {
                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                return miscComponent && miscComponent.sub_type === 'string';
            });
            if (!hasString) {
                optionsToSet.misc.push(this.options.string[0]);
            }
        }
        // Ensure riser is in misc items for StairController compatibility (only for staircase)
        if (this.type === 'STAIRCASE' && this.options?.riser && this.options.riser.length > 0) {
            if (!optionsToSet.misc) {
                optionsToSet.misc = [];
            }
            // Ensure we don't duplicate riser
            const hasRiser = optionsToSet.misc.some(item => {
                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                return miscComponent && miscComponent.sub_type === 'riser';
            });
            if (!hasRiser) {
                optionsToSet.misc.push(this.options.riser[0]);
            }
        }
        const currentType = this.getCurrentBalustradeType();
        if (currentType === 'spindle') {
            // Pass all spindles (both first and second if second exists)
            optionsToSet["spindle"] = this.options?.spindle || [];
            // Ensure it's an array with at least one element
            if (optionsToSet["spindle"].length === 0) {
                optionsToSet["spindle"] = [];
            }
        } else if (currentType === 'glass') {
            optionsToSet["glass"] = this.options?.glass || [];
        }
        this.StairController.setSelectedOptions(optionsToSet);
        if (generate) {
            this.StairController.generate();
            // Clear current BOM and request update with proper timing
            this.clearBillOfMaterials(true);
            setTimeout(() => {
                this.log('Requesting BOM update after component selection change', 'info');
                this.requestBillOfMaterialsUpdate();
            }, 200);
        } else {
            this.clearBillOfMaterials(true);
            // Request BOM update even when not generating to ensure consistency
            setTimeout(() => {
                this.log('Requesting BOM update after component selection change (no generation)', 'info');
                this.requestBillOfMaterialsUpdate();
            }, 300);
        }
        this.debouncedAutoSave();
    }
    ShowControls() {
        let controls;
        switch (this.type) {
            case 'STAIRCASE':
                controls = document.getElementById('staircase-controls');
                if (controls) {
                    controls.style.display = 'block';
                    setTimeout(() => this.syncStaircaseControls(), 100);
                }
                break;
            case 'BALUSTRADE':
                controls = document.getElementById('balustrade-controls');
                if (controls) {
                    controls.style.display = 'block';
                }
                break;
        }
    }

    clampTreadCountToBounds(value) {
        if (this.treadBounds[0] === 0 && this.treadBounds[1] === 0) {
            return value;
        }
        if (value < this.treadBounds[0]) {
            return this.treadBounds[0];
        } else if (value > this.treadBounds[1]) {
            return this.treadBounds[1];
        }
        return value;
    }

    // * Glass Methods

    initializeGlassGap() {
        if (this.StairController && this.StairController.businessLogic) {
            const currentGap = this.StairController.businessLogic.stairCaseParameters?.inputs?.glass_gap;
            if (currentGap !== undefined) {
                const glassGapInput = document.getElementById('glass-gap');
                if (glassGapInput) {
                    glassGapInput.value = currentGap;
                }
            }
        }
        const glassGapInput = document.getElementById('glass-gap');
        if (glassGapInput && !glassGapInput.value) {
            glassGapInput.value = '20';
        }
    }

    handleGlassGapChange(gap) {
        this.validateAndUpdateGlassGap(parseInt(gap) || 20);
        this.clearCurrentConfiguration();
        this.debouncedAutoSave();
    }

    clearGlassSelection() {
        const glassDisplay = document.getElementById('component-glass-display');
        if (glassDisplay) {
            glassDisplay.innerHTML = '<div class="component-display-placeholder">Select Glass</div>';
        }
        if (this.options) {
            this.options.glass = [];
        }
    }

    clearGlassClampSelection() {
        const glassClampDisplay = document.getElementById('component-glass-clamp-display');
        if (glassClampDisplay) {
            glassClampDisplay.innerHTML = '<div class="component-display-placeholder">Select Glass Clamp</div>';
        }
        if (this.options && this.options.misc) {
            this.options.misc = this.options.misc.filter(item => {
                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                return !miscComponent || miscComponent.sub_type !== 'glass-clamp';
            });
        }
    }

    clearStringSelection() {
        const stringDisplay = document.getElementById('component-string-display');
        if (stringDisplay) {
            stringDisplay.innerHTML = '<div class="component-display-placeholder">Select String Material</div>';
        }
        if (this.options && this.options.string) {
            this.options.string = [];
        }
    }

    updateGlassClampVisibility() {
        const glassClampControl = document.getElementById('glass-clamp-control');
        if (!glassClampControl) {
            this.log('Glass clamp control not found', 'warn');
            return;
        }
        const currentGlass = this.getCurrentComponentSelection('glass');
        if (!currentGlass) {
            this.log('No glass selected, hiding glass clamp control');
            glassClampControl.classList.add('hidden');
            return;
        }
        const glassComponent = window.PD_SC_BUILDER_ASSETS['glass']?.[currentGlass];
        if (!glassComponent || !glassComponent.dimensions2d) {
            this.log(`Glass component or dimensions not found: ${currentGlass}`, 'warn');
            glassClampControl.classList.add('hidden');
            return;
        }
        const isEmbeddable = glassComponent.dimensions2d.embedded === true;
        this.log(`Glass ${currentGlass} embeddable: ${isEmbeddable}, Dimensions: ${JSON.stringify(glassComponent.dimensions2d)}`);
        if (isEmbeddable) {
            this.log('Hiding glass clamp control for embeddable glass');
            glassClampControl.classList.add('hidden');
            this.clearGlassClampSelection();
        } else {
            this.log('Showing glass clamp control for non-embeddable glass');
            glassClampControl.classList.remove('hidden');
            this.ensureDefaultGlassClamp();
        }
    }

    ensureDefaultGlassClamp() {
        if (!this.options) {
            this.options = this.defaultOptions;
        }
        if (this.options.misc) {
            const hasGlassClamp = this.options.misc.some(item => {
                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                return miscComponent && miscComponent.sub_type === 'glass-clamp';
            });
            if (hasGlassClamp) {
                this.log('Glass clamp already selected');
                return;
            }
        }
        const availableGlassClamps = Object.keys(window.PD_SC_BUILDER_ASSETS['misc'] || {}).filter(item => {
            const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
            return miscComponent && miscComponent.sub_type === 'glass-clamp';
        });
        this.log('Available glass clamps:', availableGlassClamps);
        if (availableGlassClamps.length > 0) {
            if (!this.options.misc) {
                this.options.misc = [];
            }
            this.options.misc.push(availableGlassClamps[0]);
            this.log('Added default glass clamp:', availableGlassClamps[0]);
            this.updateComponentDisplay('glass-clamp', availableGlassClamps[0]);
        } else {
            this.log('No glass clamps available', 'warn');
        }
    }

    ensureDefaultPost() {
        if (!this.options) {
            this.options = this.defaultOptions;
        }

        // Check if post is already selected
        if (this.options.post && this.options.post.length > 0) {
            this.log('Post already selected');
            return;
        }

        const availablePosts = Object.keys(window.PD_SC_BUILDER_ASSETS['post'] || {});
        this.log('Available posts:', availablePosts);

        if (availablePosts.length > 0) {
            if (!this.options.post) {
                this.options.post = [];
            }
            // Use default post from defaultOptions if available, otherwise use first available
            const defaultPost = this.defaultOptions?.post?.[0];
            const postToUse = defaultPost && availablePosts.includes(defaultPost) ? defaultPost : availablePosts[0];
            
            this.options.post.push(postToUse);
            this.log('Added default post:', postToUse);

            // Update the display
            try {
                this.updateComponentDisplay('post', postToUse);
            } catch (error) {
                this.log(`Error updating post component display: ${error.message}`, 'warn');
            }
        } else {
            this.log('No posts available', 'warn');
        }
    }

    ensureDefaultString() {
        if (!this.options) {
            this.options = this.defaultOptions;
        }

        // Check if string material is already selected
        if (this.options.string && this.options.string.length > 0) {
            this.log('String material already selected');
            return;
        }

        const availableStrings = Object.keys(window.PD_SC_BUILDER_ASSETS['misc'] || {}).filter(item => {
            const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
            return miscComponent && miscComponent.sub_type === 'string';
        });

        this.log('Available string materials:', availableStrings);

        if (availableStrings.length > 0) {
            if (!this.options.string) {
                this.options.string = [];
            }

            // Add string material to separate string property
            this.options.string.push(availableStrings[0]);
            this.log('Added default string material:', availableStrings[0]);

            // Also add to misc array for StairController compatibility
            if (!this.options.misc) {
                this.options.misc = [];
            }
            // Ensure we don't duplicate string material in misc array
            const hasStringInMisc = this.options.misc.some(item => {
                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                return miscComponent && miscComponent.sub_type === 'string';
            });
            if (!hasStringInMisc) {
                this.options.misc.push(availableStrings[0]);
                this.log('Added string material to misc array for StairController:', availableStrings[0]);
            }

            // Update the display but don't trigger component display update that might interfere with turns
            try {
                this.updateComponentDisplay('string', availableStrings[0]);
            } catch (error) {
                this.log(`Error updating string component display: ${error.message}`, 'warn');
            }

            // Ensure string is set on StairController if it exists
            if (this.StairController && this.type === 'STAIRCASE') {
                this.log('Setting string material on StairController after ensuring default', 'info');
                this.SetSelectedAssets(true);
            }
        } else {
            this.log('No string materials available', 'warn');
        }
    }

    ensureDefaultRiser() {
        if (!this.options) {
            this.options = this.defaultOptions;
        }

        // Check if riser is already selected
        if (this.options.riser && this.options.riser.length > 0) {
            this.log('Riser already selected');
            return;
        }

        const availableRisers = Object.keys(window.PD_SC_BUILDER_ASSETS['misc'] || {}).filter(item => {
            const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
            return miscComponent && miscComponent.sub_type === 'riser';
        });

        this.log('Available risers:', availableRisers);

        if (availableRisers.length > 0) {
            if (!this.options.riser) {
                this.options.riser = [];
            }

            // Add riser to separate riser property
            this.options.riser.push(availableRisers[0]);
            this.log('Added default riser:', availableRisers[0]);

            // Also add to misc array for StairController compatibility
            if (!this.options.misc) {
                this.options.misc = [];
            }
            // Ensure we don't duplicate riser in misc array
            const hasRiserInMisc = this.options.misc.some(item => {
                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                return miscComponent && miscComponent.sub_type === 'riser';
            });
            if (!hasRiserInMisc) {
                this.options.misc.push(availableRisers[0]);
                this.log('Added riser to misc array for StairController:', availableRisers[0]);
            }

            // Update the display but don't trigger component display update that might interfere with turns
            try {
                this.updateComponentDisplay('riser', availableRisers[0]);
            } catch (error) {
                this.log(`Error updating riser component display: ${error.message}`, 'warn');
            }

            // Ensure riser is set on StairController if it exists
            if (this.StairController && this.type === 'STAIRCASE') {
                this.log('Setting riser on StairController after ensuring default', 'info');
                this.SetSelectedAssets(true);
            }
        } else {
            this.log('No risers available', 'warn');
        }
    }

    // * Feature Step Methods

    handleFeatureStepToggleChange(value) {
        const featureStepControl = document.getElementById('feature-step-control');
        if (!featureStepControl) {
            this.log('Feature step control element not found', 'warn');
            return;
        }

        if (value === 'yes') {
            featureStepControl.classList.remove('hidden');
            // If a feature step is already selected, update its display
            const currentFeatureStep = this.getCurrentComponentSelection('feature-step');
            if (currentFeatureStep) {
                this.updateComponentDisplay('feature-step', currentFeatureStep);
            } else {
                // Ensure default feature step is selected
                this.ensureDefaultFeatureStep();
            }
            // Clear current configuration to update save state
            this.clearCurrentConfiguration();
            // Update StairController with the updated options (with feature step)
            if (this.StairController && this.type === 'STAIRCASE') {
                this.SetSelectedAssets(true);
            }
        } else {
            featureStepControl.classList.add('hidden');
            // Clear feature step selection when toggle is disabled
            this.clearFeatureStepSelection();
            
            // Clear current configuration to update save state
            this.clearCurrentConfiguration();
            
            // Update StairController with the updated options (without feature step)
            if (this.StairController && this.type === 'STAIRCASE') {
                this.SetSelectedAssets(true);
            }
        }
        this.debouncedAutoSave();
    }

    updateFeatureStepVisibility() {
        const featureStepControl = document.getElementById('feature-step-control');
        if (!featureStepControl) {
            this.log('Feature step control not found', 'warn');
            return;
        }
        const featureStepToggle = document.querySelector('input[name="feature-step-toggle"]:checked');
        if (featureStepToggle && featureStepToggle.value === 'yes') {
            featureStepControl.classList.remove('hidden');
            this.ensureDefaultFeatureStep();
        } else {
            featureStepControl.classList.add('hidden');
            this.clearFeatureStepSelection();
        }
    }

    clearFeatureStepSelection() {
        const featureStepDisplay = document.getElementById('sc-component-feature-step-display');
        if (featureStepDisplay) {
            featureStepDisplay.innerHTML = '<div class="component-display-placeholder">Select Feature Step</div>';
        }
        if (this.options && this.options.misc) {
            // Remove any existing feature-steps from misc array
            this.options.misc = this.options.misc.filter(item => {
                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                return !miscComponent || miscComponent.sub_type !== 'feature-step';
            });
        }
    }

    ensureDefaultFeatureStep() {
        if (!this.options) {
            this.options = this.defaultOptions;
        }
        if (this.options.misc) {
            const hasFeatureStep = this.options.misc.some(item => {
                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                return miscComponent && miscComponent.sub_type === 'feature-step';
            });
            if (hasFeatureStep) {
                this.log('Feature step already selected');
                return;
            }
        }
        const availableFeatureSteps = Object.keys(window.PD_SC_BUILDER_ASSETS['misc'] || {}).filter(item => {
            const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
            return miscComponent && miscComponent.sub_type === 'feature-step';
        });
        this.log('Available feature steps:', availableFeatureSteps);
        if (availableFeatureSteps.length > 0) {
            if (!this.options.misc) {
                this.options.misc = [];
            }
            this.options.misc.push(availableFeatureSteps[0]);
            this.log('Added default feature step:', availableFeatureSteps[0]);
            this.updateComponentDisplay('feature-step', availableFeatureSteps[0]);
        } else {
            this.log('No feature steps available', 'warn');
        }
    }

    syncGlassGap() {
        if (this.type !== 'BALUSTRADE') {
            this.log('Glass gap sync only applicable for balustrade configurations', 'warn');
            return;
        }
        const glassGapInput = document.getElementById('glass-gap');
        if (!glassGapInput) {
            this.log('Glass gap input not found', 'warn');
            return;
        }
        const currentValue = parseInt(glassGapInput.value) || 20;
        this.log(`Syncing glass gap: UI value = ${currentValue}`, 'debug');
        if (!this.options) {
            this.options = {};
        }
        this.options.glass_gap = currentValue;
        if (this.StairController) {
            this.StairController.setInput('glass_gap', currentValue, false);
            this.log(`Glass gap set on StairController: ${currentValue}`, 'debug');
            this.StairController.generate();
            this.log('Configuration regenerated after glass gap sync', 'debug');
            setTimeout(() => {
                this.requestBillOfMaterialsUpdate();
            }, 100);
        }
    }

    // * Post Cap Methods

    getCurrentPostWidth() {
        const currentPost = this.getCurrentComponentSelection('post');
        if (!currentPost) {
            return null;
        }
        const postComponent = window.PD_SC_BUILDER_ASSETS['post']?.[currentPost];
        if (!postComponent || !postComponent.dimensions2d) {
            return null;
        }
        return postComponent.dimensions2d.width || null;
    }

    isPostCapCompatibleWithPost(postCapComponent, postWidth) {
        // If post-cap doesn't have dimensions2d.post_width set, it's compatible with any post
        if (!postCapComponent.dimensions2d || !postCapComponent.dimensions2d.post_width) {
            return true;
        }
        // If post-cap has post_width set, it must match the current post width
        return postCapComponent.dimensions2d.post_width === postWidth;
    }

    updatePostCapVisibility() {
        const postCapControl = document.getElementById('post-cap-control');
        if (!postCapControl) {
            this.log('Post cap control not found', 'warn');
            return;
        }
        const currentPost = this.getCurrentComponentSelection('post');
        if (!currentPost) {
            this.log('No post selected, hiding post cap control');
            postCapControl.classList.add('hidden');
            return;
        }
        const postComponent = window.PD_SC_BUILDER_ASSETS['post']?.[currentPost];
        if (!postComponent || !postComponent.supports_caps) {
            this.log(`Post component or supports_caps not found: ${currentPost}`, 'warn');
            postCapControl.classList.add('hidden');
            this.clearPostCapSelection();
            return;
        }
        const supportsCaps = postComponent.supports_caps === true;
        this.log(`Post ${currentPost} supports caps: ${supportsCaps}`);
        if (supportsCaps) {
            this.log('Showing post cap control for post that supports caps');
            postCapControl.classList.remove('hidden');

            // Check if current post cap selection is still compatible with the new post
            const currentPostCap = this.getCurrentComponentSelection('post-cap');
            if (currentPostCap && currentPostCap !== 'no-cap') {
                const postCapComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[currentPostCap];
                const currentPostWidth = this.getCurrentPostWidth();
                if (postCapComponent && !this.isPostCapCompatibleWithPost(postCapComponent, currentPostWidth)) {
                    this.log(`Current post cap ${currentPostCap} is not compatible with post width ${currentPostWidth}, clearing selection`);
                    this.clearPostCapSelection();
                }
            }
        } else {
            this.log('Hiding post cap control for post that does not support caps');
            postCapControl.classList.add('hidden');
            this.clearPostCapSelection();
        }
    }


    clearPostCapSelection() {
        const postCapDisplay = document.getElementById('component-post-cap-display');
        if (postCapDisplay) {
            postCapDisplay.innerHTML = '<div class="component-display-placeholder">Select Post Cap</div>';
        }
        if (this.options && this.options.misc) {
            // Remove any existing post-caps from misc array
            this.options.misc = this.options.misc.filter(item => {
                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                return !miscComponent || miscComponent.sub_type !== 'post-cap';
            });
        }
    }

    updatePostPlacementNotice(show) {
        if (this.type !== 'STAIRCASE') {
            return;
        }
        const postDisplay = document.getElementById('sc-component-post-display');
        if (!postDisplay) {
            return;
        }
        const controlField = postDisplay.closest('.control-field');
        if (!controlField) {
            return;
        }
        // Remove existing notice if any
        const existingNotice = controlField.querySelector('.post-placement-notice');
        if (existingNotice) {
            existingNotice.remove();
        }
        // Add notice if we should show it
        if (show) {
            const notice = document.createElement('div');
            notice.className = 'post-placement-notice';
            notice.style.cssText = `
                margin-top: 8px;
                padding: 10px 12px;
                background-color: #e3f2fd;
                border: 1px solid #90caf9;
                border-radius: 4px;
                color: #1565c0;
                font-size: 13px;
                font-style: italic;
            `;
            notice.textContent = 'Click staircase to place desired posts';
            controlField.appendChild(notice);
            this.log('Post placement notice displayed', 'info');
        }
    }

    // * Spindle Methods

    clearSpindleSelection() {
        const spindleDisplay = document.getElementById('component-spindle-display');
        if (spindleDisplay) {
            spindleDisplay.innerHTML = '<div class="component-display-placeholder">Select Spindle</div>';
        }
        if (this.options) {
            this.options.spindle = [];
        }
    }

    showCurrentGrooveSizeInfo() {
        const currentGrooveSize = this.getCurrentGrooveSize();
        if (!currentGrooveSize) return;
        const message = `Currently showing only rails compatible with ${currentGrooveSize}mm groove size.`;
        if (this.onboardingWizard_open) {
            this.AddWarningMessage(message, true);
        } else {
            this.showMainConfiguratorNotification(message, 'info');
        }
    }

    // * ~~~ Bill Of materials

    forceBillOfMaterialsUpdate() {
        this.log('Force BOM update requested', 'info');

        // Clear current BOM first
        this.clearBillOfMaterials(true);

        if (!this.StairController) {
            this.log('No StairController available for forced BOM update', 'warn');
            return;
        }

        // Ensure configuration is generated before calculating BOM
        if (this.StairController.generate && typeof this.StairController.generate === 'function') {
            try {
                this.StairController.generate();
                this.log('Configuration generated for forced BOM update', 'info');
            } catch (error) {
                this.log(`Error generating configuration for forced BOM update: ${error.message}`, 'warn');
            }
        }

        // Request BOM update with retry logic
        setTimeout(() => {
            this.log('Executing forced BOM update', 'info');
            this.requestBillOfMaterialsUpdate();
        }, 400);
    }

    clearBillOfMaterials(preserveTurns = false) {
        const bomContent = document.getElementById('bill-of-materials-content');
        if (!bomContent) return;
        bomContent.innerHTML = '<div class="bom-loading">Calculating materials...</div>';
        this.materialBill = {}; // Clear the material bill
        this.totalBomCost = 0; // Reset the total BOM cost
        this.canOrder = undefined; // Reset the order status
        // Clear turns if not preserving them
        this.clearTurnsIfNotPreserved(preserveTurns);
    }

    clearBillOfMaterialsAndTurns() {
        const bomContent = document.getElementById('bill-of-materials-content');
        if (!bomContent) return;
        bomContent.innerHTML = '<div class="bom-loading">Calculating materials...</div>';
        this.materialBill = {}; // Clear the material bill
        this.totalBomCost = 0; // Reset the total BOM cost
        this.canOrder = undefined; // Reset the order status
        // Clear turns when clearing bill of materials
        this.clearTurns();
    }

    clearTurns() {
        if (this.type === 'STAIRCASE' && this.turns && this.turns.length > 0) {
            this.log('Clearing turns', 'info');
            this.log(`Stack trace for clearTurns:`, 'debug');
            console.trace();

            // Clear current configuration when clearing turns
            this.clearCurrentConfiguration();

            this.setTurns([], false);

            // Trigger auto-save after clearing turns
            this.debouncedAutoSave();
        }
    }

    clearTurnsIfNotPreserved(preserveTurns = false) {
        if (!preserveTurns) {
            this.clearTurns();
        }
    }

    initialiseBillOfMaterials() {
        this.log('Initialising bill of materials', 'info');
        this.clearBillOfMaterials();
        if (this.StairController) {
            // Use a longer delay to ensure all components are properly initialised
            setTimeout(() => {
                this.log('Requesting initial BOM update', 'info');
                this.requestBillOfMaterialsUpdate();
            }, 800);
        } else {
            this.log('StairController not available during BOM initialisation', 'warn');
        }
    }

    requestBillOfMaterialsUpdate() {
        this.log('requestBillOfMaterialsUpdate called', 'info');
        if (!this.StairController) {
            this.log('No StairController available for bill of materials update', 'warn');
            return;
        }

        if (!this.StairController.businessLogic) {
            this.log('StairController businessLogic not available', 'warn');
            return;
        }

        if (typeof this.StairController.businessLogic.calculateBillOfMaterials === 'function') {
            this.log('Calling calculateBillOfMaterials on businessLogic', 'info');
            try {
                this.StairController.businessLogic.calculateBillOfMaterials();
                this.log('Bill of materials calculation requested successfully', 'info');
            } catch (error) {
                this.log(`Error calling calculateBillOfMaterials: ${error.message}`, 'error');
                // Retry after a short delay if there was an error
                setTimeout(() => {
                    this.log('Retrying BOM calculation after error', 'info');
                    this.requestBillOfMaterialsUpdate();
                }, 200);
            }
        } else {
            this.log('businessLogic.calculateBillOfMaterials method not found', 'warn');
            // Try to regenerate the configuration and retry BOM calculation
            if (this.StairController.generate && typeof this.StairController.generate === 'function') {
                this.log('Attempting to regenerate configuration and retry BOM calculation', 'info');
                this.StairController.generate();
                setTimeout(() => {
                    this.requestBillOfMaterialsUpdate();
                }, 300);
            }
        }
    }

    updateBillOfMaterials(bomData) {
        this.log('updateBillOfMaterials called with data:', 'info');
        this.log(bomData, 'info');

        // Calculate costs for each item and store the complete BOM
        const completeBOM = {};
        let grandTotal = 0;
        let hasErrors = false;
        let errorItems = [];

        Object.keys(bomData).forEach(key => {
            const item = bomData[key];
            const component = this.StairController.getComponent(item.componentKey, item.type);
            const itemWithCost = this.calculateCost(item, component);
            if (itemWithCost) {
                if (component.asset.product_data?.available) {
                    itemWithCost['product_url'] = `/products/${component.asset.product_data.handle}`;
                } else {
                    itemWithCost['product_url'] = false;
                }
            }

            if(!itemWithCost) {
                this.log('No cost found for item', item, 'warn');
                hasErrors = true;
                errorItems.push({
                    name: item.componentKey,
                    type: item.type,
                    reason: 'Unable to calculate cost - Product Unavailable'
                });
            } else {
                completeBOM[key] = itemWithCost;
                grandTotal += itemWithCost.totalPrice;
            }
        });

        // Set canOrder based on whether all costs were calculated successfully
        this.canOrder = !hasErrors;

        // Store the complete bill of materials
        this.materialBill = completeBOM;
        this.totalBomCost = grandTotal; // Set the total BOM cost

        const bomContent = document.getElementById('bill-of-materials-content');
        if (!bomContent) {
            this.log('Bill of materials content element not found', 'warn');
            return;
        }
        // Check if there are any errors or if no BOM data
        if (hasErrors) {
            // Show error message when costs cannot be calculated
            let errorHtml = '<div class="bom-error">';
            errorHtml += '<div class="bom-error-header">Pricing Error</div>';
            errorHtml += '<div class="bom-error-message">Unable to calculate costs for some components:</div>';
            errorHtml += '<div class="bom-error-list">';
            errorItems.forEach(error => {
                const componentName = error.name.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                errorHtml += `<div class="bom-error-item">• ${componentName} (${error.type}) - ${error.reason}</div>`;
            });
            errorHtml += '</div>';
            errorHtml += '<div class="bom-error-note">Please check your configuration and try again.</div>';
            errorHtml += '</div>';
            bomContent.innerHTML = errorHtml;
            this.log('BOM display updated with error message due to cost calculation failures', 'warn');
            return;
        }

        if (!bomData || Object.keys(bomData).length === 0) {
            this.log('No bill of materials data provided', 'info');
            bomContent.innerHTML = '<div class="bom-empty">No materials data available</div>';
            return;
        }

        if (Object.keys(completeBOM).length === 0) {
            this.log('No items with valid costs found', 'warn');
            bomContent.innerHTML = '<div class="bom-empty">No valid materials found</div>';
            return;
        }
        const groupedMaterials = {};
        Object.values(completeBOM).forEach(item => {
            if (!groupedMaterials[item.type]) {
                groupedMaterials[item.type] = [];
            }
            groupedMaterials[item.type].push(item);
        });
        let html = '<div class="bom-content active">';
        Object.entries(groupedMaterials).forEach(([type, items]) => {
            html += `<div class="bom-type-group">`;
            items.forEach(item => {
                const componentName = item.componentKey.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                const quantity = item.quantity;
                let dimension = item.dimension;
                let metric = item.metric;
                if (metric == 'm2') {
                    dimension = dimension/1000000;
                    metric = 'm<sup>2</sup>'
                }
                let productUrl = item.product_url;
                if (item.product_url) {
                    if (item.variantId) {
                        productUrl += `?variant=${item.variantId}`;
                    }
                }
                const clickHandler = item.product_url !== false ? `onclick="window.open('${productUrl}', '_blank')"` : '';
                const cursorStyle = item.product_url !== false ? 'style="cursor: pointer;"' : '';
                html += `
                    <div class="bom-item" ${clickHandler} ${cursorStyle}>
                        <div class="bom-item-left">
                            <div class="bom-component-name">${componentName}</div>
                            <div class="bom-component-type">${type}</div>
                        </div>
                        <div class="bom-item-right">
                            <div class="bom-quantity"><span class="bom-value">x${quantity}</span></div>
                            <div class="bom-dimension"><span class="bom-value">${dimension.toFixed(2)} ${metric}</span></div>
                            <div class="bom-price-per-item"><span class="bom-label">Price per item:</span><span class="bom-value">£${item.pricePerItem.toFixed(2)}</span></div>
                            <div class="bom-total-price"><span class="bom-label">Total:</span><span class="bom-value">£${item.totalPrice.toFixed(2)}</span></div>
                        </div>
                    </div>
                `;
            });
        });
        const totalItems = Object.values(completeBOM).reduce((sum, item) => sum + item.quantity, 0);
        html += `
            <div class="bom-total-section">
                <div class="bom-total-row">
                    <span class="bom-total-label">Total Components:</span>
                    <span class="bom-total-value">${totalItems}</span>
                </div>
                <div class="bom-total-row">
                    <span class="bom-total-label">Total Cost:</span>
                    <span class="bom-total-value">£${grandTotal.toFixed(2)}</span>
                </div>
            </div>
            <button class="add-to-order-btn" id="add-to-order-btn" onclick="window.OrderSheetManager && window.OrderSheetManager.addCurrentConfiguration()">
                Add to Order Sheet
            </button>
        `;
        html += '</div>';
        bomContent.innerHTML = html;

        this.log('Bill of materials updated with costs. Grand total: £' + grandTotal.toFixed(2) + ' (stored in this.totalBomCost)', 'info');
    }

    // * ================== Notifications and modal Method's ==================

    showNoCompatibleRailsWarning(grooveSize) {
        const warningMessage = `No compatible rails found for ${grooveSize}mm groove size. Please select a different spindle or glass option.`;
        if (this.onboardingWizard_open) {
            this.AddWarningMessage(warningMessage, true);
        } else {
            this.showMainConfiguratorNotification(warningMessage, 'warning');
        }
    }

    createNotificationElement(message, type, duration, isAutoSave, container, extraClass = '') {
        const notification = document.createElement('div');
        notification.className = `configurator-notification configurator-notification--${type}${isAutoSave ? ' configurator-notification--auto-save' : ''}${extraClass ? ` ${extraClass}` : ''}`;
        notification.style.cssText = `
            background: ${type === 'warning' ? '#fff3cd' : type === 'error' ? '#f8d7da' : '#d1ecf1'};
            border: 1px solid ${type === 'warning' ? '#ffeaa7' : type === 'error' ? '#f5c6cb' : '#bee5eb'};
            color: ${type === 'warning' ? '#856404' : type === 'error' ? '#721c24' : '#0c5460'};
            padding: 15px;
            margin-bottom: 10px;
            border-radius: 4px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            animation: slideIn 0.3s ease-out;
            pointer-events: auto;
            position: relative;
            opacity: 1;
            transition: opacity 0.3s ease-out;
            ${isAutoSave ? 'opacity: 0.8; font-size: 13px;' : ''}
        `;
        notification.innerHTML = `
            <div style="display: flex; justify-content: space-between; align-items: flex-start;">
                <div>${message}</div>
                <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; font-size: 18px; cursor: pointer; margin-left: 10px; opacity: 0.7; transition: opacity 0.2s ease;" onmouseover="this.style.opacity='1'" onmouseout="this.style.opacity='0.7'">×</button>
            </div>
        `;

        container.appendChild(notification);

        // Log notification creation for debugging
        this.log(`Notification created: "${message}" (${type}) - Duration: ${duration}ms`, 'debug');

        // Auto-remove notification after specified duration
        setTimeout(() => {
            if (notification.parentElement) {
                notification.style.opacity = '0';
                setTimeout(() => {
                    if (notification.parentElement) {
                        notification.remove();
                    }
                }, 300);
            }
        }, duration);
    }

    showNotificationContainer() {
        const notificationContainer = document.getElementById('configurator-notifications');
        if (notificationContainer) {
            notificationContainer.style.opacity = '1';
            this.log('Notification container made visible', 'debug');
        }
    }

    showMainConfiguratorNotification(message, type = 'info', options = {}) {
        const extraClass = options.staircaseValidation ? 'configurator-notification--staircase-validation' : '';
        let notificationContainer = document.getElementById('configurator-notifications');
        if (!notificationContainer) {
            notificationContainer = document.createElement('div');
            notificationContainer.id = 'configurator-notifications';
            notificationContainer.style.cssText = `
                position: fixed;
                top: 60px;
                right: 20px;
                z-index: 10000;
                max-width: 600px;
                max-height: 80vh;
                overflow-y: visible;
                pointer-events: none;
                opacity: 0;
                transition: opacity 0.3s ease-in-out;
            `;
            document.body.appendChild(notificationContainer);

            // Show notifications 5 seconds after configurator has fully loaded
            setTimeout(() => {
                notificationContainer.style.opacity = '1';

                // Process any queued notifications
                if (this.queuedNotifications && this.queuedNotifications.length > 0) {
                    this.log(`Processing ${this.queuedNotifications.length} queued notifications`, 'debug');
                    this.queuedNotifications.forEach(queuedNotification => {
                        const qExtra = queuedNotification.staircaseValidation ? 'configurator-notification--staircase-validation' : '';
                        this.createNotificationElement(queuedNotification.message, queuedNotification.type, queuedNotification.duration, queuedNotification.isAutoSave, notificationContainer, qExtra);
                    });
                    this.queuedNotifications = []; // Clear the queue
                }
            }, 5000);
        }

        // Define different durations for different notification types
        const durations = {
            'auto-save': 2000,    // Auto-save notifications show for 2 seconds (very brief)
            'info': 12000,        // General info notifications show for 12 seconds
            'warning': 15000,     // Warning notifications show for 15 seconds
            'error': 20000        // Error notifications show for 20 seconds
        };

        // Determine duration based on message content or type
        let duration = durations[type] || durations['info'];
        const messageLower = message.toLowerCase();
        if (messageLower.includes('auto-saved') ||
            messageLower.includes('auto save') ||
            messageLower.includes('autosaved') ||
            messageLower === 'auto-saved') {
            duration = durations['auto-save'];
        }

        // If container is not visible yet (opacity 0), queue the notification
        if (notificationContainer.style.opacity === '0') {
            // Store the notification data to create it when container becomes visible
            if (!this.queuedNotifications) {
                this.queuedNotifications = [];
            }
            this.queuedNotifications.push({
                message,
                type,
                duration,
                isAutoSave: duration === durations['auto-save'],
                staircaseValidation: !!options.staircaseValidation
            });
            this.log(`Notification queued (container not visible): "${message}" (${type}) - Duration: ${duration}ms`, 'debug');
            return;
        }

        // Create and display the notification
        this.createNotificationElement(message, type, duration, duration === durations['auto-save'], notificationContainer, extraClass);

        if (!document.getElementById('configurator-notification-styles')) {
            const style = document.createElement('style');
            style.id = 'configurator-notification-styles';
            style.textContent = `
                @keyframes slideIn {
                    from { transform: translateX(100%); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }
                .configurator-notification {
                    transform-origin: top right;
                }
                .configurator-notification:hover {
                    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
                }
            `;
            document.head.appendChild(style);
        }
    }

    showNoOptionsMessage(container, componentType) {
        container.innerHTML = '';
        const noOptionsDiv = document.createElement('div');
        noOptionsDiv.className = 'component-modal-no-options';
        const iconDiv = document.createElement('div');
        iconDiv.className = 'icon';
        iconDiv.innerHTML = '';
        const titleDiv = document.createElement('div');
        titleDiv.className = 'title';
        titleDiv.textContent = 'No Options Available';
        const messageDiv = document.createElement('div');
        messageDiv.className = 'message';
        if (componentType === 'handrail' || componentType === 'baserail') {
            const currentGrooveSize = this.getCurrentGrooveSize();
            if (currentGrooveSize) {
                messageDiv.innerHTML = `
                    No ${componentType} options found that are compatible with the current groove size (${currentGrooveSize}mm).<br><br>
                    <strong>To see available options:</strong><br>
                    • Select a different spindle or glass option<br>
                    • Or contact us to discuss solutions
                `;
            } else {
                messageDiv.innerHTML = `
                    No ${componentType} options found.<br><br>
                    <strong>To see available options:</strong><br>
                    • First select a spindle or glass option<br>
                    • Then return to select your ${componentType}
                `;
            }
        } else {
            messageDiv.innerHTML = `
                No ${componentType} options are currently available.<br><br>
                Please adjust your selection or contact us for assistance.
            `;
        }
        const actionsDiv = document.createElement('div');
        actionsDiv.className = 'actions';
        const goBackButton = document.createElement('button');
        goBackButton.textContent = 'Go Back';
        goBackButton.className = 'btn btn-secondary';
        goBackButton.addEventListener('click', () => {
            this.closeComponentModal();
        });
        const supportButton = document.createElement('button');
        supportButton.textContent = 'Contact Us';
        supportButton.className = 'btn btn-primary';
        supportButton.addEventListener('click', () => {
            window.open('/pages/contact')
        });
        actionsDiv.appendChild(goBackButton);
        actionsDiv.appendChild(supportButton);
        noOptionsDiv.appendChild(iconDiv);
        noOptionsDiv.appendChild(titleDiv);
        noOptionsDiv.appendChild(messageDiv);
        noOptionsDiv.appendChild(actionsDiv);
        container.appendChild(noOptionsDiv);
        if (componentType === 'handrail' || componentType === 'baserail') {
            const currentGrooveSize = this.getCurrentGrooveSize();
            if (currentGrooveSize) {
                const tipDiv = document.createElement('div');
                tipDiv.className = 'tip';
                tipDiv.innerHTML = `
                    <strong>Notice:</strong> You're currently looking for ${componentType}s compatible with a <strong>${currentGrooveSize}mm groove</strong>. 
                    To see more options, try selecting a different spindle or glass option.
                `;
                noOptionsDiv.appendChild(tipDiv);
            }
        }
    }

    ClearActiveMessages(isStep = false) {
        const errorBox = document.querySelector(isStep ? '.stair-configurator-step__active .stair-configurator-step-errors' : '.alternative-target-errors');
        const warningBox = document.querySelector(isStep ? '.stair-configurator-step__active .stair-configurator-step-warnings' : '.alternative-target-warnings');
        if (errorBox) {
            errorBox.innerHTML = '';
        }
        if (warningBox) {
            warningBox.innerHTML = '';
        }
    }

    AddWarningMessage(message, isStep = false) {
        const template = document.getElementById('configurator-step-warning-template');
        const warningBox = document.querySelector(isStep ? '.stair-configurator-step__active .stair-configurator-step-warnings' : '.alternative-target-warnings');
        const clone = template.content.cloneNode(true);
        if (warningBox) {
            clone.querySelector('div').innerHTML = message;
            warningBox.appendChild(clone);
        }
    }

    AddErrorMessage(message, isStep = false) {
        const template = document.getElementById('configurator-step-error-template');
        const errorBox = document.querySelector(isStep ? '.stair-configurator-step__active .stair-configurator-step-errors' : '.alternative-target-errors');
        const clone = template.content.cloneNode(true);
        if (errorBox) {
            clone.querySelector('div').innerHTML = message;
            errorBox.appendChild(clone);
        }
    }

    showComponentModal(componentType) {
        const modal = document.getElementById('component-selection-modal');
        const title = document.getElementById('component-modal-title');
        const optionsContainer = document.getElementById('component-modal-options');
        const typeLabels = {
            'spindle': 'Select Spindle',
            'spindle-2': 'Select Second Spindle',
            'glass': 'Select Glass',
            'post': 'Select Newel Post',
            'handrail': 'Select Handrail',
            'baserail': 'Select Baserail',
            'glass-clamp': 'Select Glass Clamp',
            'post-cap': 'Select Post Cap',
            'step': 'Select Step Type',
            'riser': 'Select Riser',
            'string': 'Select String Material',
            'feature-step': 'Select Feature Step'
        };
        title.textContent = typeLabels[componentType] || 'Select Component';
        optionsContainer.innerHTML = '';
        const currentSelection = this.getCurrentComponentSelection(componentType);
        this.populateComponentModalOptions(componentType, optionsContainer, currentSelection);
        this.currentComponentType = componentType;
        if (componentType === 'handrail' || componentType === 'baserail') {
            this.showCurrentGrooveSizeInfo();
        }
        modal.style.display = 'flex';
        setTimeout(() => {
            modal.classList.add('show');
        }, 10);
    }

    closeComponentModal() {
        const modal = document.getElementById('component-selection-modal');
        modal.classList.remove('show');
        setTimeout(() => {
            modal.style.display = 'none';
        }, 300);
        this.currentComponentType = null;
    }

    populateComponentModalOptions(componentType, container, currentSelection) {
        let assets = {};
        if (componentType === 'handrail' || componentType === 'baserail') {
            const railAssets = window.PD_SC_BUILDER_ASSETS['rail'] || {};
            Object.entries(railAssets).forEach(([handle, component]) => {
                if (component.type === componentType) {
                    const currentGrooveSize = this.getCurrentGrooveSize();
                    // Always show rails with groove 0 or false
                    const railGroove = component.dimensions2d?.groove;
                    if (railGroove === 0 || railGroove === false) {
                        assets[handle] = component;
                    } else if (!currentGrooveSize || this.isRailCompatibleWithGroove(component, currentGrooveSize)) {
                        assets[handle] = component;
                    }
                }
            });
        } else if (componentType === 'glass-clamp') {
            const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
            Object.entries(miscAssets).forEach(([handle, component]) => {
                if (component.sub_type === 'glass-clamp') {
                    assets[handle] = component;
                }
            });
        } else if (componentType === 'string') {
            const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
            Object.entries(miscAssets).forEach(([handle, component]) => {
                if (component.sub_type === 'string') {
                    assets[handle] = component;
                }
            });
        } else if (componentType === 'post-cap') {
            const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
            const currentPostWidth = this.getCurrentPostWidth();

            Object.entries(miscAssets).forEach(([handle, component]) => {
                if (component.sub_type === 'post-cap') {
                    // Filter post-caps based on post width compatibility
                    if (this.isPostCapCompatibleWithPost(component, currentPostWidth)) {
                        assets[handle] = component;
                    }
                }
            });
            // Add "no cap" option
            assets['no-cap'] = {
                name: 'No Cap',
                description: 'No post cap selected'
            };
        } else if (componentType === 'feature-step') {
            const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
            Object.entries(miscAssets).forEach(([handle, component]) => {
                if (component.sub_type === 'feature-step') {
                    assets[handle] = component;
                }
            });
        } else if (componentType === 'riser') {
            const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
            Object.entries(miscAssets).forEach(([handle, component]) => {
                if (component.sub_type === 'riser') {
                    assets[handle] = component;
                }
            });
        } else if (componentType === 'spindle-2') {
            // Filter second spindle options to only show those matching first spindle's groove size
            const firstSpindleHandle = this.getCurrentComponentSelection('spindle');
            if (!firstSpindleHandle) {
                // No first spindle selected, show no options message
                this.showNoOptionsMessage(container, 'spindle-2');
                return;
            }

            const firstSpindle = window.PD_SC_BUILDER_ASSETS['spindle']?.[firstSpindleHandle];
            if (!firstSpindle || !firstSpindle.dimensions2d || !firstSpindle.dimensions2d.groove) {
                // First spindle doesn't have groove size, show no options message
                this.showNoOptionsMessage(container, 'spindle-2');
                return;
            }

            const firstGrooveSize = firstSpindle.dimensions2d.groove;
            const spindleAssets = window.PD_SC_BUILDER_ASSETS['spindle'] || {};

            Object.entries(spindleAssets).forEach(([handle, component]) => {
                // Skip the first spindle (can't select same spindle twice)
                if (handle === firstSpindleHandle) {
                    return;
                }

                // Only include spindles with matching groove size
                if (component.dimensions2d && component.dimensions2d.groove === firstGrooveSize) {
                    assets[handle] = component;
                }
            });
        } else {
            assets = window.PD_SC_BUILDER_ASSETS[componentType] || {};
        }
        this.log(`Populating ${componentType} options: ${Object.keys(assets)}`);
        if (Object.keys(assets).length === 0) {
            this.showNoOptionsMessage(container, componentType);
            return;
        }
        Object.entries(assets).forEach(([handle, component]) => {
            const optionDiv = document.createElement('div');
            optionDiv.className = 'component-modal-option';
            optionDiv.setAttribute('data-component-handle', handle);
            optionDiv.setAttribute('data-component-type', componentType);
            if (currentSelection === handle) {
                optionDiv.classList.add('selected');
            }
            optionDiv.innerHTML = `
                <div style="display: flex; align-items: center;">
                    <div class="component-modal-option-image" style="background-image: url('${component.product_data?.featured_image || ''}')"></div>
                    <div class="component-modal-option-details">
                        <div class="component-modal-option-title">${component.name}</div>
                        <div class="component-modal-option-textures">
                            ${this.createTextureDisplay(component.primary_texture)}
                            ${component.primary_texture !== component.secondary_texture ? this.createTextureDisplay(component.secondary_texture) : ''}
                </div>
                    </div>
                </div>
            `;
            optionDiv.addEventListener('click', () => {
                this.selectComponentOption(handle, componentType);
            });
            container.appendChild(optionDiv);
        });
    }

    updateComponentDisplay(componentType, handle) {
        let displayElement;
        if (this.type === 'STAIRCASE') {
            displayElement = document.getElementById(`sc-component-${componentType}-display`);
        } else {
            // Handle spindle-2 with special display element ID
            if (componentType === 'spindle-2') {
                displayElement = document.getElementById('component-spindle-2-display');
            } else {
                displayElement = document.getElementById(`component-${componentType}-display`);
            }
        }
        if (!displayElement) {
            this.log(`Display element not found for ${componentType}`, 'debug');
            return;
        }
        let component = null;
        if (componentType === 'spindle-2' || componentType === 'spindle') {
            // Both first and second spindle use the same asset type
            const spindleAssets = window.PD_SC_BUILDER_ASSETS['spindle'] || {};
            component = spindleAssets[handle];
        } else if (componentType === 'handrail' || componentType === 'baserail') {
            const railAssets = window.PD_SC_BUILDER_ASSETS['rail'] || {};
            component = railAssets[handle];
            if (component && component.type !== componentType) {
                component = null;
            }
        } else if (componentType === 'glass-clamp') {
            const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
            component = miscAssets[handle];
            if (component && component.sub_type !== 'glass-clamp') {
                component = null;
            }
        } else if (componentType === 'feature-step') {
            const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
            component = miscAssets[handle];
            if (component && component.sub_type !== 'feature-step') {
                component = null;
            }
        } else if (componentType === 'string') {
            const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
            component = miscAssets[handle];
            if (component && component.sub_type !== 'string') {
                component = null;
            }
        } else if (componentType === 'riser') {
            const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
            component = miscAssets[handle];
            if (component && component.sub_type !== 'riser') {
                component = null;
            }
        } else if (componentType === 'post-cap') {
            if (handle === 'no-cap') {
                component = {
                    name: 'No Cap',
                    description: 'No post cap selected'
                };
            } else {
                const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
                component = miscAssets[handle];
                if (component && component.sub_type !== 'post-cap') {
                    component = null;
                }
            }
        } else {
            component = window.PD_SC_BUILDER_ASSETS[componentType]?.[handle];
        }
        if (!component) return;
        displayElement.innerHTML = `
            <div class="component-display-content">
                <div class="component-display-image" style="background-image: url('${component.product_data?.featured_image || ''}')"></div>
                <div class="component-display-details">
                    <div class="component-display-title">${component.name}</div>
                    <div class="component-display-textures">
                        ${this.createTextureDisplay(component.primary_texture)}
                        ${component.primary_texture !== component.secondary_texture ? this.createTextureDisplay(component.secondary_texture) : ''}
                    </div>
                </div>
            </div>
        `;

        // Show post placement notice for staircase when post is selected
        if (componentType === 'post' && this.type === 'STAIRCASE') {
            this.updatePostPlacementNotice(true);
        } else if (componentType === 'post' && this.type === 'BALUSTRADE') {
            this.updatePostPlacementNotice(false);
        }

        // Trigger BOM update when component display changes
        if (this.StairController && this.StairController.businessLogic) {
            setTimeout(() => {
                this.log(`Requesting BOM update after ${componentType} component change to ${handle}`, 'info');
                this.requestBillOfMaterialsUpdate();
            }, 150);
        }
    }
    updateComponentSelection(componentType, handle) {
        if (!this.options) {
            this.options = this.defaultOptions;
        }

        // Clear current configuration when changing component selection
        this.clearCurrentConfiguration();

        const typeMapping = {
            'spindle': 'spindle',
            'spindle-2': 'spindle',
            'glass': 'glass',
            'post': 'post',
            'handrail': 'rail',
            'baserail': 'rail',
            'glass-clamp': 'misc',
            'string': 'string',
            'riser': 'riser',
            'post-cap': 'misc',
            'step': 'step',
            'feature-step': 'misc'
        };
        const optionKey = typeMapping[componentType];
        if (optionKey) {
            if (componentType === 'spindle-2') {
                // Handle second spindle selection
                if (!this.options.spindle || this.options.spindle.length === 0) {
                    this.showMainConfiguratorNotification('Please select a first spindle before selecting a second spindle', 'error');
                    return;
                }
                // Validate groove size compatibility
                const validation = this.validateSecondSpindleGrooveSize(handle);
                if (!validation.isValid) {
                    this.showMainConfiguratorNotification(validation.message, 'error');
                    return;
                }
                // Ensure spindle array exists and has at least one element
                if (!this.options.spindle) {
                    this.options.spindle = [];
                }
                // Set second spindle at index 1
                if (this.options.spindle.length === 1) {
                    this.options.spindle.push(handle);
                } else {
                    this.options.spindle[1] = handle;
                }
            } else if (componentType === 'post-cap') {
                // Handle post-cap selection for misc items
                if (!this.options.misc) {
                    this.options.misc = [];
                }
                // Remove any existing post-caps
                this.options.misc = this.options.misc.filter(item => {
                    const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                    return !miscComponent || miscComponent.sub_type !== 'post-cap';
                });
                // Add new post-cap if not "no-cap"
                if (handle !== 'no-cap' && handle !== null) {
                    this.options.misc.push(handle);
                }
            } else if (componentType === 'glass-clamp') {
                // Handle glass-clamp selection for misc items
                if (!this.options.misc) {
                    this.options.misc = [];
                }
                // Remove any existing glass-clamps
                this.options.misc = this.options.misc.filter(item => {
                    const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                    return !miscComponent || miscComponent.sub_type !== 'glass-clamp';
                });
                // Add new glass-clamp if not null
                if (handle !== null) {
                    this.options.misc.push(handle);
                }
            } else if (componentType === 'feature-step') {
                // Handle feature-step selection for misc items
                if (!this.options.misc) {
                    this.options.misc = [];
                }
                // Remove any existing feature-steps
                this.options.misc = this.options.misc.filter(item => {
                    const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                    return !miscComponent || miscComponent.sub_type !== 'feature-step';
                });
                // Add new feature-step if not null
                if (handle !== null) {
                    this.options.misc.push(handle);
                }
            } else if (componentType === 'string') {
                // Handle string material selection
                if (!this.options.string) {
                    this.options.string = [];
                }
                this.options.string[0] = handle;
                // Also add to misc array for StairController compatibility
                if (!this.options.misc) {
                    this.options.misc = [];
                }
                // Remove any existing string materials from misc
                this.options.misc = this.options.misc.filter(item => {
                    const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                    return !miscComponent || miscComponent.sub_type !== 'string';
                });
                // Add new string material to misc
                if (handle !== null) {
                    this.options.misc.push(handle);
                }
            } else if (componentType === 'riser') {
                // Handle riser selection
                if (!this.options.riser) {
                    this.options.riser = [];
                }
                this.options.riser[0] = handle;
                // Also add to misc array for StairController compatibility
                if (!this.options.misc) {
                    this.options.misc = [];
                }
                // Remove any existing risers from misc
                this.options.misc = this.options.misc.filter(item => {
                    const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                    return !miscComponent || miscComponent.sub_type !== 'riser';
                });
                // Add new riser to misc
                if (handle !== null) {
                    this.options.misc.push(handle);
                }
            } else {
                // Handle regular component types
                if (!this.options[optionKey]) {
                    this.options[optionKey] = [];
                }
                if (componentType === 'handrail') {
                    this.options[optionKey][0] = handle;
                } else if (componentType === 'baserail') {
                    this.options[optionKey][1] = handle;
                } else {
                    this.options[optionKey][0] = handle;
                }
            }
        }
        if (componentType === 'spindle' || componentType === 'glass') {
            if (this.wouldComponentLeaveNoCompatibleRails(componentType, handle)) {
                this.showNoCompatibleRailsWarning(this.getComponentGrooveSize(componentType, handle));
                return;
            }
            this.validateRailCompatibility(componentType);
            // If first spindle changes and second spindle exists, validate compatibility
            if (componentType === 'spindle' && this.options.spindle && this.options.spindle.length > 1) {
                const secondSpindleHandle = this.options.spindle[1];
                const validation = this.validateSecondSpindleGrooveSize(secondSpindleHandle);
                if (!validation.isValid) {
                    // Clear second spindle if it's no longer compatible
                    this.log(`First spindle changed, clearing incompatible second spindle: ${validation.message}`, 'info');
                    this.options.spindle = [this.options.spindle[0]];
                    this.clearSecondSpindleSelection();
                    this.showMainConfiguratorNotification('Second spindle was cleared because it is no longer compatible with the new first spindle', 'warning');
                }
            }
        }
        this.debouncedAutoSave();
    }
    getCurrentComponentSelection(componentType) {
        if (!this.options) return null;
        const typeMapping = {
            'spindle': 'spindle',
            'spindle-2': 'spindle',
            'glass': 'glass',
            'post': 'post',
            'handrail': 'rail',
            'baserail': 'rail',
            'glass-clamp': 'misc',
            'string': 'string',
            'riser': 'riser',
            'post-cap': 'misc',
            'step': 'step',
            'feature-step': 'misc'
        };
        const optionKey = typeMapping[componentType];
        if (!optionKey) return null;
        if (componentType === 'handrail') {
            return this.options[optionKey][0] || null;
        } else if (componentType === 'baserail') {
            return this.options[optionKey][1] || null;
        } else if (componentType === 'spindle-2') {
            // Return second spindle (index 1) if it exists
            if (this.options[optionKey] && this.options[optionKey].length > 1) {
                return this.options[optionKey][1] || null;
            }
            return null;
        } else if (componentType === 'glass-clamp') {
            if (this.options[optionKey]) {
                for (const item of this.options[optionKey]) {
                    const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                    if (miscComponent && miscComponent.sub_type === 'glass-clamp') {
                        return item;
                    }
                }
            }
            return null;
        } else if (componentType === 'feature-step') {
            if (this.options[optionKey]) {
                for (const item of this.options[optionKey]) {
                    const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                    if (miscComponent && miscComponent.sub_type === 'feature-step') {
                        return item;
                    }
                }
            }
            return null;
        } else if (componentType === 'post-cap') {
            if (this.options[optionKey]) {
                for (const item of this.options[optionKey]) {
                    const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                    if (miscComponent && miscComponent.sub_type === 'post-cap') {
                        return item;
                    }
                }
            }
            return 'no-cap'; // Default to "no cap" if none selected
        } else if (componentType === 'string') {
            if (this.options.string && this.options.string.length > 0) {
                return this.options.string[0];
            }
            return null;
        } else if (componentType === 'riser') {
            if (this.options.riser && this.options.riser.length > 0) {
                return this.options.riser[0];
            }
            return null;
        } else {
            if (this.options[optionKey] && Array.isArray(this.options[optionKey]) && this.options[optionKey].length > 0) {
                return this.options[optionKey][0];
            }
            return null;
        }
    }

    updateComponentDisplays() {
        let componentTypes;
        if (this.type === 'STAIRCASE') {
            componentTypes = ['step', 'riser', 'post', 'string', 'feature-step'];
        } else {
            componentTypes = ['spindle', 'glass', 'post', 'handrail', 'baserail', 'glass-clamp', 'post-cap', 'string'];
        }
        componentTypes.forEach(type => {
            const selection = this.getCurrentComponentSelection(type);
            if (selection) {
                try {
                    this.updateComponentDisplay(type, selection);
                } catch (error) {
                    this.log(`Error updating component display for ${type}: ${error.message}`, 'warn');
                }
            } else if (type === 'post' && this.type === 'STAIRCASE') {
                // Hide notice if post is not selected
                this.updatePostPlacementNotice(false);
            }
        });

        // Update second spindle display if it exists and toggle is enabled
        if (this.type === 'BALUSTRADE') {
            const secondSpindleToggle = document.querySelector('input[name="second-spindle-toggle"]:checked');
            if (secondSpindleToggle && secondSpindleToggle.value === 'yes') {
                const secondSpindleSelection = this.getCurrentComponentSelection('spindle-2');
                if (secondSpindleSelection) {
                    try {
                        this.updateComponentDisplay('spindle-2', secondSpindleSelection);
                    } catch (error) {
                        this.log(`Error updating second spindle display: ${error.message}`, 'warn');
                    }
                }
            }
            // Update post cap visibility after all displays are updated
            this.updatePostCapVisibility();
        }
        // Update feature step visibility for staircase
        if (this.type === 'STAIRCASE') {
            this.updateFeatureStepVisibility();
        }
    }

    showErrorModal(message) {
        const modal = document.getElementById('error-modal');
        const messageElement = document.getElementById('error-modal-message');
        messageElement.textContent = message;
        modal.style.display = 'flex';
        setTimeout(() => {
            modal.classList.add('show');
        }, 10);
    }

    closeErrorModal() {
        const modal = document.getElementById('error-modal');
        modal.classList.remove('show');
        setTimeout(() => {
            modal.style.display = 'none';
        }, 300);
    }

    showDeleteModal() {
        const modal = document.getElementById('delete-config-modal');
        modal.style.display = 'flex';
        setTimeout(() => {
            modal.classList.add('show');
        }, 10);
    }

    closeDeleteModal() {
        const modal = document.getElementById('delete-config-modal');
        modal.classList.remove('show');
        setTimeout(() => {
            modal.style.display = 'none';
        }, 300);
        this.pendingDeleteUid = null;
    }

    showRestartModal() {
        const modal = document.getElementById('restart-config-modal');
        modal.style.display = 'flex';
        setTimeout(() => {
            modal.classList.add('show');
        }, 10);
    }

    closeRestartModal() {
        const modal = document.getElementById('restart-config-modal');
        modal.classList.remove('show');
        setTimeout(() => {
            modal.style.display = 'none';
        }, 300);
    }


    // * ================== Validation Method's ==================

    initializeTreadCountBounds() {
        if (!this.StairController || this.type !== 'STAIRCASE') {
            return;
        }
        if (this.StairController.businessLogic && this.StairController.businessLogic.stairCaseParameters) {
            const params = this.StairController.businessLogic.stairCaseParameters;
            if (params.minTreads && params.maxTreads) {
                this.log(`Initializing tread count bounds from StairController: ${params.minTreads}-${params.maxTreads}`, 'info');
                this.updateTreadCountValidation(params.minTreads, params.maxTreads);
            }
        }
        if (this.treadBounds[0] === 0 && this.treadBounds[1] === 0) {
            this.log('No tread bounds available yet, will update when calculated', 'info');
        }
    }

    validateRailCompatibility(componentType) {
        if (componentType !== 'spindle' && componentType !== 'glass') {
            return;
        }
        const newGrooveSize = this.getCurrentGrooveSize();
        if (!newGrooveSize) return;
        const options = this.onboardingWizard_open ? this.inProgressOptions : this.options;
        if (!options || !options.rail) return;
        let needsUpdate = false;
        const updatedRailOptions = [...options.rail];
        if (options.rail[0]) {
            const handrail = window.PD_SC_BUILDER_ASSETS['rail']?.[options.rail[0]];
            if (handrail) {
                // Always preserve rails with groove 0 or false - don't switch them
                const railGroove = handrail.dimensions2d?.groove;
                if (railGroove === 0 || railGroove === false) {
                    // Keep the rail with groove 0/false, don't switch
                } else if (!this.isRailCompatibleWithGroove(handrail, newGrooveSize)) {
                    const compatibleHandrail = this.findFirstCompatibleRail('handrail', newGrooveSize);
                    if (compatibleHandrail) {
                        updatedRailOptions[0] = compatibleHandrail;
                        needsUpdate = true;
                        const handrailName = window.PD_SC_BUILDER_ASSETS['rail'][compatibleHandrail]?.name || compatibleHandrail;
                        if (this.onboardingWizard_open) {
                            this.AddWarningMessage(`Handrail auto-switched to ${handrailName} due to groove size change`, true);
                        } else {
                            this.showMainConfiguratorNotification(`Handrail auto-switched to ${handrailName} due to groove size change`, 'info');
                        }
                    } else {
                        this.showNoCompatibleRailsWarning(newGrooveSize);
                    }
                }
            }
        }
        if (options.rail[1]) {
            const baserail = window.PD_SC_BUILDER_ASSETS['rail']?.[options.rail[1]];
            if (baserail) {
                // Always preserve rails with groove 0 or false - don't switch them
                const railGroove = baserail.dimensions2d?.groove;
                if (railGroove === 0 || railGroove === false) {
                    // Keep the rail with groove 0/false, don't switch
                } else if (!this.isRailCompatibleWithGroove(baserail, newGrooveSize)) {
                    const compatibleBaserail = this.findFirstCompatibleRail('baserail', newGrooveSize);
                    if (compatibleBaserail) {
                        updatedRailOptions[1] = compatibleBaserail;
                        needsUpdate = true;
                        const baserailName = window.PD_SC_BUILDER_ASSETS['rail'][compatibleBaserail]?.name || compatibleBaserail;
                        if (this.onboardingWizard_open) {
                            this.AddWarningMessage(`Baserail auto-switched to ${baserailName} due to groove size change`, true);
                        } else {
                            this.showMainConfiguratorNotification(`Baserail auto-switched to ${baserailName} due to groove size change`, 'info');
                        }
                    } else {
                        this.showNoCompatibleRailsWarning(newGrooveSize);
                    }
                }
            }
        }
        if (needsUpdate) {
            if (this.onboardingWizard_open) {
                this.inProgressOptions.rail = updatedRailOptions;
                this.refreshOnboardingRailDisplays();
                this.refreshOnboardingComponentOptions();
            } else {
                this.options.rail = updatedRailOptions;
                this.updateComponentDisplays();
            }
        }
    }

    displayValidationMessages(messages, isOnboarding = false) {
        this.log(`Displaying validation messages: ${messages.length} messages, isOnboarding: ${isOnboarding}`, 'debug');
        if (isOnboarding) {
            this.log('Using onboarding validation display', 'debug');
            this.ClearActiveMessages(true);
            messages.forEach(msg => {
                if (msg.type === 'warning') {
                    this.AddWarningMessage(msg.message, true);
                } else {
                    this.AddErrorMessage(msg.message, true);
                }
            });
        } else {
            this.log('Using main configurator notification display', 'debug');
            messages.forEach(msg => {
                this.log(`Showing notification: ${msg.message} (${msg.type})`, 'debug');
                this.showMainConfiguratorNotification(msg.message, msg.type);
            });
        }
    }

    HandleValidations(inputValue, validations, isStep = false) {
        let valid = true;
        for (const validation of validations) {
            if (this.ValidateInput(parseInt(inputValue), validation.rules, isStep) === false) {
                valid = false;
            }
        }
        return valid;
    }

    ValidateInput(inputValue, validationRules, isStep = false) {
        if (isStep) {
            this.ClearActiveMessages(isStep);
        }
        for (const rule of validationRules) {
            let isValid = true;
            let message = rule.message || '';
            switch (rule.type) {
                case 'min':
                    isValid = inputValue >= rule.value;
                    message = rule.message;
                    break;
                case 'max':
                    isValid = inputValue <= rule.value;
                    break;
                case 'range':
                    isValid = (inputValue >= rule.min && inputValue <= rule.max);
                    message = rule.message;
                    break;
                case 'tread-bounds':
                    isValid = (inputValue >= this.treadBounds[0] && inputValue <= this.treadBounds[1]);
                    message = rule.message;
                    break;
            }
            if (!isValid) {
                if (rule.warning) {
                    this.AddWarningMessage(message, isStep);
                } else {
                    this.AddErrorMessage(message, isStep);
                    return false;
                }
            }
        }
        return true;
    }

    ValidateAllMasterControls() {
        const validations = Object.values(window.PD_SC_CONTROLS).filter(control => control.type === this.type || control.type === 'BOTH');
        for (const validation of validations) {
        }
        return true;
    }

    getOrderStatus() {
        if (this.canOrder === true) {
            return 'ready';
        } else if (this.canOrder === false) {
            return 'error';
        } else {
            return 'calculating';
        }
    }

    updateTreadCountValidation(minTreads, maxTreads) {
        this.treadBounds = [minTreads, maxTreads]
        this.log(`Updating tread count validation: min=${minTreads}, max=${maxTreads}`, 'info');
        this.updateOnboardingTreadCountValidation(minTreads, maxTreads);
        this.updateMainStaircaseTreadCountValidation(minTreads, maxTreads);

        // Note: Turns display will be updated by the UI when needed
        // This prevents circular dependency issues

        this.log(`Tread count validation updated successfully for both onboarding and main controls`, 'info');
    }

    updateOnboardingTreadCountValidation(minTreads, maxTreads) {
        const treadCountInput = document.getElementById('stair-controller-step__tread-count-input');
        const treadCountErrors = document.querySelector('.stair-configurator-step-errors.input_info__tread-count-input');
        const boundsNotice = document.getElementById('tread-count-bounds-notice');
        if (treadCountInput && treadCountErrors) {
            treadCountInput.min = minTreads;
            treadCountInput.max = maxTreads;
            treadCountErrors.innerHTML = '';
            const currentValue = parseInt(treadCountInput.value) || 0;
            if (currentValue < minTreads) {
                treadCountInput.value = minTreads;
            } else if (currentValue > maxTreads) {
                treadCountInput.value = maxTreads;
            }
            if (boundsNotice) {
                const boundsNoticeText = boundsNotice.querySelector('.bounds-notice-text');
                if (boundsNoticeText) {
                    if (minTreads > 0 && maxTreads > 0) {
                        boundsNoticeText.innerHTML = `Based on your staircase parameters, the valid range is <strong>${minTreads} - ${maxTreads} treads</strong>.`;
                        boundsNotice.classList.add('updated');
                    } else {
                        boundsNoticeText.innerHTML = 'The valid range will be calculated based on your floor height, rise angle, and staircase width. Please complete the previous steps first.';
                        boundsNotice.classList.remove('updated');
                    }
                }
            }
        }
    }

    updateMainStaircaseTreadCountValidation(minTreads, maxTreads) {
        const treadCountInput = document.getElementById('sc-stair-tread-count');
        if (treadCountInput) {
            treadCountInput.min = minTreads;
            treadCountInput.max = maxTreads;
            const currentValue = parseInt(treadCountInput.value) || 0;
            if (currentValue < minTreads || currentValue > maxTreads) {
                const clampedValue = this.clampTreadCountToBounds(currentValue);
                treadCountInput.value = clampedValue;
                if (clampedValue !== currentValue) {
                    this.showMainConfiguratorNotification(
                        `Tread count adjusted from ${currentValue} to ${clampedValue} to respect the valid range of ${minTreads}-${maxTreads} treads.`,
                        'info'
                    );
                }
            }
            this.updateTreadCountBoundsDisplay(treadCountInput, minTreads, maxTreads);
        }
    }

    validateInput(inputKey, value, isOnboarding = false) {
        this.log(`validateInput called: ${inputKey} = ${value}, isOnboarding: ${isOnboarding}`, 'debug');
        if (!window.PD_SC_CONTROLS) {
            this.log('PD_SC_CONTROLS is not available', 'error');
            return { isValid: true, messages: [] };
        }
        const config = window.PD_SC_CONTROLS[inputKey];
        if (!config) {
            this.log(`No validation config found for ${inputKey}`, 'warn');
            this.log(`Available validation keys: ${Object.keys(window.PD_SC_CONTROLS).join(', ')}`, 'debug');
            return { isValid: true, messages: [] };
        }
        this.log(`Found validation config for ${inputKey}:`, config, 'debug');
        if (config.type !== 'BOTH' && config.type !== this.type) {
            this.log(`Validation config type ${config.type} does not match current type ${this.type}`, 'debug');
            return { isValid: true, messages: [] };
        }
        const messages = [];
        let isValid = true;
        for (const validation of config.validations) {
            for (const rule of validation.rules) {
                let ruleValid = true;
                let message = rule.message || '';
                switch (rule.type) {
                    case 'min':
                        ruleValid = value >= rule.value;
                        break;
                    case 'max':
                        ruleValid = value <= rule.value;
                        break;
                    case 'gt':
                        ruleValid = value > rule.value;
                        if (rule.warning) {
                            if (!ruleValid) {
                                messages.push({ type: 'warning', message: rule.message });
                            }
                            ruleValid = true;
                        }
                        break;
                    case 'lt':
                        ruleValid = value < rule.value;
                        if (rule.warning) {
                            if (!ruleValid) {
                                messages.push({ type: 'warning', message: rule.message });
                            }
                            ruleValid = true;
                        }
                        break;
                    case 'range':
                        ruleValid = (value >= rule.min && value <= rule.max);
                        if (rule.warning) {
                            if (!ruleValid) {
                                messages.push({ type: 'warning', message: rule.message });
                            }
                            ruleValid = true;
                        }
                        break;
                    case 'tread-bounds':
                        ruleValid = (value >= this.treadBounds[0] && value <= this.treadBounds[1]);
                        break;
                }
                if (!ruleValid) {
                    if (!rule.warning) {
                        messages.push({ type: 'error', message: rule.message });
                        isValid = false;
                    }
                }
            }
        }
        this.log(`Validation result for ${inputKey}: isValid=${isValid}, messages=${messages.length}`, 'debug');
        return { isValid, messages };
    }

    validateAndUpdateStaircaseControl(controlType, value, forceUpdate = false) {
        if (!this.StairController || this.type !== 'STAIRCASE') {
            return false;
        }
        const numValue = controlType === 'rise_angle' ? parseFloat(value) : parseInt(value, 10);
        if (isNaN(numValue)) {
            return false;
        }
        const validationMapping = {
            'floor_height': 'staircase_floor_height',
            'rise_angle': 'staircase_rise_angle',
            'stair_width': 'staircase_width',
            'riser_count': 'staircase_tread_count'
        };
        const validationKey = validationMapping[controlType];
        if (validationKey) {
            const validation = this.validateInput(validationKey, numValue, false);
            if (!validation.isValid && !forceUpdate) {
                this.displayValidationMessages(validation.messages, false);
                return false;
            }
        }
        if (controlType === 'riser_count') {
            const boundedValue = this.clampTreadCountToBounds(numValue);
            if (boundedValue !== numValue) {
                const treadCountInput = document.getElementById('sc-stair-tread-count');
                if (treadCountInput) {
                    treadCountInput.value = boundedValue;
                }
                this.log(`Tread count adjusted from ${numValue} to ${boundedValue} to respect bounds`, 'info');
            }
            this.StairController.setInput('riser_count', boundedValue);
        } else {
            if (controlType === 'stair_width') {
                this.StairController.setInput('width', this.getEngineStairWidth(numValue));
            } else {
                this.StairController.setInput(this.getControllerParam(controlType), numValue);
            }
        }
        this.StairController.generate();
        return true;
    }

    validateAndUpdateBalustradeControl(controlType, value, forceUpdate = false) {
        if (!this.StairController || this.type !== 'BALUSTRADE') {
            return;
        }
        const numValue = parseInt(value);
        if (isNaN(numValue)) {
            return;
        }
        const validationMapping = {
            'master_angle': 'master_angle',
            'master_length': 'master_length',
            'master_aperture_height': 'master_aperture_height'
        };
        const validationKey = validationMapping[controlType];
        if (validationKey) {
            const validation = this.validateInput(validationKey, numValue, false);
            if (!validation.isValid && !forceUpdate) {
                this.displayValidationMessages(validation.messages, false);
                return;
            }
            if (validation.messages.length > 0) {
                this.displayValidationMessages(validation.messages, false);
            }
        }
        switch (controlType) {
            case 'master_angle':
                this.StairController.setInput('angle', numValue, true);
                break;
            case 'master_length':
                this.StairController.setInput('length', numValue, true);
                break;
            case 'master_aperture_height':
                this.StairController.setInput('aperture_height', numValue);
                this.StairController.setInput('post_height', numValue + 250, true);
                break;
        }
        setTimeout(() => {
            this.requestBillOfMaterialsUpdate();
        }, 100);
    }

    validateAndUpdateGlassGap(gapValue) {
        if (!this.StairController || this.type !== 'BALUSTRADE') {
            return;
        }
        const validation = this.validateInput('glass_gap', gapValue, false);
        if (!validation.isValid) {
            this.displayValidationMessages(validation.messages, false);
            return;
        }
        if (validation.messages.length > 0) {
            this.displayValidationMessages(validation.messages, false);
        }
        let finalGapValue = gapValue;
        if (gapValue < 20) finalGapValue = 20;
        if (gapValue > 90) finalGapValue = 90;
        const glassGapInput = document.getElementById('glass-gap');
        if (glassGapInput && glassGapInput.value !== finalGapValue.toString()) {
            glassGapInput.value = finalGapValue;
        }
        this.StairController.setInput('glass_gap', finalGapValue);
        this.StairController.generate();
        // Clear current BOM and request update with proper timing
        this.clearBillOfMaterials();
        setTimeout(() => {
            this.log('Requesting BOM update after configuration regeneration', 'info');
            this.requestBillOfMaterialsUpdate();
        }, 300);
        if (!this.options) {
            this.options = {};
        }
        this.options.glass_gap = finalGapValue;
    }

    wouldComponentLeaveNoCompatibleRails(componentType, componentHandle) {
        const grooveSize = this.getComponentGrooveSize(componentType, componentHandle);
        if (!grooveSize) return false;
        const hasCompatibleHandrail = this.findFirstCompatibleRail('handrail', grooveSize) !== null;
        const hasCompatibleBaserail = this.findFirstCompatibleRail('baserail', grooveSize) !== null;
        return !hasCompatibleHandrail || !hasCompatibleBaserail;
    }

    // * ================== Configurator and render Method's ==================


    ShowConfigurator() {
        this.log('Show Configurator')
        const isFromOnboarding = this.StairController && this.onboardingWizard_open === false;
        if (!isFromOnboarding) {
            this.StairController = new StairCaseController(
                this.type,
                null,
                true
            );
            this.StairController.registerCallback('onCalculateBillOfMaterials', (data) => {
                this.updateBillOfMaterials(data);
            });
            this.StairController.registerCallback('treadBoundsUpdated', (minTreads, maxTreads) => {
                this.log('Tread bounds updated callback received', minTreads, maxTreads, 'info');
                this.updateTreadCountValidation(minTreads, maxTreads);
            });
            if (this.type === 'STAIRCASE') {
                this.StairController.registerCallback('onStaircasePostToggle', () => {
                    this.log('Staircase post toggled, triggering auto-save', 'info');
                    this.debouncedAutoSave();
                });
            }
        } else {
            this.log('Preserving existing StairController from onboarding', 'info');
            this.StairController.registerCallback('onCalculateBillOfMaterials', (data) => {
                this.updateBillOfMaterials(data);
            });
            this.StairController.registerCallback('treadBoundsUpdated', (minTreads, maxTreads) => {
                this.log('Tread bounds updated callback received', minTreads, maxTreads, 'info');
                this.updateTreadCountValidation(minTreads, maxTreads);
            });
            if (this.type === 'STAIRCASE') {
                this.StairController.registerCallback('onStaircasePostToggle', () => {
                    this.log('Staircase post toggled, triggering auto-save', 'info');
                    this.debouncedAutoSave();
                });
            }
        }
        this.ShowControls()
        this.initializeControlElements();
        if (this.type === 'STAIRCASE') {
            this.log('Staircase button disabled')
            document.getElementById('sc-show-background').style.display = 'none';
            setTimeout(() => {
                this.addStaircaseControlListeners();
                // Initialize turns display for staircase
                setTimeout(() => {
                    this.initializeTurnsDisplay();
                    // Start turns monitoring for staircase
                    this.startTurnsMonitoring();
                }, 100);
            }, 100);
        } else if (this.type === 'BALUSTRADE') {
            setTimeout(() => {
                this.addBalustradeControlListeners();
                // Ensure second spindle toggle visibility matches current balustrade type
                const currentBalustradeType = this.getCurrentBalustradeType();
                const spindle2ToggleControl = document.getElementById('spindle-2-toggle-control');
                if (spindle2ToggleControl) {
                    if (currentBalustradeType === 'glass') {
                        spindle2ToggleControl.classList.add('hidden');
                    } else {
                        spindle2ToggleControl.classList.remove('hidden');
                    }
                }
            }, 100);
        }
        setTimeout(() => {
            this.log('Adding restart button listener with 100ms delay', 'debug');
            this.addRestartButtonListener();
        }, 100);
        this.initialiseBillOfMaterials();
        this.onboardingWizard.style.opacity = 0;
        this.onboardingWizard.style.display = 'none';
        this.onboardingWizard_open = false;
        const mainContent = document.getElementById('stair-configurator-primary-content');
        if (mainContent) {
            mainContent.style.display = 'flex';
            this.log('Main configurator content is now visible', 'info');
        } else {
            this.log('Main configurator content element not found', 'warn');
        }
        const savedConfigsSection = document.getElementById('saved-configurations-section');
        if (savedConfigsSection) {
            savedConfigsSection.style.display = 'block';
            this.log('Saved configurations section is now visible', 'info');
        } else {
            this.log('Saved configurations section element not found', 'warn');
        }
        this.BuildConfigurator();
        if (isFromOnboarding) {
            this.syncControlValuesAfterOnboarding();
        } else if (this.type === 'STAIRCASE') {
            // Ensure default post and string are selected when showing configurator (not from onboarding)
            this.ensureDefaultPost();
            this.ensureDefaultString();
            this.ensureDefaultRiser();
            // Ensure string is set on StairController
            if (this.StairController) {
                this.SetSelectedAssets(true);
            }
        }
        setTimeout(() => {
            this.log('Performing first render of configurator', 'info');
            this.Render();
        }, 50);
        setTimeout(() => {
            this.RenderSavedConfigurations();
        }, 150);
        setTimeout(() => {
            const billOfMaterialsSection = document.querySelector('.bill-of-materials-section');
            if (billOfMaterialsSection) {
                billOfMaterialsSection.style.display = 'block';
            }
        }, 150);
    }

    LoadDefaultOptions() {
        // TODO: Redo the default options method to pick appropriate materials at start.
        this.defaultOptions = {
            "spindle": [
                'oak-square-spindle-lacquered',
            ],
            "glass": [],
            "post": [
                '90-mm-oak-square-newel-post-unfinished',
            ],
            "rail": [
                'solid-oak-contemporary-handrail-unfinished-41',
                'solid-oak-contemporary-baserail-lacquered-41-mm'
            ],
            "step": [
                'oak-step'
            ],
            "misc": [],
            "string": [],
            "glass_gap": 20,
        }
    }

    setConfiguratorType(type) {
        if (this.type && this.type !== type) {
            this.clearHiddenConfiguration();
            // Clear turns when switching configurator types
            this.clearTurns();
            // Stop turns monitoring when switching types
            this.stopTurnsMonitoring();
        }
        this.type = type;
        this.updateURLParams({ 'configurator-pre-load': type.toLowerCase() });
        this.log(`Configurator type set to: ${type}`, 'info');
    }

    PreLoadConfigurator(configuratorType, saveId = null) {
        this.log(`Pre-loading configurator: ${configuratorType}${saveId ? ` with save ID: ${saveId}` : ''}`, 'info');
        if (!['BALUSTRADE', 'STAIRCASE'].includes(configuratorType)) {
            this.log(`Invalid configurator type: ${configuratorType}`, 'error');
            return;
        }
        if (saveId && !this.validateSaveId(saveId)) {
            this.log(`Invalid or non-existent save ID: ${saveId}`, 'warn');
            saveId = null;
        }
        this.setConfiguratorType(configuratorType);
        this.ShowConfigurator();
        if (saveId) {
            this.log(`Loading saved configuration: ${saveId}`, 'info');
            setTimeout(() => {
                this.LoadConfiguration(saveId);
            }, 300);
        } else {
            this.log('No save ID specified, attempting to load hidden configuration', 'info');
            setTimeout(() => {
                const hiddenLoaded = this.loadHiddenConfiguration();
                if (!hiddenLoaded) {
                    this.log('No hidden configuration found, populating with defaults', 'info');
                    this.PopulateComponentData();
                }
                setTimeout(() => {
                    this.log('Re-rendering configurator after populating data', 'info');
                    this.Render();
                }, 100);
            }, 500);
        }
    }

    PreLoadStaircase() {
        const manualOnlyKeys = ['rise_input_mode', 'total_rise', 'total_going', 'step_rise', 'step_going'];
        for (const [key, value] of Object.entries(this.dimensions)) {
            if (manualOnlyKeys.indexOf(key) >= 0) continue;
            const num = typeof value === 'string' && value !== '' ? parseFloat(value) : value;
            if (value !== undefined && value !== null && key !== 'rise' && !isNaN(num)) {
                if (key === 'width') {
                    this.StairController.setInput('width', this.getEngineStairWidth(num));
                } else {
                    this.StairController.setInput(key, num);
                }
            } else if (key === 'rise' && (value !== undefined && value !== null)) {
                const angleVal = parseFloat(value);
                this.StairController.setInput('angle', Number.isFinite(angleVal) ? this.roundAngleForDisplay(angleVal) : parseFloat(value));
            }
        }
        this.riseInputMode = this.dimensions.rise_input_mode || 'angle';
        const mode = this.riseInputMode;
        if (mode === 'total' && this.dimensions.total_rise != null && this.dimensions.total_going != null) {
            const totalRise = parseFloat(this.dimensions.total_rise);
            const totalGoing = parseFloat(this.dimensions.total_going);
            if (!isNaN(totalRise) && !isNaN(totalGoing) && totalGoing > 0) {
                this.setManualRiseGoingMode(true);
                this.applyManualTotalRiseAndGoing(totalRise, totalGoing);
            } else {
                this.StairController.generate();
            }
        } else if (mode === 'step' && this.dimensions.step_rise != null && this.dimensions.step_going != null) {
            const stepRise = parseFloat(this.dimensions.step_rise);
            const stepGoing = parseFloat(this.dimensions.step_going);
            if (!isNaN(stepRise) && !isNaN(stepGoing) && stepGoing > 0) {
                this.setManualRiseGoingMode(true);
                this.applyManualStepRiseAndGoing(stepRise, stepGoing);
            } else {
                this.StairController.generate();
            }
        } else {
            this.StairController.generate();
        }
        this.refreshMainStaircaseValidationWarnings();
    }

    FinaliseBalustradeLoad() {
        const angleVal = parseFloat(this.dimensions.angle);
        this.StairController.setInput('angle', Number.isFinite(angleVal) ? angleVal : parseInt(this.dimensions.angle, 10));
        this.masterAngle.value = Number.isFinite(angleVal) ? this.roundAngleForDisplay(angleVal) : this.dimensions.angle;
        this.StairController.setInput('length', parseInt(this.dimensions.width));
        this.masterLength.value = parseInt(this.dimensions.width);
        this.StairController.setInput('post_height', parseInt(this.dimensions.height) + 250);
        this.StairController.setInput('aperture_height', parseInt(this.dimensions.height), true);
        setTimeout(() => {
            this.requestBillOfMaterialsUpdate();
        }, 100);
        this.masterAppetureHeight.value = parseInt(this.dimensions.height);
    }

    FinaliseStaircaseLoad() {
        for (const [key, value] of Object.entries(this.dimensions)) {
            const numericValue = parseFloat(value);
            if (isNaN(numericValue)) continue;
            if (key === 'width') {
                this.StairController.setInput('width', this.getEngineStairWidth(numericValue));
            } else {
                this.StairController.setInput(key, numericValue);
            }
        }
        setTimeout(() => {
            this.requestBillOfMaterialsUpdate();
        }, 100);
    }

    BuildConfigurator() {
        if(!this.options) {
            this.options = this.defaultOptions;
        }
        // Ensure default post and string for staircase
        if (this.type === 'STAIRCASE') {
            this.ensureDefaultPost();
            this.ensureDefaultString();
            this.ensureDefaultRiser();
        }
        this.StairController.setSelectedOptions(
            this.options
        )
        this.updateComponentDisplays();
    }

    createTextureDisplay(textureHandle) {
        const texture = window.PD_SC_BUILDER_TEXTURES[textureHandle];
        if (!texture) return '';
        const style = texture.source_type === 'color'
            ? `background-color: ${texture.source}`
            : `background-image: url('${texture.source}')`;
        return `<div class="component-modal-option-texture" style="${style}"></div>`;
    }

    ZoomIn() {
    }


    DownloadConfiguration() {
    }

    ToggleRenderTargetClass(className, toggle = true) {
        const renderTarget = document.getElementById('sc-render-target');
        this.log(renderTarget);
        if (renderTarget && toggle) {
            renderTarget.classList.toggle(className);
        } else {
            renderTarget.classList.remove(className);
        }
    }

    Render() {
        this.log('Render external loop')
        this.log(`StairController status: ${this.StairController ? 'exists' : 'undefined'}`, 'info');
        if (this.StairController && this.StairController.generate && this.StairController.render) {
            try {
                this.log('Calling StairController.generate()', 'info');
                this.StairController.generate()
                this.log('Render internal loop')
                this.StairController.render()
                this.log('Render completed successfully', 'info');

                // Clear current BOM and request update with proper timing
                // Don't clear turns during render
                this.clearBillOfMaterials(true);
                setTimeout(() => {
                    this.log('Requesting BOM update after render completion', 'info');
                    this.requestBillOfMaterialsUpdate();
                }, 200);
            } catch (error) {
                this.log(`Error during render: ${error.message}`, 'error');
                // Even if render fails, try to update BOM
                setTimeout(() => {
                    this.log('Attempting BOM update after render error', 'warn');
                    this.requestBillOfMaterialsUpdate();
                }, 500);
            }
        } else {
            this.log('StairController not ready for rendering', 'warn');
            if (this.StairController) {
                this.log(`StairController methods: generate=${!!this.StairController.generate}, render=${!!this.StairController.render}`, 'warn');
            }
        }
    }

    // * ================== Save and load methods ==================

    validateSaveId(saveId) {
        try {
            const savedConfigs = JSON.parse(localStorage.getItem('staircrazy_saved_configurations') || '{}');
            return saveId in savedConfigs;
        } catch (error) {
            this.log(`Error validating save ID: ${error.message}`, 'error');
            return false;
        }
    }

    getAvailableSaveIds(configuratorType) {
        try {
            const savedConfigs = JSON.parse(localStorage.getItem('staircrazy_saved_configurations') || '{}');
            const availableIds = [];
            for (const [saveId, config] of Object.entries(savedConfigs)) {
                if (config.type === configuratorType) {
                    availableIds.push(saveId);
                }
            }
            return availableIds;
        } catch (error) {
            this.log(`Error getting available save IDs: ${error.message}`, 'error');
            return [];
        }
    }

    getSaveInfo(saveId) {
        try {
            const savedConfigs = JSON.parse(localStorage.getItem('staircrazy_saved_configurations') || '{}');
            const config = savedConfigs[saveId];
            if (!config) {
                return null;
            }
            return {
                id: saveId,
                type: config.type,
                name: config.name || 'Unnamed Configuration',
                created: config.created || 'Unknown',
                parameters: config.parameters || {}
            };
        } catch (error) {
            this.log(`Error getting save info: ${error.message}`, 'error');
            return null;
        }
    }

    manualSaveHiddenConfiguration() {
        this.log('Manually saving hidden configuration...', 'info');
        this.saveHiddenConfiguration();
        this.showMainConfiguratorNotification('Configuration saved manually', 'info');
    }

    saveHiddenConfiguration() {
        try {
            if (!this.StairController || !this.StairController.businessLogic) {
                this.log('Cannot save hidden configuration: StairController not ready', 'warn');
                return;
            }
            const parameters = this.StairController.businessLogic.stairCaseParameters;
            if (this.type === 'BALUSTRADE' && this.options && this.options.glass_gap !== undefined) {
                if (!parameters.inputs) {
                    parameters.inputs = {};
                }
                parameters.inputs.glass_gap = this.options.glass_gap;
            }

            // Include turns configuration if it exists
            if (this.type === 'STAIRCASE' && this.turns && this.turns.length > 0) {
                if (!parameters.turns) {
                    parameters.turns = [];
                }
                parameters.turns = [...this.turns];
                this.log(`Including turns configuration in hidden save: ${this.turns.length} turns`, 'debug');
            }

            const hiddenSaveData = {
                name: 'Auto-saved Configuration',
                type: this.type,
                parameters: parameters,
                timestamp: new Date().toISOString(),
                isHidden: true
            };
            localStorage.setItem('staircrazy_hidden_configuration', JSON.stringify(hiddenSaveData));
            this.log('Hidden configuration auto-saved', 'debug');
            this.showMainConfiguratorNotification('Auto-saved', 'info');
        } catch (error) {
            this.log('Error saving hidden configuration:', error, 'warn');
        }
    }

    loadHiddenConfiguration() {
        try {
            this.log('Attempting to load hidden configuration...', 'debug');
            const hiddenConfig = localStorage.getItem('staircrazy_hidden_configuration');
            if (!hiddenConfig) {
                this.log('No hidden configuration found', 'debug');
                return false;
            }
            const config = JSON.parse(hiddenConfig);
            this.log(`Found hidden config for type: ${config.type}, current type: ${this.type}`, 'debug');
            if (config.type !== this.type) {
                this.log('Hidden configuration type mismatch, clearing', 'debug');
                this.clearHiddenConfiguration();
                return false;
            }
            const configAge = Date.now() - new Date(config.timestamp).getTime();
            const maxAge = 24 * 60 * 60 * 1000;
            if (configAge > maxAge) {
                this.log('Hidden configuration too old, clearing', 'debug');
                this.clearHiddenConfiguration();
                return false;
            }
            this.log('Loading hidden configuration', 'info');
            this.log(`Config parameters: ${JSON.stringify(config.parameters, null, 2)}`, 'debug');
            if (config.parameters) {
                this.log('Loading parameters into StairController...', 'debug');
                if (config.parameters.inputs) {
                    this.log(`Setting inputs: ${JSON.stringify(config.parameters.inputs)}`, 'debug');
                    for (const [key, value] of Object.entries(config.parameters.inputs)) {
                        this.log(`Setting input ${key} = ${value}`, 'debug');
                        this.StairController.setInput(key, value, false);
                    }
                }
                if (config.parameters.options) {
                    this.log(`Setting options: ${JSON.stringify(config.parameters.options)}`, 'debug');
                    this.StairController.setSelectedOptions(config.parameters.options);
                }
            }
            this.StairController.generate();
            if (config.parameters && config.parameters.inputs) {
                this.log('Updating UI elements...', 'debug');
                if (this.type === 'BALUSTRADE') {
                    if (config.parameters.inputs.length && this.masterLength) {
                        this.masterLength.value = config.parameters.inputs.length;
                    }
                    if (config.parameters.inputs.angle && this.masterAngle) {
                        this.masterAngle.value = config.parameters.inputs.angle;
                    }
                    if (config.parameters.inputs.aperture_height && this.masterAppetureHeight) {
                        this.masterAppetureHeight.value = config.parameters.inputs.aperture_height;
                    }
                } else if (this.type === 'STAIRCASE') {
                    this.log('Updating staircase controls...', 'debug');
                    const floorHeightInput = document.getElementById('sc-floor-height');
                    const stairRiseInput = document.getElementById('sc-stair-rise');
                    const stairWidthInput = document.getElementById('sc-stair-width');
                    const treadCountInput = document.getElementById('sc-stair-tread-count');
                    this.log(`Floor height input found: ${!!floorHeightInput}`, 'debug');
                    this.log(`Stair rise input found: ${!!stairRiseInput}`, 'debug');
                    this.log(`Stair width input found: ${!!stairWidthInput}`, 'debug');
                    this.log(`Tread count input found: ${!!treadCountInput}`, 'debug');
                    if (floorHeightInput && config.parameters.inputs.floor_height) {
                        this.log(`Setting floor height to: ${config.parameters.inputs.floor_height}`, 'debug');
                        floorHeightInput.value = config.parameters.inputs.floor_height;
                    }
                    if (stairRiseInput && config.parameters.inputs.angle) {
                        this.log(`Setting stair rise to: ${config.parameters.inputs.angle}`, 'debug');
                        stairRiseInput.value = config.parameters.inputs.angle;
                    }
                    if (stairWidthInput && config.parameters.inputs.width) {
                        this.log(`Setting stair width to: ${config.parameters.inputs.width}`, 'debug');
                        stairWidthInput.value = this.getDisplayStairWidth(config.parameters.inputs.width);
                    }
                    if (treadCountInput && config.parameters.inputs.riser_count) {
                        this.log(`Setting tread count to: ${config.parameters.inputs.riser_count}`, 'debug');
                        treadCountInput.value = config.parameters.inputs.riser_count;
                    }
                }
                if (config.parameters.options) {
                    this.options = config.parameters.options;
                    if (this.type === 'BALUSTRADE') {
                        const hasGlass = config.parameters.options.glass && config.parameters.options.glass.length > 0;
                        const hasSpindle = config.parameters.options.spindle && config.parameters.options.spindle.length > 0;
                        if (hasGlass) {
                            const glassToggle = document.querySelector('input[name="balustrade-type"][value="glass"]');
                            if (glassToggle) {
                                glassToggle.checked = true;
                                this.handleBalustradeTypeChange('glass');
                            }
                            if (config.parameters.options.glass[0]) {
                                this.updateComponentDisplay('glass', config.parameters.options.glass[0]);
                            }
                        } else if (hasSpindle) {
                            const spindleToggle = document.querySelector('input[name="balustrade-type"][value="spindle"]');
                            if (spindleToggle) {
                                spindleToggle.checked = true;
                                this.handleBalustradeTypeChange('spindle');
                            }
                            if (config.parameters.options.spindle[0]) {
                                this.updateComponentDisplay('spindle', config.parameters.options.spindle[0]);
                            }
                            // Handle second spindle if it exists
                            if (config.parameters.options.spindle.length > 1 && config.parameters.options.spindle[1]) {
                                const secondSpindleHandle = config.parameters.options.spindle[1];
                                // Validate groove size compatibility
                                const validation = this.validateSecondSpindleGrooveSize(secondSpindleHandle);
                                if (validation.isValid) {
                                    // Enable second spindle toggle
                                    const secondSpindleToggleYes = document.querySelector('input[name="second-spindle-toggle"][value="yes"]');
                                    if (secondSpindleToggleYes) {
                                        secondSpindleToggleYes.checked = true;
                                        this.handleSecondSpindleToggleChange('yes');
                                    }
                                    // Update second spindle display
                                    this.updateComponentDisplay('spindle-2', secondSpindleHandle);
                                } else {
                                    this.log(`Second spindle ${secondSpindleHandle} is not compatible with first spindle, clearing: ${validation.message}`, 'warn');
                                    // Clear second spindle from options
                                    this.options.spindle = [this.options.spindle[0]];
                                    this.showMainConfiguratorNotification(`Second spindle was cleared: ${validation.message}`, 'warning');
                                }
                            }
                        }
                        if (config.parameters.options.post && config.parameters.options.post[0]) {
                            this.updateComponentDisplay('post', config.parameters.options.post[0]);
                        }
                        // Restore saved rails after handleBalustradeTypeChange (which may have triggered validation)
                        // This ensures rails with groove 0/false are preserved
                        if (config.parameters.options.rail) {
                            if (config.parameters.options.rail[0]) {
                                this.options.rail[0] = config.parameters.options.rail[0];
                                this.updateComponentDisplay('handrail', config.parameters.options.rail[0]);
                            }
                            if (config.parameters.options.rail[1]) {
                                this.options.rail[1] = config.parameters.options.rail[1];
                                this.updateComponentDisplay('baserail', config.parameters.options.rail[1]);
                            }
                            // Update StairController with the saved rails
                            this.StairController.setSelectedOptions(this.options);
                        }
                        if (config.parameters.options.misc) {
                            const glassClamps = config.parameters.options.misc.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'glass-clamp';
                            });
                            if (glassClamps.length > 0) {
                                this.updateComponentDisplay('glass-clamp', glassClamps[0]);
                            }

                            // Extract string material from misc array and store in separate string property
                            const stringMaterials = config.parameters.options.misc.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'string';
                            });
                            if (stringMaterials.length > 0) {
                                if (!this.options.string) {
                                    this.options.string = [];
                                }
                                this.options.string = [stringMaterials[0]];
                                this.updateComponentDisplay('string', stringMaterials[0]);
                            }

                            // Extract riser from misc array and store in separate riser property
                            const risers = config.parameters.options.misc.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'riser';
                            });
                            if (risers.length > 0) {
                                if (!this.options.riser) {
                                    this.options.riser = [];
                                }
                                this.options.riser = [risers[0]];
                                this.updateComponentDisplay('riser', risers[0]);
                            }

                            // Extract post-caps from misc array and update display
                            const postCaps = config.parameters.options.misc.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'post-cap';
                            });
                            if (postCaps.length > 0) {
                                // Check if the first post cap is compatible with the current post
                                const postCapComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[postCaps[0]];
                                const currentPostWidth = this.getCurrentPostWidth();
                                if (postCapComponent && this.isPostCapCompatibleWithPost(postCapComponent, currentPostWidth)) {
                                    this.updateComponentDisplay('post-cap', postCaps[0]);
                                } else {
                                    this.log(`Post cap ${postCaps[0]} is not compatible with current post width ${currentPostWidth}, defaulting to no-cap`);
                                    this.updateComponentDisplay('post-cap', 'no-cap');
                                }
                            } else {
                                this.updateComponentDisplay('post-cap', 'no-cap');
                            }

                            // Ensure default string is set if missing after loading options
                            if (this.type === 'STAIRCASE') {
                                this.ensureDefaultString();
                                this.ensureDefaultRiser();
                            }
                        } else if (this.type === 'STAIRCASE') {
                            // If no misc options at all, ensure default string
                            this.ensureDefaultString();
                            this.ensureDefaultRiser();
                        }

                        // Update post cap visibility after loading
                        this.updatePostCapVisibility();
                        if (config.parameters.inputs && config.parameters.inputs.glass_gap !== undefined) {
                            this.log(`Loading glass gap from hidden configuration: ${config.parameters.inputs.glass_gap}`, 'debug');
                            this.options.glass_gap = config.parameters.inputs.glass_gap;
                            setTimeout(() => {
                                const glassGapInput = document.getElementById('glass-gap');
                                if (glassGapInput) {
                                    glassGapInput.value = config.parameters.inputs.glass_gap;
                                    this.log(`Updated glass gap input field to: ${glassGapInput.value}`, 'debug');
                                    this.syncGlassGap();
                                } else {
                                    this.log('Glass gap input field not found', 'warn');
                                }
                            }, 100);
                        } else {
                            this.log('No glass gap found in hidden configuration, using default: 20', 'debug');
                            this.options.glass_gap = 20;
                        }
                    } else if (this.type === 'STAIRCASE') {
                        if (config.parameters.options.step && config.parameters.options.step[0]) {
                            this.updateComponentDisplay('step', config.parameters.options.step[0]);
                        }
                        // Restore saved rails - ensure they're preserved even if validation tried to switch them
                        if (config.parameters.options.rail) {
                            if (config.parameters.options.rail[0]) {
                                this.options.rail[0] = config.parameters.options.rail[0];
                                this.updateComponentDisplay('handrail', config.parameters.options.rail[0]);
                            }
                            if (config.parameters.options.rail[1]) {
                                this.options.rail[1] = config.parameters.options.rail[1];
                                this.updateComponentDisplay('baserail', config.parameters.options.rail[1]);
                            }
                            // Update StairController with the saved rails
                            this.StairController.setSelectedOptions(this.options);
                        }
                        if (config.parameters.options.post && config.parameters.options.post[0]) {
                            this.updateComponentDisplay('post', config.parameters.options.post[0]);
                        }
                        // Restore feature step if it exists in misc array
                        if (config.parameters.options.misc) {
                            const featureSteps = config.parameters.options.misc.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'feature-step';
                            });
                            if (featureSteps.length > 0) {
                                // Enable feature step toggle
                                const featureStepToggleYes = document.querySelector('input[name="feature-step-toggle"][value="yes"]');
                                if (featureStepToggleYes) {
                                    featureStepToggleYes.checked = true;
                                    this.handleFeatureStepToggleChange('yes');
                                }
                                // Update feature step display
                                this.updateComponentDisplay('feature-step', featureSteps[0]);
                            }
                        }

                        // Ensure default string is set if missing after loading options
                        this.ensureDefaultString();
                        this.ensureDefaultRiser();
                    }
                }

                // Load turns configuration if it exists, otherwise clear turns
                if (config.parameters.turns && Array.isArray(config.parameters.turns)) {
                    this.log(`Loading turns configuration from hidden configuration: ${config.parameters.turns.length} turns`, 'debug');

                    // Store turns locally first
                    this.turns = [...config.parameters.turns];
                    this.log(`Turns stored locally: ${JSON.stringify(this.turns)}`, 'debug');

                    // Set turns on StairController immediately
                    if (this.StairController && this.StairController.setInput) {
                        this.log(`Setting turns on StairController: ${JSON.stringify(this.turns)}`, 'debug');
                        this.setTurns(this.turns, true, true);
                        this.log(`Turns set on StairController successfully with generation triggered`, 'debug');
                    } else {
                        this.log(`StairController not available for setting turns`, 'warn');
                    }

                    // Update UI after loading turns
                    this.updateTurnsDisplay();
                } else {
                    this.log('No turns configuration found, clearing turns', 'debug');
                    this.setTurns([], false, true);

                    // Update UI after clearing turns
                    this.updateTurnsDisplay();
                }
            }
            setTimeout(() => {
                this.requestBillOfMaterialsUpdate();
            }, 100);
            if (this.type === 'STAIRCASE') {
                // Start turns monitoring for hidden configuration
                this.startTurnsMonitoring();

                setTimeout(() => {
                    this.syncStaircaseControls();
                }, 300);
            }
            if (this.type === 'BALUSTRADE' && this.options && this.options.glass_gap !== undefined) {
                setTimeout(() => {
                    this.log(`Setting final glass gap on StairController: ${this.options.glass_gap}`, 'debug');
                    this.StairController.setInput('glass_gap', this.options.glass_gap, false);
                    const currentGlassGap = this.StairController.businessLogic?.stairCaseParameters?.inputs?.glass_gap;
                    this.log(`Verification - Current glass gap on StairController: ${currentGlassGap}`, 'debug');
                    this.StairController.generate();
                    this.log('Configuration regenerated after setting glass gap', 'debug');
                    setTimeout(() => {
                        this.requestBillOfMaterialsUpdate();
                    }, 100);
                }, 200);
            }
            setTimeout(() => {
                this.log('Re-attaching control listeners after loading hidden configuration', 'debug');
                if (this.type === 'STAIRCASE') {
                    this.addStaircaseControlListeners();
                    // Ensure string is set on StairController after loading
                    if (this.StairController) {
                        this.SetSelectedAssets(true);
                    }
                } else if (this.type === 'BALUSTRADE') {
                    this.addBalustradeControlListeners();
                    if (this.options && this.options.glass_gap !== undefined) {
                        setTimeout(() => {
                            this.log('Final glass gap synchronization after listener attachment', 'debug');
                            this.syncGlassGap();
                        }, 100);
                    }
                }
            }, 300);
            this.log('Hidden configuration loaded successfully', 'info');
            this.showMainConfiguratorNotification('Previous work restored', 'info');
            return true;
        } catch (error) {
            this.log('Error loading hidden configuration:', error, 'warn');
            this.clearHiddenConfiguration();
            return false;
        }
    }

    clearHiddenConfiguration() {
        try {
            localStorage.removeItem('staircrazy_hidden_configuration');
            // Clear turns when clearing hidden configuration
            this.clearTurns();
            this.log('Hidden configuration cleared', 'debug');
        } catch (error) {
            this.log('Error clearing hidden configuration:', error, 'warn');
        }
    }

    SaveConfiguration() {
        if (!this.StairController) {
            this.log('No StairController available to save configuration', 'warn');
            this.showErrorModal('No configuration available to save. Please create a configuration first.');
            return;
        }
        this.showSaveModal();
    }
    showSaveModal() {
        const modal = document.getElementById('save-config-modal');
        const input = document.getElementById('save-config-name');
        input.value = '';
        modal.style.display = 'flex';
        setTimeout(() => {
            modal.classList.add('show');
            input.focus();
        }, 10);
    }
    closeSaveModal() {
        const modal = document.getElementById('save-config-modal');
        modal.classList.remove('show');
        setTimeout(() => {
            modal.style.display = 'none';
        }, 300);
    }
    confirmSaveConfiguration() {
        const input = document.getElementById('save-config-name');
        const name = input.value.trim();
        if (!name) {
            input.style.borderColor = '#d32f2f';
            input.focus();
            return;
        }
        try {
            const previewImg = this.StairController.ExportAsImage();
            const parameters = this.StairController.businessLogic.stairCaseParameters;
            if (this.type === 'BALUSTRADE' && this.options && this.options.glass_gap !== undefined) {
                if (!parameters.inputs) {
                    parameters.inputs = {};
                }
                parameters.inputs.glass_gap = this.options.glass_gap;
                this.log(`Including glass gap in saved configuration: ${this.options.glass_gap}`, 'info');
            } else {
                this.log(`Not including glass gap in saved configuration. Type: ${this.type}, Options: ${JSON.stringify(this.options)}`, 'info');
            }

            // Include turns configuration if it exists
            if (this.type === 'STAIRCASE' && this.turns && this.turns.length > 0) {
                if (!parameters.turns) {
                    parameters.turns = [];
                }
                parameters.turns = [...this.turns];
                this.log(`Including turns configuration in saved configuration: ${this.turns.length} turns`, 'info');
            }

            // Include rise input mode and manual going/rise for staircase (Total R&G / Step R&G)
            if (this.type === 'STAIRCASE') {
                parameters.rise_input_mode = this.riseInputMode || 'angle';
            }

            const saveData = {
                name: name,
                preview_img: previewImg,
                type: this.type,
                parameters: parameters,
                timestamp: new Date().toISOString()
            };
            let savedConfigs = JSON.parse(localStorage.getItem('staircrazy_saved_configurations') || '{}');
            const uid = 'config_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            savedConfigs[uid] = saveData;
            localStorage.setItem('staircrazy_saved_configurations', JSON.stringify(savedConfigs));
            this.RenderSavedConfigurations();
            this.updateURLParams({ 'configurator-load-save': uid });
            // Don't clear hidden configuration when saving - this preserves the current turns
            // this.clearHiddenConfiguration();
            this.showMainConfiguratorNotification('Configuration saved successfully', 'info');
            this.closeSaveModal();
            this.log('Configuration saved successfully:', uid);
        } catch (error) {
            this.log('Error saving configuration:', error, 'error');
            this.showErrorModal('Error saving configuration. Please try again.');
        }
    }
    LoadConfiguration(uid) {
        try {
            const savedConfigs = JSON.parse(localStorage.getItem('staircrazy_saved_configurations') || '{}');
            const config = savedConfigs[uid];
            if (!config) {
                this.log(`Configuration not found: ${uid}`, 'error');
                return;
            }
            if (config.type !== this.type) {
                this.setConfiguratorType(config.type);
                this.StairController = new StairCaseController(
                    this.type,
                    null,
                    true
                );
                this.StairController.registerCallback('onCalculateBillOfMaterials', (data) => {
                    this.updateBillOfMaterials(data);
                });
                this.StairController.registerCallback('treadBoundsUpdated', (minTreads, maxTreads) => {
                    this.updateTreadCountValidation(minTreads, maxTreads);
                });
                if (this.type === 'STAIRCASE') {
                    this.StairController.registerCallback('onStaircasePostToggle', () => {
                        this.log('Staircase post toggled, triggering auto-save', 'info');
                        this.debouncedAutoSave();
                    });
                }
                this.ShowControls();
            }
            this.updateURLParams({ 'configurator-load-save': uid });
            if (config.parameters) {
                this.log('Loading configuration parameters:', 'info');
                this.log(config.parameters, 'info');
                if (config.parameters.inputs) {
                    for (const [key, value] of Object.entries(config.parameters.inputs)) {
                        this.StairController.setInput(key, value, false);
                    }
                }
                // Restore manual going/rise mode for staircase (Total R&G / Step R&G)
                if (this.type === 'STAIRCASE' && config.parameters.rise_input_mode) {
                    this.riseInputMode = config.parameters.rise_input_mode;
                    if (config.parameters.rise_input_mode === 'total' || config.parameters.rise_input_mode === 'step') {
                        this.setManualRiseGoingMode(true);
                    } else {
                        this.setManualRiseGoingMode(false);
                    }
                }
                if (config.parameters.options) {
                    // Update local options to match loaded configuration (deep copy for arrays)
                    this.options = {
                        ...config.parameters.options,
                        misc: config.parameters.options.misc ? [...config.parameters.options.misc] : []
                    };
                    // Ensure default string is set if missing for staircase
                    if (this.type === 'STAIRCASE') {
                        this.ensureDefaultString();
                        this.ensureDefaultRiser();
                    }
                    // Set options on StairController after ensuring defaults
                    this.StairController.setSelectedOptions(this.options);
                } else if (this.type === 'STAIRCASE') {
                    // If no options at all, ensure defaults
                    this.ensureDefaultString();
                    this.ensureDefaultRiser();
                    if (this.options) {
                        this.StairController.setSelectedOptions(this.options);
                    }
                }
                // Load turns configuration if it exists, otherwise clear turns
                if (config.parameters.turns && Array.isArray(config.parameters.turns)) {
                    this.log(`Loading turns configuration: ${config.parameters.turns.length} turns`, 'info');
                    this.log(`Turns data: ${JSON.stringify(config.parameters.turns)}`, 'debug');

                    // Store turns temporarily to ensure they're not lost
                    const turnsToLoad = [...config.parameters.turns];

                    // Store turns locally first
                    this.turns = [...turnsToLoad];
                    this.log(`Turns stored locally: ${JSON.stringify(this.turns)}`, 'debug');

                    // Set turns on StairController immediately
                    if (this.StairController && this.StairController.setInput) {
                        this.log(`Setting turns on StairController: ${JSON.stringify(this.turns)}`, 'debug');
                        this.StairController.setInput('turns', this.turns, true); // Changed to true to trigger generation
                        this.log(`Turns set on StairController successfully with generation triggered`, 'debug');

                        // Explicitly call generate to ensure 3D model is updated
                        if (this.StairController.generate) {
                            this.log(`Calling StairController.generate() to update 3D model`, 'debug');
                            this.StairController.generate();
                            this.log(`StairController.generate() completed`, 'debug');
                        }
                    } else {
                        this.log(`StairController not available for setting turns`, 'warn');
                    }



                    // Update UI after loading turns
                    this.updateTurnsDisplay();
                } else {
                    this.log('No turns configuration found, clearing turns', 'info');
                    this.setTurns([], false, true);

                    // Force immediate UI update after clearing turns
                    this.updateTurnsDisplay();
                }
            }
            this.StairController.generate();
            this.log(`After StairController.generate(), turns: ${JSON.stringify(this.turns)}`, 'debug');



            // Clear current BOM and request update with proper timing
            // Don't clear turns when loading configuration
            this.clearBillOfMaterials(true);
            setTimeout(() => {
                this.log('Requesting BOM update after loading saved configuration', 'info');
                this.requestBillOfMaterialsUpdate();
            }, 300);
            if (config.parameters && config.parameters.inputs) {
                if (config.parameters.inputs.length && this.masterLength) {
                    this.masterLength.value = config.parameters.inputs.length;
                }
                if (config.parameters.inputs.angle && this.masterAngle) {
                    this.masterAngle.value = config.parameters.inputs.angle;
                }
                if (config.parameters.inputs.aperture_height && this.masterAppetureHeight) {
                    this.masterAppetureHeight.value = config.parameters.inputs.aperture_height;
                }
                // Restore rise input mode UI for staircase (Angle / Total R&G / Step R&G)
                if (this.type === 'STAIRCASE' && config.parameters.rise_input_mode) {
                    const mode = config.parameters.rise_input_mode;
                    const riseModeRadios = document.querySelectorAll('input[name="rise-input-mode"]');
                    riseModeRadios.forEach(radio => { radio.checked = (radio.value === mode); });
                    const panelAngle = document.getElementById('rise-mode-angle');
                    const panelTotal = document.getElementById('rise-mode-total');
                    const panelStep = document.getElementById('rise-mode-step');
                    if (panelAngle) panelAngle.style.display = (mode === 'angle' ? '' : 'none');
                    if (panelTotal) panelTotal.style.display = (mode === 'total' ? '' : 'none');
                    if (panelStep) panelStep.style.display = (mode === 'step' ? '' : 'none');
                    const inputs = config.parameters.inputs;
                    if (mode === 'total' && inputs.floor_height != null && inputs.length != null) {
                        const totalRiseEl = document.getElementById('sc-total-rise');
                        const totalGoingEl = document.getElementById('sc-total-going');
                        if (totalRiseEl) totalRiseEl.value = inputs.floor_height;
                        if (totalGoingEl) totalGoingEl.value = inputs.length;
                    } else if (mode === 'step' && inputs.riser_size != null && inputs.going != null) {
                        const stepRiseEl = document.getElementById('sc-step-rise');
                        const stepGoingEl = document.getElementById('sc-step-going');
                        if (stepRiseEl) stepRiseEl.value = inputs.riser_size;
                        if (stepGoingEl) stepGoingEl.value = inputs.going;
                    }
                }
                if (config.parameters.options) {
                    this.options = config.parameters.options;
                    if (this.type === 'BALUSTRADE') {
                        const hasGlass = config.parameters.options.glass && config.parameters.options.glass.length > 0;
                        const hasSpindle = config.parameters.options.spindle && config.parameters.options.spindle.length > 0;
                        if (hasGlass) {
                            const glassToggle = document.querySelector('input[name="balustrade-type"][value="glass"]');
                            if (glassToggle) {
                                glassToggle.checked = true;
                                this.handleBalustradeTypeChange('glass');
                            }
                            if (config.parameters.options.glass[0]) {
                                this.updateComponentDisplay('glass', config.parameters.options.glass[0]);
                            }
                            const glassGapControl = document.getElementById('glass-gap-control');
                            if (glassGapControl) {
                                glassGapControl.classList.remove('hidden');
                                this.log('Glass gap control is now visible', 'info');
                            } else {
                                this.log('Glass gap control not found', 'warn');
                            }
                        } else if (hasSpindle) {
                            const spindleToggle = document.querySelector('input[name="balustrade-type"][value="spindle"]');
                            if (spindleToggle) {
                                spindleToggle.checked = true;
                                this.handleBalustradeTypeChange('spindle');
                            }
                            if (config.parameters.options.spindle[0]) {
                                this.updateComponentDisplay('spindle', config.parameters.options.spindle[0]);
                            }
                            // Handle second spindle if it exists
                            if (config.parameters.options.spindle.length > 1 && config.parameters.options.spindle[1]) {
                                const secondSpindleHandle = config.parameters.options.spindle[1];
                                // Validate groove size compatibility
                                const validation = this.validateSecondSpindleGrooveSize(secondSpindleHandle);
                                if (validation.isValid) {
                                    // Enable second spindle toggle
                                    const secondSpindleToggleYes = document.querySelector('input[name="second-spindle-toggle"][value="yes"]');
                                    if (secondSpindleToggleYes) {
                                        secondSpindleToggleYes.checked = true;
                                        this.handleSecondSpindleToggleChange('yes');
                                    }
                                    // Update second spindle display
                                    this.updateComponentDisplay('spindle-2', secondSpindleHandle);
                                } else {
                                    this.log(`Second spindle ${secondSpindleHandle} is not compatible with first spindle, clearing: ${validation.message}`, 'warn');
                                    // Clear second spindle from options
                                    this.options.spindle = [this.options.spindle[0]];
                                    this.showMainConfiguratorNotification(`Second spindle was cleared: ${validation.message}`, 'warning');
                                }
                            }
                        }
                        if (config.parameters.options.post && config.parameters.options.post[0]) {
                            const postSelect = document.getElementById('option-post');
                            if (postSelect) {
                                postSelect.value = config.parameters.options.post[0];
                            }
                        }
                        // Restore saved rails after handleBalustradeTypeChange (which may have triggered validation)
                        // This ensures rails with groove 0/false are preserved
                        if (config.parameters.options.rail) {
                            if (config.parameters.options.rail[0]) {
                                this.options.rail[0] = config.parameters.options.rail[0];
                                this.updateComponentDisplay('handrail', config.parameters.options.rail[0]);
                            }
                            if (config.parameters.options.rail[1]) {
                                this.options.rail[1] = config.parameters.options.rail[1];
                                this.updateComponentDisplay('baserail', config.parameters.options.rail[1]);
                            }
                            // Update StairController with the saved rails
                            this.StairController.setSelectedOptions(this.options);
                        }
                        if (config.parameters.inputs && config.parameters.inputs.glass_gap !== undefined) {
                            this.log(`Loading glass gap from saved configuration: ${config.parameters.inputs.glass_gap}`, 'info');
                            this.options.glass_gap = config.parameters.inputs.glass_gap;
                            setTimeout(() => {
                                const glassGapInput = document.getElementById('glass-gap');
                                if (glassGapInput) {
                                    glassGapInput.value = config.parameters.inputs.glass_gap;
                                    this.log(`Updated glass gap input field to: ${glassGapInput.value}`, 'info');
                                } else {
                                    this.log('Glass gap input field not found', 'warn');
                                }
                            }, 100);
                        } else {
                            this.log('No glass gap found in saved configuration, using default: 20', 'info');
                            this.options.glass_gap = 20;
                            setTimeout(() => {
                                const glassGapInput = document.getElementById('glass-gap');
                                if (glassGapInput) {
                                    glassGapInput.value = '20';
                                    this.log(`Set default glass gap input field to: 20`, 'info');
                                }
                            }, 100);
                        }
                        if (config.parameters.options.glass && config.parameters.options.glass[0]) {
                            this.updateGlassClampVisibility();
                            const glassClamps = config.parameters.options.misc?.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'glass-clamp';
                            }) || [];
                            if (glassClamps.length > 0) {
                                this.updateComponentDisplay('glass-clamp', glassClamps[0]);
                            }
                        }

                        // Extract string material from misc array and store in separate string property
                        if (config.parameters.options.misc) {
                            const stringMaterials = config.parameters.options.misc.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'string';
                            });
                            if (stringMaterials.length > 0) {
                                if (!this.options.string) {
                                    this.options.string = [];
                                }
                                this.options.string = [stringMaterials[0]];
                                this.updateComponentDisplay('string', stringMaterials[0]);
                            }

                            // Extract riser from misc array and store in separate riser property
                            const risers = config.parameters.options.misc.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'riser';
                            });
                            if (risers.length > 0) {
                                if (!this.options.riser) {
                                    this.options.riser = [];
                                }
                                this.options.riser = [risers[0]];
                                this.updateComponentDisplay('riser', risers[0]);
                            }
                        }

                        // Update post cap visibility after options are loaded
                        this.updatePostCapVisibility();
                    } else {
                        if (config.parameters.options.step && config.parameters.options.step[0]) {
                            this.updateComponentDisplay('step', config.parameters.options.step[0]);
                            if (!this.options) {
                                this.options = {};
                            }
                            this.options.step = [config.parameters.options.step[0]];
                        }

                        // Extract string material from misc array and store in separate string property
                        if (config.parameters.options.misc) {
                            const stringMaterials = config.parameters.options.misc.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'string';
                            });
                            if (stringMaterials.length > 0) {
                                if (!this.options.string) {
                                    this.options.string = [];
                                }
                                this.options.string = [stringMaterials[0]];
                                this.updateComponentDisplay('string', stringMaterials[0]);
                            }

                            // Extract riser from misc array and store in separate riser property
                            const risers = config.parameters.options.misc.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'riser';
                            });
                            if (risers.length > 0) {
                                if (!this.options.riser) {
                                    this.options.riser = [];
                                }
                                this.options.riser = [risers[0]];
                                this.updateComponentDisplay('riser', risers[0]);
                            }
                            
                            // Restore feature step if it exists in misc array
                            const featureSteps = config.parameters.options.misc.filter(item => {
                                const miscComponent = window.PD_SC_BUILDER_ASSETS['misc']?.[item];
                                return miscComponent && miscComponent.sub_type === 'feature-step';
                            });
                            if (featureSteps.length > 0) {
                                // Enable feature step toggle
                                const featureStepToggleYes = document.querySelector('input[name="feature-step-toggle"][value="yes"]');
                                if (featureStepToggleYes) {
                                    featureStepToggleYes.checked = true;
                                    this.handleFeatureStepToggleChange('yes');
                                }
                                // Update feature step display
                                this.updateComponentDisplay('feature-step', featureSteps[0]);
                            }
                        }

                        // Ensure default string is set if missing after loading options
                        this.ensureDefaultString();
                        this.ensureDefaultRiser();

                        // Update staircase control inputs with loaded values
                        if (config.parameters.inputs) {
                            const floorHeightInput = document.getElementById('sc-floor-height');
                            const stairRiseInput = document.getElementById('sc-stair-rise');
                            const stairWidthInput = document.getElementById('sc-stair-width');
                            const treadCountInput = document.getElementById('sc-stair-tread-count');

                            if (floorHeightInput && config.parameters.inputs.floor_height) {
                                floorHeightInput.value = config.parameters.inputs.floor_height;
                            }
                            if (stairRiseInput && config.parameters.inputs.angle) {
                                stairRiseInput.value = config.parameters.inputs.angle;
                            }
                            if (stairWidthInput && config.parameters.inputs.width) {
                                stairWidthInput.value = this.getDisplayStairWidth(config.parameters.inputs.width);
                            }
                            if (treadCountInput && config.parameters.inputs.riser_count) {
                                treadCountInput.value = config.parameters.inputs.riser_count;
                            }
                        }
                    }
                }
            }
            if (this.type === 'BALUSTRADE' && this.options && this.options.glass_gap !== undefined) {
                this.log(`Setting final glass gap on StairController: ${this.options.glass_gap}`, 'info');
                this.StairController.setInput('glass_gap', this.options.glass_gap, false);
                const currentGlassGap = this.StairController.businessLogic?.stairCaseParameters?.inputs?.glass_gap;
                this.log(`Verification - Current glass gap on StairController: ${currentGlassGap}`, 'info');
            }
            this.StairController.generate();

            // Update turns display if this is a staircase configuration
            if (this.type === 'STAIRCASE') {
                // Start turns monitoring for loaded configuration
                this.startTurnsMonitoring();

                // Ensure string is set on StairController after loading
                if (this.StairController) {
                    this.SetSelectedAssets(true);
                }

                setTimeout(() => {
                    this.syncStaircaseControls();
                }, 500);
            }

            // Update all component displays to ensure UI is synchronized
            this.updateComponentDisplays();


            this.showMainConfiguratorNotification('Configuration loaded successfully', 'info');
            this.log('Configuration loaded successfully:', uid);
        } catch (error) {
            this.log('Error loading configuration:', error, 'error');
            alert('Error loading configuration. Please try again.');
        }
    }
    DeleteConfiguration(uid) {
        this.pendingDeleteUid = uid;
        this.showDeleteModal();
    }

    confirmRestart() {
        if (window.openLoader) {
            window.openLoader();
        }
        this.log('Restarting configurator...', 'info');
        this.showMainConfiguratorNotification('Restarting configurator...', 'info');
        this.closeRestartModal();
        this.clearHiddenConfiguration();
        // Clear turns when restarting
        this.clearTurns();
        // Stop turns monitoring when restarting
        this.stopTurnsMonitoring();
        setTimeout(() => {
            window.location.href = window.location.origin + window.location.pathname;
        }, 1000);
    }
    confirmDeleteConfiguration() {
        if (!this.pendingDeleteUid) {
            return;
        }
        try {
            const savedConfigs = JSON.parse(localStorage.getItem('staircrazy_saved_configurations') || '{}');
            delete savedConfigs[this.pendingDeleteUid];
            localStorage.setItem('staircrazy_saved_configurations', JSON.stringify(savedConfigs));
            this.RenderSavedConfigurations();
            const currentParams = new URLSearchParams(window.location.search);
            const currentSaveId = currentParams.get('configurator-load-save');
            if (currentSaveId === this.pendingDeleteUid) {
                this.updateURLParams({ 'configurator-load-save': null });
            }
            this.closeDeleteModal();
            this.showMainConfiguratorNotification('Configuration deleted successfully', 'info');
            this.log('Configuration deleted successfully:', this.pendingDeleteUid);
        } catch (error) {
            this.log('Error deleting configuration:', error, 'error');
            this.showErrorModal('Error deleting configuration. Please try again.');
        }
    }
    RenderSavedConfigurations() {
        const container = document.getElementById('saved-configurations-list');
        const section = document.getElementById('saved-configurations-section');
        if (!container || !section) return;
        if (this.onboardingWizard_open) {
            section.style.display = 'none';
            return;
        } else {
            section.style.display = 'block';
        }
        try {
            const savedConfigs = JSON.parse(localStorage.getItem('staircrazy_saved_configurations') || '{}');
            const filteredConfigs = Object.entries(savedConfigs).filter(([uid, config]) => {
                return config.type === this.type;
            });
            if (filteredConfigs.length === 0) {
                container.innerHTML = '<p style="grid-column: 1 / -1; text-align: center; color: #666;">No saved ' + this.type.toLowerCase() + ' configurations found.</p>';
                return;
            }
            container.innerHTML = '';
            filteredConfigs.forEach(([uid, config]) => {
                const configCard = document.createElement('div');
                configCard.className = 'saved-config-card';
                configCard.onclick = () => this.LoadConfiguration(uid);
                const deleteBtn = document.createElement('button');
                deleteBtn.innerHTML = 'Remove';
                deleteBtn.onclick = (e) => {
                    e.stopPropagation();
                    this.DeleteConfiguration(uid);
                };
                const previewSvg = this.convertBase64ToSvg(config.preview_img, config.name, uid);
                const configName = document.createElement('h4');
                configName.textContent = config.name;
                const configType = document.createElement('p');
                configType.textContent = config.type.charAt(0).toUpperCase() + config.type.slice(1).toLowerCase();
                const configDate = document.createElement('p');
                configDate.textContent = new Date(config.timestamp).toLocaleDateString();
                configCard.appendChild(deleteBtn);
                configCard.appendChild(previewSvg);
                configCard.appendChild(configName);
                configCard.appendChild(configType);
                configCard.appendChild(configDate);
                container.appendChild(configCard);
            });
        } catch (error) {
            this.log('Error rendering saved configurations:', error, 'error');
            container.innerHTML = '<p style="grid-column: 1 / -1; text-align: center; color: #666;">Error loading saved configurations.</p>';
        }
    }

    // ! ================== Pricing Methods ==================

    calculateCost(item, component) {
        const itemWithCost = { ...item };
        if (!component) {
            return false;
        }
        const resolvedQuantity = Number.isFinite(Number(item.quantity)) ? Number(item.quantity) : Number(component.quantity || 0);
        if (component.asset.pricing_logic === 'fixed') {
            itemWithCost.pricePerItem = component.asset.pricing_data.fixed;
            itemWithCost.totalPrice = component.asset.pricing_data.fixed * resolvedQuantity;
            itemWithCost.variantId = component.asset.product_data.variants[0].id;
            return itemWithCost;
        }
        if (component.asset.pricing_logic === 'dynamic-product') {
            let costs = this.dynamicProductCosts(component, resolvedQuantity);
            if (costs) {
                itemWithCost.pricePerItem = costs.pricePerItem;
                itemWithCost.totalPrice = costs.totalPrice;
                itemWithCost.variantId = costs.variantId;
                return itemWithCost;
            }
        }
        if (component.asset.pricing_logic === 'formula') {
            try {
                let scope = {
                    quantity: component.quantity,
                    ...component.dimensions
                }
                const cost = this.StairController.businessLogic.evaluateFormula(
                    component.asset.pricing_data.formula,
                    scope
                );
                itemWithCost.pricePerItem = cost;
                itemWithCost.totalPrice = cost * resolvedQuantity;
                itemWithCost.variantId = component.asset.product_data.variants[0].id;
                return itemWithCost;
            } catch (error) {
                this.log('Error evaluating formula:' + error.message, 'error');
                return false;
            }
        }

        return false;
    }

    dynamicProductCosts(component, quantityOverride = null) {
        let variantMap = [];
        const pricing_rules = component.asset.pricing_data.product_rules ?? false;
        const resolvedQuantity = Number.isFinite(Number(quantityOverride)) ? Number(quantityOverride) : Number(component.quantity || 0);



        if (!component.asset.product_data.variants || component.asset.product_data.variants.length === 0) {
            return false;
        }

        if (component.asset.product_data.variants.length === 1) {
            return {
                pricePerItem: component.asset.product_data.variants[0].price / 100,
                totalPrice: (component.asset.product_data.variants[0].price / 100) * resolvedQuantity,
                variantId: component.asset.product_data.variants[0].id
            };
        }

        for (const variant of component.asset.product_data.variants) {
            // Only apply pricing rules if they exist and have meaningful content
            if (true) {

                if (pricing_rules.option_1_match) {
                    if (
                        (variant.option1 || '').toLowerCase().replace(/[^a-z0-9]/gi, '') !==
                        pricing_rules.option_1_match.toLowerCase().replace(/[^a-z0-9]/gi, '')
                    ) {
                        continue;
                    }
                }
                if (pricing_rules.option_2_match) {
                    if (
                        (variant.option2 || '').toLowerCase().replace(/[^a-z0-9]/gi, '') !==
                        pricing_rules.option_2_match.toLowerCase().replace(/[^a-z0-9]/gi, '')
                    ) {
                        continue;
                    }
                }
                if (pricing_rules.option_3_match) {
                    if (
                        (variant.option3 || '').toLowerCase().replace(/[^a-z0-9]/gi, '') !==
                        pricing_rules.option_3_match.toLowerCase().replace(/[^a-z0-9]/gi, '')
                    ) {
                        continue;
                    }
                }
            }
            variantMap.push({
                variantId: variant.id,
                price: variant.price / 100,
                options: variant.options || []
            });
        }

        // Use fallback if no pricing rules exist or no variants matched
        if (variantMap.length === 0) {
            return false;
        }

        if (pricing_rules && pricing_rules.is_dynamic) {
            const dynamicOptionIndex = pricing_rules.dynamic_option - 1;
            const primaryDimension = this.getPrimaryDimension(component);
            let selectedVariant = null;
            let currentValue = false;
            for (const variant of variantMap) {
                if (!variant.options || !variant.options[dynamicOptionIndex]) continue;
                const variantValue = this.determineDynamicValue(variant.options[dynamicOptionIndex], pricing_rules.metric);
                if (typeof variantValue === 'number' && !isNaN(variantValue)) {
                    if (currentValue === false) {
                        currentValue = variantValue;
                    }
                    if (primaryDimension <= variantValue ) {
                        if (!selectedVariant) {
                            currentValue = variantValue;
                            selectedVariant = variant;
                        }
                        if (variantValue <= currentValue) {
                            currentValue = variantValue;
                            selectedVariant = variant;
                        }
                    }
                }

            }
            if (selectedVariant) {
                return {
                    pricePerItem: selectedVariant.price,
                    totalPrice: selectedVariant.price * resolvedQuantity,
                    variantId: selectedVariant.variantId
                };
            }
        } else {
            if (variantMap.length > 0) {
                return {
                    pricePerItem: variantMap[0].price,
                    totalPrice: variantMap[0].price * resolvedQuantity,
                    variantId: variantMap[0].variantId
                };
            }
        }

        this.log('No variant found for component', component, 'warn');
        return false;
    }

    determineDynamicValue(dynamicSource, metric) {
        let dynamicValue = dynamicSource.replace(/[^0-9.]/g, '');
        // Always convert value to millimetres (mm)
        if (metric === 'mm') {
            return parseFloat(dynamicValue);
        }
        if (metric === 'm') {
            return parseFloat(dynamicValue) * 1000;
        }
        if (metric === 'cm') {
            return parseFloat(dynamicValue) * 10;
        }
        // Default: treat as mm if metric is unrecognised
        return parseFloat(dynamicValue);
    }

    getPrimaryDimension(component) {
        switch (component.asset.type) {
            case 'post':
                return component.dimensions.height;
            case 'glass':
                return component.dimensions.width * component.dimensions.height;
            case 'spindle':
                return component.dimensions.height;
            case 'step':
                return component.dimensions.width;
            case 'misc':
                return component.dimensions.width;
            case 'rail':
                return component.dimensions.length;
            default:
                return component.dimensions.width ?? component.dimensions.width ?? component.dimensions.length;
        }
    }

    // ? ================== Tests ==================

    testHiddenConfiguration() {
        this.log('=== HIDDEN CONFIGURATION TEST ===', 'info');
        const hiddenConfig = localStorage.getItem('staircrazy_hidden_configuration');
        if (hiddenConfig) {
            try {
                const config = JSON.parse(hiddenConfig);
                this.log('Hidden config found:', 'info');
                this.log(`Type: ${config.type}`, 'info');
                this.log(`Timestamp: ${config.timestamp}`, 'info');
                this.log(`Parameters: ${JSON.stringify(config.parameters, null, 2)}`, 'info');
            } catch (error) {
                this.log('Error parsing hidden config:', 'error');
            }
        } else {
            this.log('No hidden configuration found', 'info');
        }
        this.log(`Current type: ${this.type}`, 'info');
        this.log(`StairController ready: ${!!this.StairController}`, 'info');
        if (this.StairController && this.StairController.businessLogic) {
            const params = this.StairController.businessLogic.stairCaseParameters;
            this.log(`Current parameters: ${JSON.stringify(params, null, 2)}`, 'info');
        }
        this.log('=== END TEST ===', 'info');
    }

    testAutoSave() {
        this.log('=== AUTO-SAVE TEST ===', 'info');
        this.log('Testing debounced auto-save...', 'info');
        this.debouncedAutoSave();
        if (!this.StairController || !this.StairController.businessLogic) {
            this.log('StairController not ready for auto-save', 'warn');
            return;
        }
        this.log('Testing manual save...', 'info');
        this.saveHiddenConfiguration();
        const hiddenConfig = localStorage.getItem('staircrazy_hidden_configuration');
        if (hiddenConfig) {
            this.log('Auto-save test successful - configuration saved', 'info');
        } else {
            this.log('Auto-save test failed - no configuration saved', 'warn');
        }
        this.log('=== END AUTO-SAVE TEST ===', 'info');
    }

    // ? ================== Helper Methods ==================

    getCurrentBalustradeType() {
        const spindleToggle = document.querySelector('input[name="balustrade-type"][value="spindle"]');
        const glassToggle = document.querySelector('input[name="balustrade-type"][value="glass"]');
        if (spindleToggle && spindleToggle.checked) {
            return 'spindle';
        } else if (glassToggle && glassToggle.checked) {
            return 'glass';
        }
        return 'spindle';
    }

    updateURLParams(params) {
        try {
            const url = new URL(window.location);
            Object.entries(params).forEach(([key, value]) => {
                if (value !== null && value !== undefined && value !== '') {
                    url.searchParams.set(key, value);
                } else {
                    url.searchParams.delete(key);
                }
            });
            window.history.replaceState({}, '', url);
            this.log(`URL updated: ${url.search}`, 'info');
        } catch (error) {
            this.log(`Error updating URL parameters: ${error.message}`, 'warn');
        }
    }

    clearCurrentConfiguration() {
        this.updateURLParams({ 'configurator-load-save': null });
        this.log('Current configuration cleared from URL', 'info');
    }

    clearCurrentConfigurationAndTurns() {
        this.updateURLParams({ 'configurator-load-save': null });
        // Clear turns when clearing current configuration
        this.clearTurns();
        this.log('Current configuration and turns cleared from URL', 'info');
    }

    getCurrentURLParams() {
        const params = new URLSearchParams(window.location.search);
        const result = {};
        for (const [key, value] of params) {
            result[key] = value;
        }
        return result;
    }

    getCurrentGrooveSize() {
        const options = this.onboardingWizard_open ? this.inProgressOptions : this.options;
        if (!options) return null;
        // Always use first spindle (index 0) for groove size compatibility with rails
        if (options.spindle && options.spindle.length > 0) {
            const spindleHandle = options.spindle[0];
            const spindle = window.PD_SC_BUILDER_ASSETS['spindle']?.[spindleHandle];
            if (spindle && spindle.dimensions2d && spindle.dimensions2d.groove) {
                return spindle.dimensions2d.groove;
            }
        }
        if (options.glass && options.glass.length > 0) {
            const glassHandle = options.glass[0];
            const glass = window.PD_SC_BUILDER_ASSETS['glass']?.[glassHandle];
            if (glass && glass.dimensions2d && glass.dimensions2d.groove) {
                return glass.dimensions2d.groove;
            }
        }
        return null;
    }

    validateSecondSpindleGrooveSize(secondSpindleHandle) {
        // Get first spindle's groove size
        const firstSpindleHandle = this.getCurrentComponentSelection('spindle');
        if (!firstSpindleHandle) {
            return {
                isValid: false,
                message: 'Please select a first spindle before selecting a second spindle'
            };
        }

        const firstSpindle = window.PD_SC_BUILDER_ASSETS['spindle']?.[firstSpindleHandle];
        if (!firstSpindle || !firstSpindle.dimensions2d || !firstSpindle.dimensions2d.groove) {
            return {
                isValid: false,
                message: 'First spindle does not have a groove size defined'
            };
        }

        const firstGrooveSize = firstSpindle.dimensions2d.groove;

        // Get second spindle's groove size
        const secondSpindle = window.PD_SC_BUILDER_ASSETS['spindle']?.[secondSpindleHandle];
        if (!secondSpindle || !secondSpindle.dimensions2d || !secondSpindle.dimensions2d.groove) {
            return {
                isValid: false,
                message: 'Second spindle does not have a groove size defined'
            };
        }

        const secondGrooveSize = secondSpindle.dimensions2d.groove;

        // Check if groove sizes match
        if (firstGrooveSize !== secondGrooveSize) {
            return {
                isValid: false,
                message: `Second spindle groove size (${secondGrooveSize}mm) does not match first spindle groove size (${firstGrooveSize}mm). Please select a spindle with a matching groove size.`
            };
        }

        return {
            isValid: true,
            message: null
        };
    }

    isRailCompatibleWithGroove(rail, grooveSize) {
        if (!rail.dimensions2d || !rail.dimensions2d.groove) {
            return false;
        }
        // Always show rails with groove 0 or false
        const railGroove = rail.dimensions2d.groove;
        if (railGroove === 0 || railGroove === false) {
            return true;
        }
        return rail.dimensions2d.groove === grooveSize;
    }

    getAvailableComponentsForType(type, sub_type = false) {
        if (type === 'string') {
            // Filter string materials from misc assets
            const miscAssets = window.PD_SC_BUILDER_ASSETS['misc'] || {};
            const availableStrings = [];
            Object.entries(miscAssets).forEach(([handle, component]) => {
                if (component.sub_type === 'string') {
                    availableStrings.push(handle);
                }
            });
            return availableStrings;
        }
        if (type !== 'rail') {
            return Object.keys(window.PD_SC_BUILDER_ASSETS[type] || {});
        }
        const availableRails = [];
        const railAssets = window.PD_SC_BUILDER_ASSETS[type] || {};
        const currentGrooveSize = this.getCurrentGrooveSize();
        this.log(`[Groove Filter] Type: ${type}, Sub-type: ${sub_type}, Current groove size: ${currentGrooveSize}mm`);
        this.log(`[Groove Filter] Total rail assets: ${Object.keys(railAssets).length}`);
        if (!currentGrooveSize) {
            Object.entries(railAssets).forEach(([handle, component]) => {
                if (component.type === sub_type) {
                    availableRails.push(handle);
                }
            });
            this.log(`[Groove Filter] No groove size set, returning all ${sub_type} rails: ${availableRails.length}`);
            return availableRails;
        }
        Object.entries(railAssets).forEach(([handle, component]) => {
            if (component.type === sub_type) {
                // Always show rails with groove 0 or false
                const railGroove = component.dimensions2d?.groove;
                if (railGroove === 0 || railGroove === false) {
                    availableRails.push(handle);
                } else if (this.isRailCompatibleWithGroove(component, currentGrooveSize)) {
                    availableRails.push(handle);
                }
            }
        });
        this.log(`[Groove Filter] Filtered ${sub_type} rails for ${currentGrooveSize}mm groove: ${availableRails.length}`);
        this.log(`[Groove Filter] Available rails: ${availableRails}`);
        return availableRails;
    }

    findFirstCompatibleRail(railType, grooveSize) {
        const railAssets = window.PD_SC_BUILDER_ASSETS['rail'] || {};
        for (const [handle, component] of Object.entries(railAssets)) {
            if (component.type === railType && this.isRailCompatibleWithGroove(component, grooveSize)) {
                return handle;
            }
        }
        return null;
    }

    getComponentGrooveSize(componentType, componentHandle) {
        const component = window.PD_SC_BUILDER_ASSETS[componentType]?.[componentHandle];
        if (component && component.dimensions2d && component.dimensions2d.groove) {
            return component.dimensions2d.groove;
        }
        return null;
    }

    getMaterialBill() {
        return this.materialBill;
    }

    getMaterialBillTotal() {
        if (!this.materialBill || Object.keys(this.materialBill).length === 0) {
            return 0;
        }
        return Object.values(this.materialBill).reduce((sum, item) => sum + (item.totalPrice || 0), 0);
    }

    getTotalBomCost() {
        return this.totalBomCost;
    }

    canPlaceOrder() {
        return this.canOrder === true;
    }

    convertBase64ToSvg(base64Url, altText, uid) {
        try {
            if (!base64Url.startsWith('data:')) {
                throw new Error('Not a valid data URL');
            }
            const base64Data = base64Url.split(',')[1];
            if (!base64Data) {
                throw new Error('Invalid base64 URL format');
            }
            const decodedString = atob(base64Data);
            if (!decodedString.includes('<svg')) {
                throw new Error('Decoded content is not SVG');
            }
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = decodedString;
            const svgElement = tempDiv.querySelector('svg');
            if (!svgElement) {
                throw new Error('No SVG element found in decoded content');
            }
            const svg = svgElement.cloneNode(true);
            svg.setAttribute('class', 'saved-config-preview-svg');
            svg.setAttribute('id', `SAVED_CONFIG_${uid}`);
            svg.setAttribute('aria-label', altText);
            svg.setAttribute('role', 'img');
            return svg;
        } catch (error) {
            this.log('Error converting base64 to SVG:', error, 'error');
            const fallbackImg = document.createElement('img');
            fallbackImg.src = base64Url;
            fallbackImg.alt = altText;
            fallbackImg.className = 'saved-config-preview-img';
            return fallbackImg;
        }
    }

    getControllerParam(controlType) {
        const paramMapping = {
            'floor_height': 'floor_height',
            'rise_angle': 'angle',
            'stair_width': 'width',
            'riser_count': 'riser_count'
        };
        return paramMapping[controlType] || controlType;
    }

    /** Convert rise and going (mm) to angle in degrees. Returns decimal angle (not rounded). */
    angleFromRiseAndGoing(rise, going) {
        if (!going || going <= 0) return null;
        const rad = Math.atan(rise / going);
        return rad * (180 / Math.PI);
    }

    /** Round angle to 3 decimal places for display/input values when decimals are allowed. */
    roundAngleForDisplay(angle) {
        return this.roundValueForDisplay(angle, 3);
    }

    roundValueForDisplay(value, decimals = 3) {
        if (value == null || typeof value !== 'number' || !Number.isFinite(value)) return value;
        const factor = Math.pow(10, decimals);
        return Math.round(value * factor) / factor;
    }

    getCurrentStringWidth() {
        if (!this.options?.string || this.options.string.length === 0) return 0;
        const selectedString = this.options.string[0];
        const stringAsset = window.PD_SC_BUILDER_ASSETS?.misc?.[selectedString];
        const dimensions = stringAsset?.dimensions2d || {};
        const parsedWidth = parseFloat(dimensions.string_width ?? dimensions.width ?? dimensions.thickness ?? 0);
        return Number.isFinite(parsedWidth) && parsedWidth > 0 ? parsedWidth : 0;
    }

    getEngineStairWidth(overallWidth) {
        const width = parseFloat(overallWidth);
        if (!Number.isFinite(width)) return overallWidth;
        const adjusted = width - (this.getCurrentStringWidth() * 2);
        return this.roundValueForDisplay(Math.max(0, adjusted), 3);
    }

    getDisplayStairWidth(engineWidth) {
        const width = parseFloat(engineWidth);
        if (!Number.isFinite(width)) return engineWidth;
        return this.roundValueForDisplay(width + (this.getCurrentStringWidth() * 2), 3);
    }

    normaliseTurnsForEngine(turns) {
        if (!Array.isArray(turns)) return [];
        return turns.map((turn) => {
            const normalisedTurn = { ...turn };
            if (normalisedTurn.width != null) {
                normalisedTurn.width = this.getEngineStairWidth(normalisedTurn.width);
            }
            return normalisedTurn;
        });
    }

    getStepRiseGoingWarningMessages(stepRise, stepGoing) {
        const messages = [];
        if (Number.isFinite(stepRise) && stepRise > 220) {
            messages.push({
                type: 'warning',
                message: 'Step rise exceeds 220mm. This may trigger a regulation breach - Please check final result for details before ordering.'
            });
        }
        if (Number.isFinite(stepGoing) && stepGoing < 220) {
            messages.push({
                type: 'warning',
                message: 'Step going is below 220mm. This may trigger a regulation breach - Please check final result for details before ordering.'
            });
        }
        return messages;
    }

    dedupeValidationMessages(messages) {
        const seen = new Set();
        return messages.filter((m) => {
            if (seen.has(m.message)) return false;
            seen.add(m.message);
            return true;
        });
    }

    getEffectiveStepRiseAndGoingForWarnings(inputs) {
        if (!inputs) return { stepRise: 0, stepGoing: 0 };
        const going = parseFloat(inputs.going);
        const riserSize = parseFloat(inputs.riser_size);
        if (Number.isFinite(going) && going > 0 && Number.isFinite(riserSize) && riserSize > 0) {
            return {
                stepRise: this.roundValueForDisplay(riserSize, 3),
                stepGoing: this.roundValueForDisplay(going, 3)
            };
        }
        return this.computeStepRiseAndGoing();
    }

    collectCurrentStaircaseValidationMessages() {
        const messages = [];
        if (this.type !== 'STAIRCASE' || !this.StairController?.businessLogic?.stairCaseParameters?.inputs) {
            return messages;
        }
        const inputs = this.StairController.businessLogic.stairCaseParameters.inputs;
        const floorHeight = parseFloat(inputs.floor_height);
        const angle = parseFloat(inputs.angle);
        const riserCount = parseInt(inputs.riser_count, 10);
        const engineWidth = parseFloat(inputs.width);
        const displayWidth = Number.isFinite(engineWidth) ? this.getDisplayStairWidth(engineWidth) : NaN;

        if (Number.isFinite(floorHeight)) {
            messages.push(...this.validateInput('staircase_floor_height', floorHeight, false).messages);
        }
        if (Number.isFinite(angle)) {
            messages.push(...this.validateInput('staircase_rise_angle', angle, false).messages);
        }
        if (Number.isFinite(displayWidth)) {
            messages.push(...this.validateInput('staircase_width', displayWidth, false).messages);
        }
        if (Number.isFinite(riserCount)) {
            messages.push(...this.validateInput('staircase_tread_count', riserCount, false).messages);
        }
        const { stepRise, stepGoing } = this.getEffectiveStepRiseAndGoingForWarnings(inputs);
        messages.push(...this.getStepRiseGoingWarningMessages(stepRise, stepGoing));
        return this.dedupeValidationMessages(messages);
    }

    clearStaircaseValidationNotifications() {
        const container = document.getElementById('configurator-notifications');
        if (!container) return;
        container.querySelectorAll('.configurator-notification--staircase-validation').forEach((el) => el.remove());
    }

    refreshMainStaircaseValidationWarnings() {
        if (this.type !== 'STAIRCASE' || this.onboardingWizard_open) return;
        this.clearStaircaseValidationNotifications();
        const messages = this.collectCurrentStaircaseValidationMessages();
        messages.forEach((msg) => {
            this.showMainConfiguratorNotification(msg.message, msg.type, { staircaseValidation: true });
        });
    }

    /** True if StairController supports manual going/rise (addConfiguration and setInput for going/riser_size). */
    supportsManualRiseGoing() {
        return this.StairController &&
            typeof this.StairController.addConfiguration === 'function' &&
            typeof this.StairController.setInput === 'function';
    }

    /** Enable or disable staircase manual going/rise mode. No-op if API not available. */
    setManualRiseGoingMode(enabled) {
        if (!this.supportsManualRiseGoing()) return;
        try {
            this.StairController.addConfiguration('staircase_manual_values', !!enabled);
            if (!enabled) {
                this.StairController.setInput('going', 0);
                this.StairController.setInput('riser_size', 0);
            }
        } catch (e) {
            this.log('setManualRiseGoingMode:', e, 'warn');
        }
    }

    /** Apply manual per-step going and riser_size (mm). Regenerates. No-op if API not available. */
    applyManualGoingAndRise(goingMm, riserSizeMm) {
        if (!this.supportsManualRiseGoing() || goingMm <= 0 || riserSizeMm <= 0) return false;
        try {
            this.StairController.addConfiguration('staircase_manual_values', true);
            this.StairController.setInput('going', goingMm, true);
            this.StairController.setInput('riser_size', riserSizeMm, true);
            this.StairController.generate();
            return true;
        } catch (e) {
            this.log('applyManualGoingAndRise:', e, 'warn');
            return false;
        }
    }

    /** Apply manual mode from total rise and total going (mm). Sets floor_height, length, going, riser_size and regenerates. */
    applyManualTotalRiseAndGoing(totalRise, totalGoing) {
        if (!this.StairController || this.type !== 'STAIRCASE') return;
        const riserCount = parseInt(this.StairController.businessLogic?.stairCaseParameters?.inputs?.riser_count, 10) || 1;
        if (riserCount <= 0 || totalGoing <= 0) return;
        const stepRise = totalRise / riserCount;
        const stepGoing = totalGoing / riserCount;
        this.StairController.setInput('floor_height', totalRise);
        this.StairController.setInput('length', totalGoing);
        if (this.applyManualGoingAndRise(stepGoing, stepRise)) {
            const angle = this.angleFromRiseAndGoing(totalRise, totalGoing);
            if (angle != null) {
                this.StairController.setInput('angle', this.roundAngleForDisplay(angle));
                const stairRiseInput = document.getElementById('sc-stair-rise');
                if (stairRiseInput) stairRiseInput.value = this.roundAngleForDisplay(angle);
            }
        } else {
            const angle = this.angleFromRiseAndGoing(totalRise, totalGoing);
            if (angle != null) this.applyAngleFromRiseAndGoing(angle);
        }
    }

    /** Apply manual mode from step rise and step going (mm). Sets floor_height, going, riser_size and regenerates. */
    applyManualStepRiseAndGoing(stepRise, stepGoing) {
        if (!this.StairController || this.type !== 'STAIRCASE') return;
        const riserCount = parseInt(this.StairController.businessLogic?.stairCaseParameters?.inputs?.riser_count, 10) || 1;
        const floorHeight = stepRise * riserCount;
        this.StairController.setInput('floor_height', floorHeight);
        const floorHeightInput = document.getElementById('sc-floor-height');
        if (floorHeightInput) floorHeightInput.value = floorHeight;
        if (this.applyManualGoingAndRise(stepGoing, stepRise)) {
            const angle = this.angleFromRiseAndGoing(stepRise, stepGoing);
            if (angle != null) {
                this.StairController.setInput('angle', this.roundAngleForDisplay(angle));
                const stairRiseInput = document.getElementById('sc-stair-rise');
                if (stairRiseInput) stairRiseInput.value = this.roundAngleForDisplay(angle);
            }
        } else {
            const angle = this.angleFromRiseAndGoing(stepRise, stepGoing);
            if (angle != null) this.applyAngleFromRiseAndGoing(angle);
        }
    }

    /** Derive total rise and going from current controller state. Returns { totalRise, totalGoing }. */
    computeTotalRiseAndGoing() {
        if (!this.StairController || this.type !== 'STAIRCASE') return { totalRise: 0, totalGoing: 0 };
        const inputs = this.StairController.businessLogic?.stairCaseParameters?.inputs;
        if (!inputs) return { totalRise: 0, totalGoing: 0 };
        const floorHeight = parseFloat(inputs.floor_height) || 0;
        const angleDeg = parseFloat(inputs.angle) || 42;
        const angleRad = angleDeg * (Math.PI / 180);
        const totalGoing = angleRad > 0 ? floorHeight / Math.tan(angleRad) : 0;
        return {
            totalRise: this.roundValueForDisplay(floorHeight, 3),
            totalGoing: this.roundValueForDisplay(totalGoing, 3)
        };
    }

    /** Derive step rise and going from current controller state. Returns { stepRise, stepGoing }. */
    computeStepRiseAndGoing() {
        if (!this.StairController || this.type !== 'STAIRCASE') return { stepRise: 0, stepGoing: 0 };
        const inputs = this.StairController.businessLogic?.stairCaseParameters?.inputs;
        if (!inputs) return { stepRise: 0, stepGoing: 0 };
        const floorHeight = parseFloat(inputs.floor_height) || 0;
        const riserCount = parseInt(inputs.riser_count, 10) || 1;
        const angleDeg = parseFloat(inputs.angle) || 42;
        const stepRise = riserCount > 0 ? floorHeight / riserCount : 0;
        const angleRad = angleDeg * (Math.PI / 180);
        const stepGoing = angleRad > 0 ? stepRise / Math.tan(angleRad) : 0;
        return {
            stepRise: this.roundValueForDisplay(stepRise, 3),
            stepGoing: this.roundValueForDisplay(stepGoing, 3)
        };
    }

    handleRiseInputModeChange(mode) {
        this.riseInputMode = mode;
        const panelAngle = document.getElementById('rise-mode-angle');
        const panelTotal = document.getElementById('rise-mode-total');
        const panelStep = document.getElementById('rise-mode-step');
        if (panelAngle) panelAngle.style.display = mode === 'angle' ? '' : 'none';
        if (panelTotal) panelTotal.style.display = mode === 'total' ? '' : 'none';
        if (panelStep) panelStep.style.display = mode === 'step' ? '' : 'none';
        if (mode === 'angle') {
            this.setManualRiseGoingMode(false);
        } else if (mode === 'total') {
            const { totalRise, totalGoing } = this.computeTotalRiseAndGoing();
            const totalRiseEl = document.getElementById('sc-total-rise');
            const totalGoingEl = document.getElementById('sc-total-going');
            if (totalRiseEl) totalRiseEl.value = totalRise;
            if (totalGoingEl) totalGoingEl.value = totalGoing;
            this.setManualRiseGoingMode(true);
            this.applyManualTotalRiseAndGoing(totalRise, totalGoing);
        } else if (mode === 'step') {
            const { stepRise, stepGoing } = this.computeStepRiseAndGoing();
            const stepRiseEl = document.getElementById('sc-step-rise');
            const stepGoingEl = document.getElementById('sc-step-going');
            if (stepRiseEl) stepRiseEl.value = stepRise;
            if (stepGoingEl) stepGoingEl.value = stepGoing;
            this.setManualRiseGoingMode(true);
            this.applyManualStepRiseAndGoing(stepRise, stepGoing);
        }
        if (this.type === 'STAIRCASE') {
            this.refreshMainStaircaseValidationWarnings();
        }
    }

    handleOnboardingRiseInputModeChange(mode) {
        const panelAngle = document.getElementById('onboarding-rise-mode-angle');
        const panelTotal = document.getElementById('onboarding-rise-mode-total');
        const panelStep = document.getElementById('onboarding-rise-mode-step');
        if (panelAngle) panelAngle.style.display = mode === 'angle' ? '' : 'none';
        if (panelTotal) panelTotal.style.display = mode === 'total' ? '' : 'none';
        if (panelStep) panelStep.style.display = mode === 'step' ? '' : 'none';
        const floorHeight = parseFloat(this.dimensions.floor_height) || 2000;
        const angleInput = document.getElementById('stair-controller-step__rise-angle-input');
        const angleDeg = angleInput ? parseFloat(angleInput.value) || 42 : 42;
        const angleRad = angleDeg * (Math.PI / 180);
        if (mode === 'total') {
            const totalGoing = angleRad > 0 ? this.roundValueForDisplay(floorHeight / Math.tan(angleRad), 3) : 0;
            const totalRiseEl = document.getElementById('stair-controller-step__total-rise-input');
            const totalGoingEl = document.getElementById('stair-controller-step__total-going-input');
            if (totalRiseEl) totalRiseEl.value = floorHeight;
            if (totalGoingEl) totalGoingEl.value = totalGoing;
        } else if (mode === 'step') {
            const riserCount = parseInt(this.dimensions.tread_count, 10) || 10;
            const stepRise = riserCount > 0 ? this.roundValueForDisplay(floorHeight / riserCount, 3) : 0;
            const stepGoing = angleRad > 0 ? this.roundValueForDisplay(stepRise / Math.tan(angleRad), 3) : 0;
            const stepRiseEl = document.getElementById('stair-controller-step__step-rise-input');
            const stepGoingEl = document.getElementById('stair-controller-step__step-going-input');
            if (stepRiseEl) stepRiseEl.value = stepRise;
            if (stepGoingEl) stepGoingEl.value = stepGoing;
        }
    }

    applyAngleFromRiseAndGoing(angle) {
        const angleVal = this.roundAngleForDisplay(angle);
        const validation = this.validateInput('staircase_rise_angle', angleVal, false);
        if (!validation.isValid) {
            this.displayValidationMessages(validation.messages, false);
            return false;
        }
        this.StairController.setInput('angle', angleVal);
        this.StairController.generate();
        const stairRiseInput = document.getElementById('sc-stair-rise');
        if (stairRiseInput) stairRiseInput.value = angleVal;
        return true;
    }

    handleTotalRiseChange(value) {
        const num = parseFloat(value);
        if (isNaN(num)) return;
        const totalGoingEl = document.getElementById('sc-total-going');
        const totalGoing = totalGoingEl ? parseFloat(totalGoingEl.value) : 0;
        this.validateAndUpdateStaircaseControl('floor_height', num);
        const floorHeightInput = document.getElementById('sc-floor-height');
        if (floorHeightInput) floorHeightInput.value = num;
        if (totalGoing > 0) {
            this.setManualRiseGoingMode(true);
            this.applyManualTotalRiseAndGoing(num, totalGoing);
        } else {
            const angle = this.angleFromRiseAndGoing(num, totalGoing);
            if (angle != null) this.applyAngleFromRiseAndGoing(angle);
        }
        this.clearCurrentConfiguration();
        this.debouncedAutoSave();
        this.refreshMainStaircaseValidationWarnings();
    }

    handleTotalGoingChange(value) {
        const num = parseFloat(value);
        if (isNaN(num) || num <= 0) return;
        const totalRiseEl = document.getElementById('sc-total-rise');
        const totalRise = totalRiseEl ? parseFloat(totalRiseEl.value) : 0;
        this.setManualRiseGoingMode(true);
        this.applyManualTotalRiseAndGoing(totalRise, num);
        this.clearCurrentConfiguration();
        this.debouncedAutoSave();
        this.refreshMainStaircaseValidationWarnings();
    }

    handleStepRiseChange(value) {
        const stepRise = parseFloat(value);
        if (isNaN(stepRise)) return;
        if (!this.StairController || this.type !== 'STAIRCASE') return;
        const riserCount = parseInt(this.StairController.businessLogic?.stairCaseParameters?.inputs?.riser_count, 10) || 1;
        const floorHeight = stepRise * riserCount;
        this.validateAndUpdateStaircaseControl('floor_height', floorHeight);
        const floorHeightInput = document.getElementById('sc-floor-height');
        if (floorHeightInput) floorHeightInput.value = floorHeight;
        const stepGoingEl = document.getElementById('sc-step-going');
        const stepGoing = stepGoingEl ? parseFloat(stepGoingEl.value) : 0;
        this.setManualRiseGoingMode(true);
        if (stepGoing > 0) {
            this.applyManualStepRiseAndGoing(stepRise, stepGoing);
        } else {
            const angle = this.angleFromRiseAndGoing(stepRise, stepGoing);
            if (angle != null) this.applyAngleFromRiseAndGoing(angle);
        }
        this.clearCurrentConfiguration();
        this.debouncedAutoSave();
        this.refreshMainStaircaseValidationWarnings();
    }

    handleStepGoingChange(value) {
        const stepGoing = parseFloat(value);
        if (isNaN(stepGoing) || stepGoing <= 0) return;
        const stepRiseEl = document.getElementById('sc-step-rise');
        const stepRise = stepRiseEl ? parseFloat(stepRiseEl.value) : 0;
        this.setManualRiseGoingMode(true);
        this.applyManualStepRiseAndGoing(stepRise, stepGoing);
        this.clearCurrentConfiguration();
        this.debouncedAutoSave();
        this.refreshMainStaircaseValidationWarnings();
    }

    getComponentGrooveSize(componentType, componentHandle) {
        const component = window.PD_SC_BUILDER_ASSETS[componentType]?.[componentHandle];
        if (component && component.dimensions2d && component.dimensions2d.groove) {
            return component.dimensions2d.groove;
        }
        return null;
    }

    // ~~~ Debouncing ~~~
    debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    debouncedAutoSave = this.debounce(() => {
        this.log('Auto-save triggered by debounced function', 'debug');
        this.saveHiddenConfiguration();
    }, 2000);

    // ! ========== Debug Methods ===========

    debugRefreshOnboarding() {
        this.log('[Debug] Manually refreshing onboarding component options...');
        this.log('[Debug] Current inProgressOptions:', this.inProgressOptions);
        this.log('[Debug] Current groove size:', this.getCurrentGrooveSize());
        this.refreshOnboardingComponentOptions();
    }

    debugGrooveFiltering() {
        this.log('=== GROOVE FILTERING DEBUG ===');
        this.log('Current step:', this.currentStep);
        this.log('Onboarding open:', this.onboardingWizard_open);
        this.log('In progress options:', this.inProgressOptions);
        this.log('Current groove size:', this.getCurrentGrooveSize());
        if (this.onboardingWizard_open) {
            const handrailOptions = document.querySelector('#stair-controller-step__handrail-type-input-options');
            const baserailOptions = document.querySelector('#stair-controller-step__baserail-type-input-options');
            this.log('Handrail options container:', handrailOptions);
            this.log('Baserail options container:', baserailOptions);
            if (handrailOptions) {
                const handrailComponents = handrailOptions.querySelectorAll('.stair-configurator-component-option');
                this.log('Handrail components found:', handrailComponents.length);
                handrailComponents.forEach((comp, index) => {
                    const handle = comp.getAttribute('data-component-handle');
                    const rail = window.PD_SC_BUILDER_ASSETS['rail']?.[handle];
                    this.log(`Handrail ${index + 1}: ${handle}, groove: ${rail?.dimensions2d?.groove}mm`);
                });
            }
            if (baserailOptions) {
                const baserailComponents = baserailOptions.querySelectorAll('.stair-configurator-component-option');
                this.log('Baserail components found:', baserailComponents.length);
                baserailComponents.forEach((comp, index) => {
                    const handle = comp.getAttribute('data-component-handle');
                    const rail = window.PD_SC_BUILDER_ASSETS['rail']?.[handle];
                    this.log(`Baserail ${index + 1}: ${handle}, groove: ${rail?.dimensions2d?.groove}mm`);
                });
            }
        }
        this.log('=== END DEBUG ===');
    }

    // ! <><><><><> EXPERIMENTAL METHODS <><><><><>

    // ! Turns Update:
    setTurns(turns, regenerate = true, preserveTurns = false) {
        if (!this.StairController || this.type !== 'STAIRCASE') {
            this.log('Cannot set turns: StairController not available or not staircase type', 'warn');
            return false;
        }

        // Check turn count limit
        if (turns.length > 3) {
            this.log(`Cannot set turns: maximum of 3 turns allowed, got ${turns.length}`, 'error');
            this.showMainConfiguratorNotification('Maximum of 3 turns allowed', 'error');
            return false;
        }

        // Validate turns data
        const validation = this.validateTurns(turns);
        if (!validation.isValid) {
            this.log(`Turn validation failed: ${validation.messages.join(', ')}`, 'error');
            this.showMainConfiguratorNotification(`Turn validation failed: ${validation.messages.join(', ')}`, 'error');
            return false;
        }

        // Check if turns exceed available treads (subtract 1 from riser_count for available treads)
        const treadCount = (this.StairController.businessLogic?.stairCaseParameters?.inputs?.riser_count || 0) - 1;
        const totalTreadsUsed = this.calculateTotalTreadsUsed(turns);

        if (totalTreadsUsed > treadCount) {
            const message = `Total treads used by turns (${totalTreadsUsed}) exceeds available treads (${treadCount})`;
            this.log(message, 'error');
            this.showMainConfiguratorNotification(message, 'error');
            return false;
        }

        // Store turns locally
        this.turns = [...turns];
        this.log(`Turns stored locally: ${JSON.stringify(this.turns)}`, 'debug');

        // Set turns on StairController
        try {
            const engineTurns = this.normaliseTurnsForEngine(turns);
            this.log(`Calling StairController.setInput('turns', ${JSON.stringify(engineTurns)}, ${regenerate})`, 'debug');
            this.StairController.setInput('turns', engineTurns, regenerate);
            this.log(`Turns set successfully: ${turns.length} turns configured`, 'info');
            this.log(`After StairController.setInput, turns: ${JSON.stringify(this.turns)}`, 'debug');

            if (regenerate) {
                this.log(`Before generateStaircase(), turns: ${JSON.stringify(this.turns)}`, 'debug');
                this.generateStaircase();
                this.log(`After generateStaircase(), turns: ${JSON.stringify(this.turns)}`, 'debug');
            }

            return true;
        } catch (error) {
            this.log(`Error setting turns on StairController: ${error.message}`, 'error');
            this.showMainConfiguratorNotification(`Error setting turns: ${error.message}`, 'error');
            return false;
        }
    }

    validateTurns(turns) {
        if (!Array.isArray(turns)) {
            return { isValid: false, messages: ['Turns must be an array'] };
        }

        const messages = [];
        let isValid = true;

        for (let i = 0; i < turns.length; i++) {
            const turn = turns[i];

            // Check required properties
            if (!turn.turn_type || !turn.turn_direction || !turn.treads_before_turn || !turn.width) {
                messages.push(`Turn ${i + 1}: Missing required properties (turn_type, turn_direction, treads_before_turn, width)`);
                isValid = false;
                continue;
            }

            // Validate turn type
            const validTypes = ['TRIPLE_WINDER', 'HALF_LANDING', 'QUARTER_LANDING'];
            if (!validTypes.includes(turn.turn_type)) {
                messages.push(`Turn ${i + 1}: Invalid turn type. Must be one of: ${validTypes.join(', ')}`);
                isValid = false;
            }

            // Validate direction
            const validDirections = ['LEFT', 'RIGHT'];
            if (!validDirections.includes(turn.turn_direction)) {
                messages.push(`Turn ${i + 1}: Invalid direction. Must be LEFT or RIGHT`);
                isValid = false;
            }

            // Validate width
            if (typeof turn.width !== 'number' || turn.width < 350) {
                messages.push(`Turn ${i + 1}: Width must be a number greater than or equal to 350mm`);
                isValid = false;
            }

            // Validate treads before turn
            if (typeof turn.treads_before_turn !== 'number' || turn.treads_before_turn < 0) {
                messages.push(`Turn ${i + 1}: Treads before turn must be a non-negative number`);
                isValid = false;
            }
        }

        return { isValid, messages };
    }

    calculateTotalTreadsUsed(turns) {
        if (!Array.isArray(turns)) return 0;

        return turns.reduce((total, turn) => {
            let treadsForTurn = turn.treads_before_turn;

            // Add additional treads based on turn type
            switch (turn.turn_type) {
                case 'TRIPLE_WINDER':
                    treadsForTurn += 3; // Total of 3 treads
                    break;
                case 'HALF_LANDING':
                    treadsForTurn += 1; // Total of 1 tread
                    break;
                case 'QUARTER_LANDING':
                    treadsForTurn += 1; // Total of 1 tread
                    break;
            }

            return total + treadsForTurn;
        }, 0);
    }

    getTurns() {
        return [...this.turns];
    }

    addTurn(turn) {
        if (this.turns.length >= 3) {
            this.log('Cannot add turn: maximum of 3 turns allowed', 'warn');
            this.showMainConfiguratorNotification('Maximum of 3 turns allowed', 'warning');
            return false;
        }

        // Clear current configuration when adding turns
        this.clearCurrentConfiguration();

        // Clear posts when adding turns
        if (this.StairController && typeof this.StairController.clearPosts === 'function') {
            this.StairController.clearPosts();
            this.log('Posts cleared after adding turn', 'info');
            this.showMainConfiguratorNotification('Post placements have been reset due to turn adjustment', 'info');
        }

        const newTurns = [...this.turns, turn];
        const result = this.setTurns(newTurns, true);

        // Trigger auto-save after adding turns
        this.debouncedAutoSave();

        return result;
    }

    updateTurn(index, turn) {
        if (index < 0 || index >= this.turns.length) {
            this.log(`Invalid turn index: ${index}`, 'error');
            return false;
        }

        // Clear current configuration when updating turns
        this.clearCurrentConfiguration();

        const newTurns = [...this.turns];
        newTurns[index] = turn;
        const result = this.setTurns(newTurns, true);

        // Trigger auto-save after updating turns
        this.debouncedAutoSave();

        return result;
    }

    removeTurn(index) {
        if (index < 0 || index >= this.turns.length) {
            this.log(`Invalid turn index: ${index}`, 'error');
            return false;
        }

        // Clear current configuration when removing turns
        this.clearCurrentConfiguration();

        // Clear posts when removing turns
        if (this.StairController && typeof this.StairController.clearPosts === 'function') {
            this.StairController.clearPosts();
            this.log('Posts cleared after removing turn', 'info');
            this.showMainConfiguratorNotification('Post placements have been reset due to turn adjustment', 'info');
        }

        const newTurns = this.turns.filter((_, i) => i !== index);
        const result = this.setTurns(newTurns, true);

        // Trigger auto-save after removing turns
        this.debouncedAutoSave();

        return result;
    }

    getAvailableTreadsForTurns() {
        if (!this.StairController || this.type !== 'STAIRCASE') {
            return 0;
        }

        const treadCount = (this.StairController.businessLogic?.stairCaseParameters?.inputs?.riser_count || 0) - 1;
        const totalTreadsUsed = this.calculateTotalTreadsUsed(this.turns);
        return Math.max(0, treadCount - totalTreadsUsed);
    }

    generateStaircase() {
        if (this.StairController && this.StairController.generate) {
            this.StairController.generate();
        }
    }

    updateAvailableTreadsDisplay(totalTreads, usedTreads) {
        const availableTreads = totalTreads - usedTreads;

        // Update any UI elements that show available treads
        const availableTreadsElements = document.querySelectorAll('.available-treads-display');
        availableTreadsElements.forEach(element => {
            element.textContent = `Available treads for turns: ${availableTreads}`;
            element.className = `available-treads-display ${availableTreads < 0 ? 'error' : 'info'}`;
        });

        this.log(`Updated available treads display: ${availableTreads} treads available out of ${totalTreads}`, 'info');
    }

    clearTurns() {
        return this.setTurns([], true);
    }

    getTurnStatistics() {
        const totalTreads = (this.StairController.businessLogic?.stairCaseParameters?.inputs?.riser_count || 0) - 1;
        const totalTreadsUsed = this.calculateTotalTreadsUsed(this.turns);
        const availableTreads = Math.max(0, totalTreads - totalTreadsUsed);

        return {
            totalTurns: this.turns.length,
            totalTreads,
            totalTreadsUsed,
            availableTreads,
            turns: this.turns.map((turn, index) => ({
                index,
                type: turn.turn_type,
                direction: turn.turn_direction,
                width: turn.width,
                treadsBefore: turn.treads_before_turn,
                treadsUsed: this.getTreadsUsedByTurn(turn)
            }))
        };
    }

    getTreadsUsedByTurn(turn) {
        let treadsUsed = 1; // Base tread

        switch (turn.turn_type) {
            case 'TRIPLE_WINDER':
                treadsUsed += 2; // Total of 3 treads
                break;
            case 'HALF_LANDING':
            case 'QUARTER_LANDING':
                treadsUsed += 0; // Total of 1 tread
                break;
        }

        return treadsUsed;
    }

    // ! Turns UI Management Methods
    initializeTurnsDisplay() {
        if (this.type !== 'STAIRCASE') return;

        this.updateAvailableTreadsDisplay();
        this.updateTurnsList();
        this.updateTurnStatistics();
        this.updateAddTurnButtonVisibility();
    }

    updateAvailableTreadsDisplay() {
        if (this.type !== 'STAIRCASE') return;

        const availableTreads = this.getAvailableTreadsForTurns();
        const element = document.getElementById('available-treads-count');
        if (element) {
            element.textContent = availableTreads;
        }

        // Update the display class based on available treads
        const displayElement = document.querySelector('.available-treads-display');
        if (displayElement) {
            if (availableTreads < 0) {
                displayElement.className = 'available-treads-display error';
            } else {
                displayElement.className = 'available-treads-display info';
            }
        }
    }

    updateTurnsList() {
        if (this.type !== 'STAIRCASE') return;

        const turns = this.getTurns();
        this.log(`updateTurnsList called with ${turns.length} turns`, 'debug');

        const turnsList = document.getElementById('turns-list');

        if (!turnsList) {
            this.log(`turns-list element not found`, 'warn');
            return;
        }

        this.log(`Clearing turns list and updating with ${turns.length} turns`, 'debug');
        turnsList.innerHTML = '';

        if (turns.length === 0) {
            turnsList.innerHTML = '<p>No turns configured</p>';
            this.log(`Displayed 'No turns configured' message`, 'debug');
            return;
        }

        turns.forEach((turn, index) => {
            this.log(`Creating turn item ${index + 1}: ${turn.turn_type} - ${turn.turn_direction}`, 'debug');

            const turnItem = document.createElement('div');
            turnItem.className = 'turn-item';

            const turnInfo = document.createElement('div');
            turnInfo.className = 'turn-info';
            turnInfo.innerHTML = `
                <strong>${turn.turn_type.replace('_', ' ')}</strong> - 
                ${turn.turn_direction} - 
                Width: ${turn.width}mm - 
                Treads before: ${turn.treads_before_turn}
            `;

            const turnActions = document.createElement('div');
            turnActions.className = 'turn-actions';
            turnActions.innerHTML = `
                <button class="edit-turn-btn" onclick="window.ConfiguratorController.editTurn(${index})">Edit</button>
                <button class="remove-turn-btn" onclick="window.ConfiguratorController.showRemoveTurnModal(${index})">Remove</button>
            `;

            turnItem.appendChild(turnInfo);
            turnItem.appendChild(turnActions);
            turnsList.appendChild(turnItem);

            this.log(`Turn item ${index + 1} added to DOM`, 'debug');
        });

        this.log(`Turns list updated with ${turns.length} items`, 'debug');

        // Update add-turn button visibility based on turn count
        this.updateAddTurnButtonVisibility();
    }

    updateTurnStatistics() {
        if (this.type !== 'STAIRCASE') return;

        const stats = this.getTurnStatistics();
        const statsDisplay = document.getElementById('turn-stats-display');

        if (!statsDisplay) return;

        statsDisplay.innerHTML = `
            <p><strong>Total Turns:</strong> ${stats.totalTurns}</p>
            <p><strong>Total Treads:</strong> ${stats.totalTreads}</p>
            <p><strong>Treads Used by Turns:</strong> ${stats.totalTreadsUsed}</p>
            <p><strong>Available Treads:</strong> ${stats.availableTreads}</p>
        `;
    }

    updateTurnsDisplay() {
        this.log(`updateTurnsDisplay called. Current turns: ${JSON.stringify(this.turns)}`, 'debug');

        this.updateAvailableTreadsDisplay();
        this.updateTurnsList();
        this.updateTurnStatistics();
        this.updateAddTurnButtonVisibility();

        this.log(`updateTurnsDisplay completed`, 'debug');
    }

    updateAddTurnButtonVisibility() {
        if (this.type !== 'STAIRCASE') return;

        const addTurnButton = document.querySelector('.add-turn-btn');
        if (addTurnButton) {
            if (this.turns.length >= 3) {
                addTurnButton.style.display = 'none';
                addTurnButton.disabled = true;
            } else {
                addTurnButton.style.display = 'block';
                addTurnButton.disabled = false;
            }
        }
    }

    restoreTurnsFromSavedConfiguration(loadSaveId) {
        try {
            this.log(`Attempting to restore turns from saved configuration: ${loadSaveId}`, 'info');
            const savedConfigs = JSON.parse(localStorage.getItem('staircrazy_saved_configurations') || '{}');
            const config = savedConfigs[loadSaveId];

                            if (config && config.parameters && config.parameters.turns && Array.isArray(config.parameters.turns)) {
                    this.log(`Found turns in saved configuration: ${config.parameters.turns.length} turns`, 'info');
                    this.turns = [...config.parameters.turns];
                    this.log(`Turns restored: ${JSON.stringify(this.turns)}`, 'debug');

                    // Set turns on StairController immediately
                    if (this.StairController && this.StairController.setInput) {
                        this.log(`Setting turns on StairController during restoration: ${JSON.stringify(this.turns)}`, 'debug');
                        this.StairController.setInput('turns', this.turns, true); // Changed to true to trigger generation
                        this.log(`Turns set on StairController during restoration successfully with generation triggered`, 'debug');
                    } else {
                        this.log(`StairController not available for setting turns during restoration`, 'warn');
                    }

                    // Update the display immediately
                    this.updateTurnsDisplay();

                    return true;
            } else {
                this.log(`No turns found in saved configuration: ${loadSaveId}`, 'warn');
                return false;
            }
        } catch (error) {
            this.log(`Error restoring turns from saved configuration: ${error.message}`, 'error');
            return false;
        }
    }

    // Monitor and auto-restore turns if they're missing
    monitorAndRestoreTurns() {
        if (this.type !== 'STAIRCASE') return;

        // Check if we should have turns but they're missing
        const urlParams = new URLSearchParams(window.location.search);
        const loadSaveId = urlParams.get('configurator-load-save');

        if (loadSaveId && this.turns.length === 0) {
            this.log(`Turns monitor: turns are missing but configurator-load-save is set. Attempting restoration.`, 'warn');
            this.restoreTurnsFromSavedConfiguration(loadSaveId);
        }
    }



    // Set up periodic monitoring of turns
    startTurnsMonitoring() {
        if (this.type !== 'STAIRCASE') return;

        this.log('Starting turns monitoring', 'info');

        // Check immediately
        this.monitorAndRestoreTurns();

        // Set up periodic monitoring every 2 seconds
        this.turnsMonitoringInterval = setInterval(() => {
            this.monitorAndRestoreTurns();
        }, 2000);
    }

    // Stop turns monitoring
    stopTurnsMonitoring() {
        if (this.turnsMonitoringInterval) {
            clearInterval(this.turnsMonitoringInterval);
            this.turnsMonitoringInterval = null;
            this.log('Stopped turns monitoring', 'info');
        }
    }

    // Force a complete refresh of the turns display
    forceTurnsDisplayRefresh() {
        if (this.type !== 'STAIRCASE') return;

        this.log(`Force refreshing turns display. Current turns: ${JSON.stringify(this.turns)}`, 'info');

        // Force update all turns-related UI elements
        this.updateAvailableTreadsDisplay();
        this.updateTurnsList();
        this.updateTurnStatistics();
        this.updateAddTurnButtonVisibility();

        this.log(`Force refresh completed`, 'debug');
    }



    // ! Turn Modal Management
    showTurnModal(turnIndex = -1) {
        this.currentTurnIndex = turnIndex;
        this.resetTurnForm();

        if (turnIndex >= 0) {
            // Editing existing turn
            const turns = this.getTurns();
            if (turnIndex < turns.length) {
                const turn = turns[turnIndex];
                document.getElementById('turn-type').value = turn.turn_type;
                document.getElementById('turn-direction').value = turn.turn_direction;
                document.getElementById('turn-width').value = turn.width;
                document.getElementById('turn-treads-before').value = turn.treads_before_turn;
            }
        }

        // Add event listener for turn type change to show notice for Half landing
        const turnTypeSelect = document.getElementById('turn-type');
        if (turnTypeSelect) {
            // Remove existing listener if any
            turnTypeSelect.removeEventListener('change', this.handleTurnTypeChange);
            // Add new listener
            this.handleTurnTypeChange = (e) => {
                if (e.target.value === 'HALF_LANDING') {
                    this.showMainConfiguratorNotification('Please note: The landing is not provided as part of the order', 'info');
                }
            };
            turnTypeSelect.addEventListener('change', this.handleTurnTypeChange);
        }

        const modal = document.getElementById('turn-form-modal');
        modal.style.display = 'flex';
        setTimeout(() => {
            modal.classList.add('show');
        }, 10);
    }

    closeTurnModal() {
        const modal = document.getElementById('turn-form-modal');
        modal.classList.remove('show');
        setTimeout(() => {
            modal.style.display = 'none';
        }, 300);
        this.currentTurnIndex = -1;
    }

    resetTurnForm() {
        document.getElementById('turn-type').value = 'TRIPLE_WINDER';
        document.getElementById('turn-direction').value = 'RIGHT';
        document.getElementById('turn-width').value = '600';
        document.getElementById('turn-treads-before').value = '1';
    }

    addNewTurn() {
        this.showTurnModal();
    }

    editTurn(index) {
        this.showTurnModal(index);
    }

    showRemoveTurnModal(index) {
        this.pendingDeleteTurnIndex = index;
        const modal = document.getElementById('remove-turn-modal');
        modal.style.display = 'flex';
        setTimeout(() => {
            modal.classList.add('show');
        }, 10);
    }

    closeRemoveTurnModal() {
        const modal = document.getElementById('remove-turn-modal');
        modal.classList.remove('show');
        setTimeout(() => {
            modal.style.display = 'none';
        }, 300);
        this.pendingDeleteTurnIndex = null;
    }

    confirmRemoveTurn() {
        if (this.pendingDeleteTurnIndex !== null) {
            const success = this.removeTurn(this.pendingDeleteTurnIndex);
            if (success) {
                this.closeRemoveTurnModal();
                setTimeout(() => {
                    this.updateTurnsDisplay();
                }, 100);
            }
        }
    }

    handleTurnFormSubmission() {
        const turnData = {
            turn_type: document.getElementById('turn-type').value,
            turn_direction: document.getElementById('turn-direction').value,
            width: parseFloat(document.getElementById('turn-width').value),
            treads_before_turn: parseInt(document.getElementById('turn-treads-before').value)
        };

        let success = false;

        if (this.currentTurnIndex === -1) {
            // Adding new turn
            success = this.addTurn(turnData);
        } else {
            // Updating existing turn
            success = this.updateTurn(this.currentTurnIndex, turnData);
        }

        if (success) {
            // Show notice for Half landing turn selection
            if (turnData.turn_type === 'HALF_LANDING') {
                this.showMainConfiguratorNotification('Please note: The landing is not provided as part of the order', 'info');
            }

            this.closeTurnModal();
            setTimeout(() => {
                this.updateTurnsDisplay();
            }, 100);
        }
    }

    // ! UNSORTED METHODS:


}
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() {
            window.ConfiguratorController = new ConfiguratorController();
        }, 3000);
    });
})();